var SHTHelper = window.SHTHelper || {},
    TRAP_FOCUS_HANDLERS = {};
(SHTHelper.fetchConfigHTTP = {
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
}),
    (SHTHelper.fetchConfigJSON = {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
    }),
    (SHTHelper.debounce = function (t, s) {
        let i = null;
        return function (e) {
            clearTimeout(i),
                (i = null),
                (i = setTimeout(function () {
                    t.call(this, e);
                }, s));
        };
    }),
    (SHTHelper.removeTrapFocus = function (e = null) {
        document.removeEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            document.removeEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown),
            e && e.focus();
    }),
    (SHTHelper.trapFocus = function (t, e = t) {
        var s = SHTHelper.qs(".js-header-logo-link"),
            i = t.querySelectorAll(
                `a[href]:not([disabled]), [tabindex]:not([tabindex^='-']), summary, button:not([disabled]), textarea:not([disabled]), input:not([type=hidden]):enabled, input[type="text"]:not([disabled]), object, iframe, input[type="search"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])`
            );
        let n = i[0],
            r = i[i.length - 1];
        1 === i.length && s && (r = s);
        SHTHelper.removeTrapFocus(),
            (TRAP_FOCUS_HANDLERS.focusin = (e) => {
                (e.target !== t && e.target !== r && e.target !== n) ||
                    document.addEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.focusout = function () {
                document.removeEventListener("keydown", TRAP_FOCUS_HANDLERS.keydown);
            }),
            (TRAP_FOCUS_HANDLERS.keydown = function (e) {
                ("Tab" !== e.key && 9 !== e.keyCode) ||
                    (e.shiftKey
                        ? (e.target !== t && e.target !== n) || (r.focus(), e.preventDefault())
                        : e.target === r && (n.focus(), e.preventDefault()));
            }),
            document.addEventListener("focusout", TRAP_FOCUS_HANDLERS.focusout),
            document.addEventListener("focusin", TRAP_FOCUS_HANDLERS.focusin),
            e.focus();
    }),
    (SHTHelper.isColor = function (e) {
        var t = new Option().style;
        return (t.color = e), t.color == e;
    }),
    (SHTHelper.isHexColor = function (e) {
        return /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/.test(e);
    }),
    (SHTHelper.isImage = function (e) {
        return /(\/\/)([^\s(["<,>/]*)(\/)[^\s[",><]*(.png|.jpg|.webp|.heic|.gif|.svg)(\?[^\s[",><]*)?/gi.test(e);
    }),
    (SHTHelper.preventStickyHeaderReveal = function () {
        var e = SHTHelper.qs("sht-sticky-header");
        e && e.dispatchEvent(new Event("preventStickyHeaderReveal"));
    }),
    (SHTHelper.formatMoney = function (e, t = "") {
        "string" == typeof e && (e = e.replace(".", ""));
        var s = /\{\{\s*(\w+)\s*\}\}/,
            t = t || window.theme_variables.settings.money_format;
        let i = "";
        switch (t.match(s)[1]) {
            case "amount":
                i = SHTHelper.formatWithDelimiters(e, 2);
                break;
            case "amount_no_decimals":
                i = SHTHelper.formatWithDelimiters(e, 0);
                break;
            case "amount_with_space_separator":
                i = SHTHelper.formatWithDelimiters(e, 2, " ", ".");
                break;
            case "amount_with_comma_separator":
                i = SHTHelper.formatWithDelimiters(e, 2, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = SHTHelper.formatWithDelimiters(e, 2, "'", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = SHTHelper.formatWithDelimiters(e, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                i = SHTHelper.formatWithDelimiters(e, 0, " ");
                break;
            case "amount_no_decimals_with_apostrophe_separator":
                i = SHTHelper.formatWithDelimiters(e, 0, "'");
        }
        return t.indexOf("with_comma_separator"), t.replace(s, i);
    }),
    (SHTHelper.defaultTo = function (e, t) {
        return null == e || e != e ? t : e;
    }),
    (SHTHelper.formatWithDelimiters = function (e, t, s, i) {
        return (
            (t = SHTHelper.defaultTo(t, 2)),
            (s = SHTHelper.defaultTo(s, ",")),
            (i = SHTHelper.defaultTo(i, ".")),
            isNaN(e) || null == e
                ? 0
                : (t = (e = (e / 100).toFixed(t)).split("."))[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + s) +
                  (t[1] ? i + t[1] : "")
        );
    }),
    (SHTHelper.loadScript = function (e, t, s) {
        var i;
        SHTHelper.qs("#" + e)
            ? s()
            : ((i = document.createElement("script")).setAttribute("src", "" + t),
              i.setAttribute("id", "" + e),
              (i.onload = function () {
                  s();
              }),
              (i.onreadystatechange = function () {
                  ("complete" != this.readyState && "loaded" != this.readyState) || s();
              }),
              (i.onerror = function (e) {
                  console.log("Failed to load script file " + t, e), s();
              }),
              document.body.appendChild(i));
    }),
    (SHTHelper.forceUpdateCartStatus = function (e) {
        let t = [
                {
                    section: "cart-drawer",
                    selector: ".js-cart-drawer-wrapper",
                    space_selector: ".js-cart-drawer-wrapper",
                },
                {
                    section: "header-cart-status",
                    space_selector: ".shopify-section",
                    selector: "#headerCartStatus",
                    cart_notification: !1,
                },
                {
                    section: "main-cart",
                    space_selector: "#mainCartContainer",
                    selector: "#mainCartContainer",
                    cart_notification: !1,
                },
                {
                    section: "cart-notification-panel-product",
                    space_selector: ".js-cart-notification-panel-item-count",
                    selector: ".js-cart-notification-panel-item-count-content",
                    cart_notification: !1,
                },
                {
                    section: "cart-notification-panel-product",
                    space_selector: ".js-cart-notification-panel-product-" + e?.id,
                    selector: ".js-cart-notification-panel-content",
                    cart_notification: !0,
                },
            ],
            n = SHTHelper.qs("sht-cart-noti"),
            s = SHTHelper.qs("sht-sticky-header");
        e = t.map((e) => e.section).join(",");
        fetch(window.location.pathname + "?sections=" + e)
            .then((e) => e.json())
            .then((i) => {
                s && s.dataset.isEnabled && s.reveal(),
                    t.forEach((e) => {
                        var t = i[e.section],
                            s = SHTHelper.qs(e.selector);
                        t &&
                            s &&
                            ((t = new DOMParser().parseFromString(t, "text/html").querySelector(e.space_selector)) &&
                                (s.innerHTML = t.innerHTML),
                            e.cart_notification) &&
                            n &&
                            n.open();
                    });
            })
            .catch((e) => {
                console.log("Cannot force Update Cart Status");
            });
    });
class SHTPopupEditorHelper {
    constructor(e, t) {
        (this.popupSource = e),
            (this.sectionId = t),
            (this.boundHandler = this.handleSectionEvent.bind(this)),
            (this.isSectionSelected = !1),
            (this.getPopupElement = () =>
                "function" == typeof this.popupSource ? this.popupSource() : this.popupSource),
            "undefined" != typeof Shopify && Shopify.designMode && this.bindEditorEvents();
    }
    bindEditorEvents() {
        document.addEventListener("shopify:section:select", this.boundHandler),
            document.addEventListener("shopify:section:deselect", this.boundHandler),
            document.addEventListener("shopify:section:load", this.boundHandler);
    }
    destroy() {
        document.removeEventListener("shopify:section:select", this.boundHandler),
            document.removeEventListener("shopify:section:deselect", this.boundHandler),
            document.removeEventListener("shopify:section:load", this.boundHandler);
    }
    handleSectionEvent(e) {
        var t = e?.detail;
        t?.sectionId &&
            ((t = t.sectionId === this.sectionId),
            "shopify:section:select" === e.type && t
                ? ((this.isSectionSelected = !0), this.getPopupElement(), this.showPopup())
                : "shopify:section:deselect" === e.type && t
                  ? ((this.isSectionSelected = !1), this.hidePopup())
                  : "shopify:section:load" === e.type &&
                    t &&
                    (this.getPopupElement(),
                    setTimeout(() => {
                        this.isSectionSelected && this.showPopup();
                    }, 150)));
    }
    showPopup() {
        var e = this.getPopupElement();
        e && ("function" == typeof e.togglePopup ? e.togglePopup(!0) : e.toggleAttribute("open", !0));
    }
    hidePopup() {
        var e = this.getPopupElement();
        e && ("function" == typeof e.togglePopup ? e.togglePopup(!1) : e.toggleAttribute("open", !1));
    }
}
class SHTPredictiveSearchEditorHelper extends SHTPopupEditorHelper {
    showPopup() {
        var e = this.getPopupElement() || document.querySelector("sht-predictive-srch");
        e &&
            (e.toggleAttribute("open", !0),
            document.body.classList.add("header--predictive-search-open", "o-hidden","no-scroll"),
            (this.predictiveSearchElm = document.querySelector(".js-predictive-search")),
            (this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input")),
            Shopify.designMode
                ? "function" == typeof SHTHelper?.removeTrapFocus && SHTHelper.removeTrapFocus()
                : setTimeout(() => {
                      try {
                          this.predictiveSearchElm &&
                              this.predictiveSearchInputElm &&
                              "function" == typeof SHTHelper?.trapFocus &&
                              SHTHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
                      } catch (e) {
                          console.warn("[PredictiveSearch] trapFocus failed:", e);
                      }
                  }, 300));
    }
    hidePopup() {
        var e = this.getPopupElement() || document.querySelector("sht-predictive-srch");
        e && e.toggleAttribute("open", !1),
            document.body.classList.remove("header--predictive-search-open", "o-hidden","no-scroll");
        try {
            "function" == typeof SHTHelper?.releaseTrapFocus && SHTHelper.releaseTrapFocus();
        } catch (e) {}
    }
}
class SHTElementLazyLoad {
    constructor() {
        (this.elements = SHTHelper.qsa(".js-main-body .js-animate")),
            (this.sequential_elements = SHTHelper.qsa(".js-main-body .js-seq-animate")),
            this.setupEventListeners();
    }
    setupEventListeners() {
        var s = new IntersectionObserver((s, i) => {
            for (let e = 0, t = s.length; e < t; e++)
                s[e].isIntersecting && (s[e].target.classList.add("animated"), i.unobserve(s[e].target));
        });
        for (let e = 0, t = this.elements.length; e < t; e++) s.observe(this.elements[e]);
        var i = new IntersectionObserver(
            (s, i) => {
                for (let e = 0, t = s.length; e < t; e++) {
                    var n = 100 * e;
                    s[e].isIntersecting &&
                        (setTimeout(() => {
                            s[e].target.classList.add("animated");
                        }, n),
                        i.unobserve(s[e].target));
                }
            },
            { threshold: 0.2 }
        );
        for (let e = 0, t = this.sequential_elements.length; e < t; e++) i.observe(this.sequential_elements[e]);
    }
}
setTimeout(() => {
    void 0 !== SHTElementLazyLoad && new SHTElementLazyLoad();
}),
    Shopify.designMode &&
        document.addEventListener("shopify:section:load", function (e) {
            void 0 !== SHTElementLazyLoad && new SHTElementLazyLoad();
        });
class SHTCustomComponent extends HTMLElement {
    constructor() {
        super(), (this.$ = this.querySelector.bind(this)), (this.$$ = this.querySelectorAll.bind(this));
    }
    static initGlobalFeatures() {
        SHTCustomComponent.globalFeaturesInitialized ||
            ((SHTCustomComponent.globalFeaturesInitialized = !0), SHTCustomComponent.initPaymentButtonEnhancement());
    }
    static enhancePaymentButton(e) {
        if (e)
            if (
                (e.classList.contains("btn") || e.classList.add("btn"),
                e.classList.contains("btn-primary--animate") || e.classList.add("btn-primary--animate"),
                e.querySelector(".btn-primary__content"))
            )
                e.dataset.enhanced || (e.dataset.enhanced = "true");
            else {
                var t = document.createElement("span"),
                    s = ((t.className = "d-block o-hidden p-relative"), document.createElement("span"));
                for (s.className = "btn-primary__content"; e.firstChild; ) s.appendChild(e.firstChild);
                t.appendChild(s), e.appendChild(t), (e.dataset.enhanced = "true");
            }
    }
    static enhancePaymentButtons(e = document) {
        e = e.querySelectorAll(".shopify-payment-button__button--unbranded");
        return (
            e.forEach((e) => {
                SHTCustomComponent.enhancePaymentButton(e);
            }),
            0 < e.length
        );
    }
    static waitForPaymentButtons(i, n = 2e3) {
        return new Promise((e) => {
            const t = () => {
                var e = i.querySelectorAll(".shopify-payment-button__button--unbranded");
                return 0 < e.length && (e.forEach((e) => SHTCustomComponent.enhancePaymentButton(e)), !0);
            };
            if (t()) e();
            else {
                const s = new MutationObserver(() => {
                    t() && (s.disconnect(), e());
                });
                s.observe(i, { childList: !0, subtree: !0 }),
                    setTimeout(() => {
                        s.disconnect(), t(), e();
                    }, n);
            }
        });
    }
    static initPaymentButtonEnhancement() {
        SHTCustomComponent.enhancePaymentButtons();
        var e = () => {
            document.querySelectorAll(".shopify-payment-button").forEach((s) => {
                if ("true" !== s.dataset.observed) {
                    let t = null;
                    new MutationObserver((e) => {
                        e.some((e) =>
                            Array.from(e.addedNodes).some(
                                (e) =>
                                    1 === e.nodeType &&
                                    (e.classList?.contains("shopify-payment-button__button--unbranded") ||
                                        e.querySelector?.(".shopify-payment-button__button--unbranded"))
                            )
                        ) &&
                            (clearTimeout(t),
                            (t = setTimeout(() => {
                                SHTCustomComponent.enhancePaymentButtons(s);
                            }, 100)));
                    }).observe(s, { childList: !0, subtree: !0, attributes: !1 }),
                        (s.dataset.observed = "true");
                }
            });
        };
        e(),
            document.addEventListener("shopify:section:load", e),
            document.addEventListener("shopify:section:select", e);
    }
}
class LoadingBar extends HTMLElement {
    constructor() {
        super(), this.bindEventHandlers();
    }
    bindEventHandlers() {
        document.addEventListener("page:loaded", this.handleLoaded.bind(this), { once: !0 }),
            window.addEventListener("load", this.handleLoaded.bind(this), { once: !0 });
    }
    handleLoaded() {
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? (this.style.display = "none")
            : requestAnimationFrame(() => {
                  this.classList.add("is-hidden");
              });
    }
}
customElements.define("loading-bar", LoadingBar);
class SHTHeader extends SHTCustomComponent {
    constructor() {
        super();

        this.searchHeaderOpenBtn = this.$$(".js-search-open-trigger");
        this.searchCloseBtns = document.querySelectorAll(".js-predictive-search-close-trigger");

        this.predictiveSearchElm = document.querySelector(".js-predictive-search");
        this.predictiveSearchInputElm = document.querySelector(".js-predictive-search-input");
        this.bodyElement = document.body;

        // ✅ TOGGLE ONLY ON TRIGGER (controlled)
        this.searchHeaderOpenBtn.forEach((btn) =>
            btn.addEventListener("click", (e) => {
                e.stopPropagation();

                if (this.isSearchOpen) {
                    this.closePredictiveSearch();
                } else {
                    this.openPredictiveSearch();
                }
            })
        );

        // ✅ CLOSE BUTTONS
        this.searchCloseBtns.forEach((btn) =>
            btn.addEventListener("click", (e) => {
                e.stopPropagation();
                this.closePredictiveSearch();
            })
        );

        // ✅ OUTSIDE CLICK (runs before click → no conflict)
        document.addEventListener("pointerdown", this.handleOutsideClick.bind(this));

        this.boundRecalcSearchTop = this.calculateAndSetSearchTop.bind(this);
        window.addEventListener("resize", () => {
            if (this.isSearchOpen) this.boundRecalcSearchTop();
        });
        window.addEventListener("scroll", () => {
            if (this.isSearchOpen) this.boundRecalcSearchTop();
        });
    }

    get isSearchOpen() {
        return (
            this.bodyElement.classList.contains("header--predictive-search-open") ||
            (this.predictiveSearchElm && this.predictiveSearchElm.classList.contains("is-active")) ||
            (this.predictiveSearchElm && this.predictiveSearchElm.hasAttribute("open"))
        );
    }

    calculateAndSetSearchTop() {
        if (!this.predictiveSearchElm) {
            this.predictiveSearchElm = document.querySelector(".js-predictive-search");
        }
        if (!this.predictiveSearchElm) return;

        var headerElm = SHTHelper.qs(".js-section-header") || SHTHelper.qs("sht-sticky-header") || SHTHelper.qs("sht-header") || SHTHelper.qs("#shopify-section-header");
        var announcementBar = SHTHelper.qs(".js-anmb-section") || SHTHelper.qs(".announcement-bar") || SHTHelper.qs("#shopify-section-announcement-bar");
        var headerBottom = 0;
        var annoBottom = 0;

        if (headerElm) {
            var rect = headerElm.getBoundingClientRect();
            if (rect.bottom > 0) {
                headerBottom = rect.bottom;
            }
        }

        if (announcementBar) {
            var rect = announcementBar.getBoundingClientRect();
            if (rect.bottom > 0) {
                annoBottom = rect.bottom;
            }
        }

        var totalHeight = Math.max(headerBottom, annoBottom);
        totalHeight = Math.round(totalHeight);

        this.predictiveSearchElm.style.setProperty("top", totalHeight + "px", "important");
    }

    openPredictiveSearch() {
        this.bodyElement.classList.add("header--predictive-search-open", "o-hidden", "no-scroll");
        this.predictiveSearchElm?.classList.add("is-active");

        if (this.predictiveSearchElm && typeof this.predictiveSearchElm.openSearchResults === "function") {
            const term = typeof this.predictiveSearchElm.getSearchTerm === "function" ? this.predictiveSearchElm.getSearchTerm() : "";
            this.predictiveSearchElm.openSearchResults(term);
        }

        this.calculateAndSetSearchTop();

        setTimeout(() => {
            SHTHelper.trapFocus(this.predictiveSearchElm, this.predictiveSearchInputElm);
        }, 300);
    }

    closePredictiveSearch() {
        this.bodyElement.classList.remove("header--predictive-search-open", "o-hidden", "no-scroll");
        this.predictiveSearchElm?.classList.remove("is-active");

        if (this.predictiveSearchElm && typeof this.predictiveSearchElm.closeSearchResults === "function") {
            this.predictiveSearchElm.closeSearchResults(true);
        }

        if (SHTHelper?.releaseFocus) {
            SHTHelper.releaseFocus();
        }
    }

    handleOutsideClick(e) {
        if (!this.isSearchOpen) return;

        const isInsideSearch = e.target.closest(".js-predictive-search");
        const isInsidePredictive = e.target.closest("predictive-search");

        const isTrigger = e.target.closest(".js-search-open-trigger");

        if (!isInsideSearch && !isInsidePredictive && !isTrigger) {
            this.closePredictiveSearch();
        }
    }
}
customElements.define("sht-header", SHTHeader);
class SHTMenuHeader extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.header = SHTHelper.qs("sht-header")),
            (this.enableDrawerDesk = "true" === this.header.dataset.enableDrawer),
            (this.isHover = "hover" === this.header.dataset.enableHover),
            (this.details = this.$("details")),
            (this.summaries = this.$$("summary")),
            (this.summary = this.details.querySelector("summary")),
            (this.content = this.summary.nextElementSibling),
            (this.content_animations = null),
            (this.isMegaMenu = "Megamenu" === this.dataset.menuDropdownType),
            (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            this.bindEventHandlers(),
            this.isMegaMenu &&
                ((this.onWindowResizeBound = this.onWindowResize.bind(this)),
                window.addEventListener("resize", this.onWindowResizeBound)),
            !1 === this.isMegaMenu && this.isDesktop && this.initSubmenuPositioning();
    }
    disconnectedCallback() {
        if (
            (this.onWindowResizeBound && window.removeEventListener("resize", this.onWindowResizeBound),
            this.megaMenuResizeObserver)
        ) {
            try {
                this.megaMenuResizeObserver.disconnect();
            } catch (e) {}
            (this.megaMenuResizeObserver = null), (this.megaMenuWrapper = null);
        }
    }
    initSubmenuPositioning() {
        (this.resizeObserver = new ResizeObserver(this.checkSubmenuPositions.bind(this))),
            this.resizeObserver.observe(document.body),
            this.checkSubmenuPositions();
    }
    checkSubmenuPositions() {
        this.$$(".menu-dropdown-lv2").forEach((e) => {
            var t,
                s = e.closest(".menu__item");
            s &&
                ((s = s.getBoundingClientRect()),
                (s = window.innerWidth - s.right),
                (t = e.offsetWidth + ((t = e.querySelector(".menu-dropdown-lv3")) ? t.offsetWidth : 0)),
                e.classList.remove("menu-dropdown--right"),
                s <= t) &&
                e.classList.add("menu-dropdown--right");
        });
    }
    bindEventHandlers() {
        (this.mobileBreakpoint = window.matchMedia("(max-width: 1025px)")),
            this.details.addEventListener("focusout", this.onFocusOutEvent.bind(this)),
            !this.isHover || this.enableDrawerDesk || this.mobileBreakpoint.matches
                ? this.handleMenuClick()
                : this.handleMenuHover();
    }
    isAnyMegaMenuOpen() {
        var e = document.querySelector(
            'sht-menu-header[data-menu-dropdown-type="Megamenu"] details[data-level="1"][open]'
        );
        return Boolean(e);
    }
    ensureHeaderMegaClass() {
        "Megamenu" === this.dataset.menuDropdownType && this.header.classList.add("header-mega--open");
    }
    updateHeaderMegaClassOnClose() {
        this.isAnyMegaMenuOpen() || this.header.classList.remove("header-mega--open");
    }
    getMegaMenuHeight(e) {
        e = e?.querySelector(".js-mega-menu-wrapper");
        return e ? e.offsetHeight : 0;
    }
    measureAndEmitMegaMenuHeight(t) {
        "Megamenu" === this.dataset.menuDropdownType &&
            "1" === t?.dataset.level &&
            requestAnimationFrame(() => {
                var e = this.getMegaMenuHeight(t),
                    e =
                        ((this.currentMegaMenuHeight = e),
                        this.header?.style?.setProperty("--mega-menu-height", e + "px"),
                        new CustomEvent("sht:mega-menu:height", { bubbles: !0, detail: { height: e, details: t } }));
                this.dispatchEvent(e);
            });
    }
    observeMegaMenu(e) {
        if (e) {
            var t = e.querySelector(".js-mega-menu-wrapper");
            if (t) {
                if (
                    (this.megaMenuResizeObserver ||
                        (this.megaMenuResizeObserver = new ResizeObserver(() => {
                            this.measureAndEmitMegaMenuHeight(e);
                        })),
                    this.megaMenuWrapper && this.megaMenuWrapper !== t)
                )
                    try {
                        this.megaMenuResizeObserver.unobserve(this.megaMenuWrapper);
                    } catch (e) {}
                this.megaMenuWrapper = t;
                try {
                    this.megaMenuResizeObserver.observe(t);
                } catch (e) {}
            }
        }
    }
    unobserveMegaMenu(e) {
        var t = e ? e.querySelector(".js-mega-menu-wrapper") : this.megaMenuWrapper;
        if (this.megaMenuResizeObserver && t)
            try {
                this.megaMenuResizeObserver.unobserve(t);
            } catch (e) {}
        e && this.megaMenuWrapper === t && (this.megaMenuWrapper = null);
    }
    onWindowResize() {
        this.isMegaMenu &&
            this.details &&
            "1" === this.details.dataset.level &&
            this.details.hasAttribute("open") &&
            this.measureAndEmitMegaMenuHeight(this.details);
    }
    handleMenuClick() {
        for (let e = 0, t = this.summaries.length; e < t; e++) {
            var s = this.summaries[e];
            s.addEventListener("click", (e) => {
                let t = e.currentTarget.closest("details");
                e.preventDefault(),
                    t.hasAttribute("open")
                        ? (e.currentTarget.setAttribute("aria-expanded", !1),
                          t.classList.remove("is-open"),
                          setTimeout(() => {
                              (t.open = !1),
                                  "1" == t.dataset.level &&
                                      (this.header.classList.remove("header-menu--open"),
                                      this.updateHeaderMegaClassOnClose(),
                                      this.unobserveMegaMenu(t));
                          }, 300))
                        : ("1" == t.dataset.level
                              ? this.closeOtherLevel1Menus(t)
                              : "2" == t.dataset.level && this.closeOtherLevel2Menus(t),
                          t.classList.remove("is-open"),
                          e.currentTarget.setAttribute("aria-expanded", !0),
                          (t.open = !0),
                          t.offsetHeight,
                          requestAnimationFrame(() => {
                              t.classList.add("is-open");
                          }),
                          "1" == t.dataset.level &&
                              (this.header.classList.add("header-menu--open"),
                              this.ensureHeaderMegaClass(),
                              this.measureAndEmitMegaMenuHeight(t),
                              this.observeMegaMenu(t)));
            }),
                s.addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
        }
    }
    closeOtherLevel1Menus(s) {
        this.querySelectorAll('details[data-level="1"]').forEach((e) => {
            var t;
            e !== s &&
                e.hasAttribute("open") &&
                ((t = e.querySelector("summary")),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    (e.open = !1), this.unobserveMegaMenu(e);
                }, 300));
        });
    }
    closeOtherLevel1MenusImmediate(s) {
        this.querySelectorAll('details[data-level="1"]').forEach((e) => {
            var t;
            e !== s &&
                e.hasAttribute("open") &&
                ((t = e.querySelector("summary")),
                e.classList.add("hover-no-animation"),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                (e.open = !1),
                this.unobserveMegaMenu(e),
                setTimeout(() => {
                    e.classList.remove("hover-no-animation");
                }, 10));
        });
    }
    closeOtherLevel2Menus(s) {
        var e = s.closest('details[data-level="1"]');
        e &&
            e.querySelectorAll('details[data-level="2"]').forEach((e) => {
                var t;
                e !== s &&
                    e.hasAttribute("open") &&
                    ((t = e.querySelector("summary")),
                    e.classList.remove("is-open"),
                    t.setAttribute("aria-expanded", !1),
                    setTimeout(() => {
                        e.open = !1;
                    }, 300));
            });
    }
    closeOtherLevel2MenusImmediate(s) {
        var e = s.closest('details[data-level="1"]');
        e &&
            e.querySelectorAll('details[data-level="2"]').forEach((e) => {
                var t;
                e !== s &&
                    e.hasAttribute("open") &&
                    ((t = e.querySelector("summary")),
                    e.classList.add("hover-no-animation"),
                    e.classList.remove("is-open"),
                    t.setAttribute("aria-expanded", !1),
                    (e.open = !1),
                    setTimeout(() => {
                        e.classList.remove("hover-no-animation");
                    }, 10));
            });
    }
    onKeyUpEscEvent(t) {
        if ("ESCAPE" === t.code.toUpperCase()) {
            let e = t.target.closest("details[open]");
            e &&
                ((t = e.querySelector("summary")),
                e.classList.remove("is-open"),
                t.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    e.removeAttribute("open"),
                        "1" == e.dataset.level &&
                            (this.header.classList.remove("header-menu--open"),
                            this.updateHeaderMegaClassOnClose(),
                            "Megamenu" === this.dataset.menuDropdownType) &&
                            this.unobserveMegaMenu(e);
                }, 300),
                t.focus());
        }
    }
    onFocusOutEvent() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    handleMenuHover() {
        (this.hoverTimeout = null),
            (this.level2HoverTimeouts = new Map()),
            (this.entryDelayTimeouts = new Map()),
            (this.currentOpenMenu = null),
            (this.currentOpenLevel2Menus = new Set());
        for (let e = 0, t = this.summaries.length; e < t; e++) {
            let t = this.summaries[e].closest("details");
            if ("1" === t.dataset.level)
                if ("Megamenu" === this.dataset.menuDropdownType)
                    this.addEventListener("mouseenter", (e) => {
                        this.onMenuHover(t, !0);
                    }),
                        this.addEventListener("mouseleave", (e) => {
                            this.onMenuHover(t, !1);
                        });
                else {
                    var s = t.closest(".menu__item");
                    if (!s) return;
                    s.addEventListener("mouseenter", (e) => {
                        this.onMenuHover(t, !0);
                    }),
                        s.addEventListener("mouseleave", (e) => {
                            this.onMenuHover(t, !1);
                        });
                }
            if ("2" === t.dataset.level) {
                s = t.closest('details[data-level="1"]');
                if (!(s && s.closest(".menu__item-megamenu"))) {
                    var i = t.closest(".submenu__item");
                    if (!i) return;
                    i.addEventListener("mouseenter", (e) => {
                        this.onLevel2MenuHover(t, !0);
                    }),
                        i.addEventListener("mouseleave", (e) => {
                            this.onLevel2MenuHover(t, !1);
                        });
                }
            }
        }
        for (let e = 0, t = this.summaries.length; e < t; e++)
            this.summaries[e].addEventListener("keyup", this.onKeyUpEscEvent.bind(this));
    }
    onMenuHover(e, t) {
        clearTimeout(this.hoverTimeout),
            this.entryDelayTimeouts.has(e) &&
                (clearTimeout(this.entryDelayTimeouts.get(e)), this.entryDelayTimeouts.delete(e));
        var s = "Megamenu" === this.dataset.menuDropdownType;
        t
            ? !(this.currentOpenMenu && this.currentOpenMenu !== e) && s && !this.currentOpenMenu
                ? ((t = setTimeout(() => {
                      this.closeOtherLevel1MenusImmediate(e),
                          this.openHoverMenu(e),
                          (this.currentOpenMenu = e),
                          this.entryDelayTimeouts.delete(e);
                  }, 250)),
                  this.entryDelayTimeouts.set(e, t))
                : (this.closeOtherLevel1MenusImmediate(e), this.openHoverMenu(e), (this.currentOpenMenu = e))
            : s
              ? (this.hoverTimeout = setTimeout(() => {
                    this.closeHoverMenu(e), this.currentOpenMenu === e && (this.currentOpenMenu = null);
                }, 300))
              : (this.closeHoverMenu(e), this.currentOpenMenu === e && (this.currentOpenMenu = null));
    }
    onLevel2MenuHover(t, e) {
        const s = t.closest('details[data-level="1"]');
        this.level2HoverTimeouts.has(t) &&
            (clearTimeout(this.level2HoverTimeouts.get(t)), this.level2HoverTimeouts.delete(t)),
            this.entryDelayTimeouts.has(t) &&
                (clearTimeout(this.entryDelayTimeouts.get(t)), this.entryDelayTimeouts.delete(t)),
            e
                ? Array.from(this.currentOpenLevel2Menus).some(
                      (e) => e !== t && e.closest('details[data-level="1"]') === s
                  )
                    ? ((e = setTimeout(() => {
                          this.closeOtherLevel2MenusImmediate(t),
                              this.openHoverMenu(t),
                              this.currentOpenLevel2Menus.add(t),
                              this.entryDelayTimeouts.delete(t);
                      }, 150)),
                      this.entryDelayTimeouts.set(t, e))
                    : (this.closeOtherLevel2MenusImmediate(t),
                      this.openHoverMenu(t),
                      this.currentOpenLevel2Menus.add(t))
                : ((e = setTimeout(() => {
                      this.closeHoverMenu(t), this.currentOpenLevel2Menus.delete(t), this.level2HoverTimeouts.delete(t);
                  }, 50)),
                  this.level2HoverTimeouts.set(t, e));
    }
    openHoverMenu(e) {
        e.hasAttribute("open") ||
            ((e.open = !0),
            e.querySelector("summary").setAttribute("aria-expanded", !0),
            e.offsetHeight,
            requestAnimationFrame(() => {
                e.classList.add("is-open");
            }),
            "1" === e.dataset.level &&
                (this.header.classList.add("header-menu--open"),
                this.ensureHeaderMegaClass(),
                this.measureAndEmitMegaMenuHeight(e),
                this.observeMegaMenu(e)));
    }
    closeHoverMenu(e) {
        e.hasAttribute("open") &&
            (e.classList.remove("is-open"),
            e.querySelector("summary").setAttribute("aria-expanded", !1),
            setTimeout(() => {
                (e.open = !1),
                    "1" === e.dataset.level && this.header.classList.remove("header-menu--open"),
                    this.updateHeaderMegaClassOnClose(),
                    "1" === e.dataset.level && this.unobserveMegaMenu(e);
            }, 300));
    }
    close() {
        this.hoverTimeout && (clearTimeout(this.hoverTimeout), (this.hoverTimeout = null)),
            this.level2HoverTimeouts &&
                (this.level2HoverTimeouts.forEach((e) => clearTimeout(e)), this.level2HoverTimeouts.clear()),
            this.entryDelayTimeouts &&
                (this.entryDelayTimeouts.forEach((e) => clearTimeout(e)), this.entryDelayTimeouts.clear());
        var e = "1" == this.details.dataset.level && this.details.hasAttribute("open");
        for (let t = 0, e = this.summaries.length; t < e; t++) {
            var s = this.summaries[t];
            let e = s.closest("details");
            e.hasAttribute("open") &&
                (e.classList.remove("is-open"),
                s.setAttribute("aria-expanded", !1),
                setTimeout(() => {
                    e.removeAttribute("open");
                }, 300));
        }
        e &&
            setTimeout(() => {
                this.header.classList.remove("header-menu--open");
            }, 300),
            (this.currentOpenMenu = null),
            this.currentOpenLevel2Menus && this.currentOpenLevel2Menus.clear(),
            setTimeout(() => {
                this.updateHeaderMegaClassOnClose();
            }, 300);
    }
    disconnectedCallback() {
        this.hoverTimeout && clearTimeout(this.hoverTimeout),
            this.level2HoverTimeouts &&
                (this.level2HoverTimeouts.forEach((e) => clearTimeout(e)), this.level2HoverTimeouts.clear()),
            this.entryDelayTimeouts &&
                (this.entryDelayTimeouts.forEach((e) => clearTimeout(e)), this.entryDelayTimeouts.clear());
    }
}
customElements.define("sht-menu-header", SHTMenuHeader);
class SHTStickyHeader extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        if (
            ((this.header_sticky = this.dataset.headerSticky),
            (this.prevent_reveal = !1),
            (this.css_ary = ["top-0", "zi-4", "header--sticky", "is-header-hide"]),
            (this.header = SHTHelper.qs(".js-section-header")),
            (this.cartNotificationPanel = this.$(".js-cartNotificationPanel")),
            (this.currentScrollTop = 0),
            (this.headerBounds = {}),
            this.bindEventHandlers(),
            "disable" == this.header_sticky)
        )
            return !1;
        "always" == this.header_sticky
            ? (this.header.classList.add("header--sticky-always"),
              this._checkStickyAlwaysPosition(),
              this._bindStickyAlwaysScrollHandler())
            : this.createObserver();
    }
    bindEventHandlers() {
        if ("disable" == this.header_sticky) return !1;
        (this.preventStickyHeaderReveal = () => (this.prevent_reveal = !0)),
            this.addEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.addEventListener("scroll", this.onScrollHandle.bind(this), !1);
    }
    _checkStickyAlwaysPosition() {
        this.header &&
            (0.5 < this.header.getBoundingClientRect().top
                ? this.header.classList.remove("header--sticky-always")
                : this.header.classList.add("header--sticky-always"));
    }
    _bindStickyAlwaysScrollHandler() {
        (this.stickyAlwaysScrollHandler = () => {
            this._checkStickyAlwaysPosition();
        }),
            window.addEventListener("scroll", this.stickyAlwaysScrollHandler, !1);
    }
    createObserver() {
        new IntersectionObserver((e, t) => {
            (this.header_bounds = e[0].intersectionRect), t.disconnect();
        }).observe(this.header);
    }
    onScrollHandle() {
        if (this.header_bounds) {
            var e = window.pageYOffset || SHTHelper.qde.scrollTop;
            if (e > this.currentScrollTop && e > this.header_bounds.bottom) {
                if (this.prevent_reveal)
                    return (
                        window.clearTimeout(this.is_scrolling),
                        void (this.is_scrolling = setTimeout(() => {
                            this.prevent_reveal = !1;
                        }, 20))
                    );
                requestAnimationFrame(this.hide.bind(this));
            } else if (e < this.currentScrollTop && e > this.header_bounds.bottom) {
                if (this.prevent_reveal)
                    return (
                        requestAnimationFrame(this.hide.bind(this)),
                        window.clearTimeout(this.is_scrolling),
                        void (this.is_scrolling = setTimeout(() => {
                            this.prevent_reveal = !1;
                        }, 20))
                    );
                requestAnimationFrame(this.reveal.bind(this));
            } else e <= this.header_bounds.top && requestAnimationFrame(this.reset.bind(this));
            this.currentScrollTop = e;
        }
    }
    hide() {
        this.header.classList.add("is-header-hide", "p-sticky", "top-0", "zi-4", "header--sticky"),
            (this.cartNotificationPanel.hidden = !0),
            this.closeMenu();
    }
    reveal() {
        this.header.classList.add("top-0", "animate", "zi-4", "p-sticky", "header--sticky"),
            this.header.classList.remove("is-header-hide");
    }
    reset() {
        this.header.classList.remove("is-header-hide", "top-0", "animate", "header--sticky", "p-sticky");
    }
    closeMenu() {
        this.menus = this.header.querySelectorAll("sht-menu-header");
        for (let e = 0, t = this.menus.length; e < t; e++) this.menus[e].close();
    }
    disconnectedCallback() {
        this.removeEventListener("preventStickyHeaderReveal", this.preventStickyHeaderReveal),
            window.removeEventListener("scroll", this.onScrollHandle.bind(this));
    }
}
customElements.define("sht-sticky-header", SHTStickyHeader);
class SHTCartNotificationPanel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.elms = {
                notification_wrapper: this.$(".js-cart-notification-panel-wrapper"),
                notification_container: this.$(".js-cart-notification-panel-container"),
                close_buttons: this.$$(".js-cart-notification-panel-close-btn"),
                sticky_header: SHTHelper.qs("sht-sticky-header"),
            }),
            (this.dismiss_timeout = null);
        for (let e = 0, t = this.elms.close_buttons.length; e < t; e++)
            this.elms.close_buttons[e].addEventListener("click", this.close.bind(this));
    }
    async open() {
        this.togglePanel(!0),
            await this.animationsComplete(),
            this.elms.notification_container.focus(),
            this.addEventListener("mouseover", this.onMouseOverHandle.bind(this)),
            this.addEventListener("mouseout", this.onMouseOutHandle.bind(this)),
            this.setDismissTimeout(),
            SHTHelper.trapFocus(this);
    }
    async close() {
        this.clearDismissTimeout(),
            this.togglePanel(!1),
            await this.animationsComplete(),
            this.dispatchEvent(new Event("closed")),
            this.element_to_focus
                ? (SHTHelper.removeTrapFocus(this.element_to_focus), (this.element_to_focus = null))
                : SHTHelper.removeTrapFocus();
    }
    animationsComplete() {
        return Promise.allSettled(this.getAnimations().map((e) => e.finished));
    }
    clearDismissTimeout() {
        clearTimeout(this.dismiss_timeout);
    }
    renderContents(s, e = !0, t = null) {
        (this.element_to_focus = t), (this.productId = s.id);
        var i = this.getSectionsToRender();
        for (let e = 0, t = i.length; e < t; e++) {
            var n = SHTHelper.qs(i[e].space_selector);
            n &&
                ("#headerCartStatus" == i[e].space_selector && n.classList.add("header-cart-status--animate"),
                (n.innerHTML = this.getSectionInnerHTML(s.sections[i[e].id], i[e].selector)));
        }
        e && this.open();
    }
    getSectionsToRender() {
        return [
            {
                id: "cart-notification-panel-product",
                selector: ".js-cart-notification-panel-product-" + this.productId,
                space_selector: ".js-cart-notification-panel-content",
            },
            {
                id: "free-shipping-notification",
                selector: ".js-free-shipping-notification",
                space_selector: ".js-cart-notification-free-shipping",
            },
            { id: "header-cart-status", section: "header-cart-status", space_selector: "#headerCartStatus" },
            {
                id: "cart-notification-panel-product",
                selector: ".js-cart-notification-panel-item-count",
                space_selector: ".js-cart-notification-panel-item-count-content",
            },
        ];
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    onMouseOverHandle(e) {
        this.clearDismissTimeout();
    }
    onMouseOutHandle(e) {
        this.setDismissTimeout();
    }
    togglePanel(e) {
        e ? this.toggleAttribute("hidden", !1) : this.setAttribute("hidden", !0);
    }
    setDismissTimeout() {
        (this.dismiss_timeout = setTimeout(
            function () {
                this.close();
            }.bind(this),
            5e3
        )),
            "false" == this.elms.sticky_header.dataset.isEnabled &&
                setTimeout(() => {
                    this.elms.sticky_header.reset();
                }, 6e3);
    }
}
customElements.define("sht-cart-noti", SHTCartNotificationPanel);
class SHTCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        "false" != this.dataset.enable &&
            ((this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel()));
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML = this.currentPage),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement?.setAttribute("disabled", "disabled")
                : this.prevBtnElement?.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement?.setAttribute("disabled", "disabled")
                : this.nextBtnElement?.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    togglePagination(e) {
        e
            ? this.paginationElement?.classList.remove("d-none-important")
            : this.paginationElement?.classList.add("d-none-important");
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t + 1;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft - 1;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 459px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - s + t * this.itemOffset
                    : this.container.scrollLeft + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        "false" != this.dataset.enable &&
            (new ResizeObserver((e) => this.init()).observe(this.container),
            new IntersectionObserver(
                ((e, t) => {
                    e[0].isIntersecting && (this.init(), t.unobserve(this));
                }).bind(this)
            ).observe(this),
            this.prevBtnElement?.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement?.addEventListener("click", this.onButtonClick.bind(this)),
            this.container?.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100)));
    }
}
customElements.define("sht-carousel", SHTCarousel);
class SHTCarouselTrigger extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
    init() {
        (this.trigger = this.$$(".js-carousel-trigger")),
            (this.carouselWebElement = SHTHelper.qs("#" + this.dataset.carouselTarget)),
            (this.carousel = this.carouselWebElement.querySelector(".js-carousel-items")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        for (let e = 0, t = this.trigger.length; e < t; e++)
            this.trigger[e].addEventListener("click", (e) => {
                this.setActiveCarouselElement(e.currentTarget);
            });
        this.carouselWebElement.addEventListener("itemChanged", (e) => {
            this.setButtonVisibility(!1);
            e = this.$(`[aria-describedby="${e.detail.currentElement.id}"]`);
            e.setAttribute("aria-current", "true"), e.classList.add("hotspot-item--active");
        });
    }
    setActiveCarouselElement(e) {
        e = this.carousel.querySelector("#" + e.getAttribute("aria-describedby", ""));
        e && this.carousel.scrollTo({ left: e.offsetLeft, behavior: "smooth" });
    }
    setButtonVisibility(s) {
        if (this.trigger)
            for (let e = 0, t = this.trigger.length; e < t; e++)
                s
                    ? (this.trigger[e].setAttribute("aria-current", "true"),
                      this.trigger[e].classList.add("hotspot-item--active"))
                    : (this.trigger[e].removeAttribute("aria-current"),
                      this.trigger[e].classList.remove("hotspot-item--active"));
    }
}
customElements.define("sht-carousel-trig", SHTCarouselTrigger);
class SHTCoreDrawer extends SHTCustomComponent {
    constructor() {
        super(),
            (this.drawerWrapperElement = this.$(".js-drawer-wrapper")),
            (this.drawerOverlayElement = this.$(".js-drawer-overlay")),
            (this.closeBtnElement = this.$(".js-drawer-btn-close")),
            (this.opener = null),
            (this.bodyElement = document.body),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.drawerOverlayElement.addEventListener("click", this.closeDrawer.bind(this)),
            this.closeBtnElement.addEventListener("click", this.closeDrawer.bind(this)),
            window.addEventListener("load", () => {
                this.removeAttribute("hidden");
            }),
            this.addEventListener("keyup", (e) => "ESCAPE" === e.code.toUpperCase() && this.closeDrawer()),
            this.drawerAttrObserve();
    }
    drawerAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "open" == e.attributeName &&
                    (this.hasAttribute("open")
                        ? (this.opener?.removeAttribute("disabled"),
                          this.opener?.setAttribute("aria-expanded", "true"),
                          this.setAttribute("aria-hidden", "false"),
                          this.dispatchEvent(new Event("opening")),
                          this.bodyElement.classList.add("o-hidden"),
                          this.classList.add("active"),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("opened")),
                          SHTHelper.trapFocus(this))
                        : (SHTHelper.removeTrapFocus(this.opener),
                          this.setAttribute("aria-hidden", "true"),
                          this.opener?.setAttribute("aria-expanded", "false"),
                          this.opener?.removeAttribute("disabled"),
                          this.dispatchEvent(new Event("closing")),
                          this.bodyElement.classList.remove("o-hidden"),
                          this.classList.remove("active"),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("closed"))));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.drawerWrapperElement.getAnimations().map((e) => e.finished));
    }
    openDrawer(e) {
        SHTHelper.preventStickyHeaderReveal(),
            (this.opener = e),
            this.removeAttribute("hidden"),
            this.toggleAttribute("open", !0);
    }
    closeDrawer() {
        this.toggleAttribute("open", !1);
    }
}
class SHTDrawer extends SHTCoreDrawer {}
customElements.define("sht-drwr", SHTDrawer);
class SHTDrawerTrigger extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-drawer-trigger")),
            (this.drawerElement = SHTHelper.qs("sht-drwr#" + this.dataset.drawerId)),
            this.triggerBtnElement &&
                this.drawerElement &&
                ((this.mediaElement = this.$(".js-drawer-trigger-media")),
                (this.headingElement = this.$(".js-drawer-trigger-heading")),
                (this.contentElements = this.$$(".js-drawer-trigger-content")),
                (this.footerElement = this.$(".js-drawer-trigger-footer")),
                this.bindEventHandlers());
    }
    bindDataToDrawer() {
        let t = "";
        (this.drawerElement.querySelector(".js-drawer-media").innerHTML = this.mediaElement.innerHTML),
            (this.drawerElement.querySelector(".js-drawer-heading").innerHTML = this.headingElement.innerHTML),
            this.drawerElement
                .querySelector(".js-drawer-wrapper")
                .setAttribute("aria-label", this.headingElement.innerHTML),
            this.contentElements.forEach((e) => {
                t += e.innerHTML;
            }),
            (this.drawerElement.querySelector(".js-drawer-content").innerHTML = t),
            this.footerElement &&
                ((this.drawerElement.querySelector(".js-drawer-footer").innerHTML = this.footerElement.innerHTML),
                this.drawerElement
                    .querySelector(".js-drawer-footer")
                    .querySelectorAll(".js-drawer-trigger-footer-btn")
                    .forEach((e) => {
                        e.classList.add("btn-drawer");
                    }));
    }
    bindEventHandlers() {
        this.triggerBtnElement.addEventListener("click", (e) => {
            setTimeout(() => {
                this.bindDataToDrawer(), this.drawerElement.openDrawer(e.target);
            }, 100);
        });
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
}
customElements.define("sht-drwr-trg", SHTDrawerTrigger);
class SHTCartDrawer extends SHTCoreDrawer {
    getSectionsToRender() {
        return [{ id: "cart-drawer", section: "cart-drawer", space_selector: "#cartDrawer" }];
    }
}
customElements.define("sht-cart-drwr", SHTCartDrawer);
class SHTCartDrawerCartNote extends SHTCustomComponent {
    constructor() {
        super(),
            this.addEventListener(
                "change",
                SHTHelper.debounce((e) => {
                    e = JSON.stringify({ note: e.target.value });
                    fetch("" + window.routes.cart_update_url, { ...SHTHelper.fetchConfigJSON, body: e });
                }, 300)
            );
    }
}
customElements.define("sht-cart-drwr-note", SHTCartDrawerCartNote);
class SHTCartDrawerQuantityInput extends SHTCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-cart-drawer-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.button = this.$$(".js-cart-drawer-quantity-btn"));
        for (let e = 0, t = this.button.length; e < t; e++)
            this.button[e].addEventListener("click", this.onButtonClickHandler.bind(this));
    }
    onButtonClickHandler(e) {
        e.preventDefault();
        var t = this.input.value;
        "plus" === e.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define("sht-cart-drwr-qty-inp", SHTCartDrawerQuantityInput);
class SHTCartDrawerRemoveButton extends SHTCustomComponent {
    constructor() {
        super(),
            this.addEventListener("click", (e) => {
                e.preventDefault(), this.closest("sht-cart-drwr-frm").updateQuantity(this.dataset.index, 0);
            });
    }
}
customElements.define("sht-cart-drwr-rmv-btn", SHTCartDrawerRemoveButton);
class SHTCartDrawerForm extends SHTCustomComponent {
    constructor() {
        super(),
            (this.totalItems = Array.from(this.$$(".js-cart-drawer-quantity-input")).reduce(
                (e, t) => e + parseInt(t.value),
                0
            )),
            (this.drawerCartElement = SHTHelper.qs("sht-cart-drwr")),
            (this.wrapperElement = this.drawerCartElement.querySelector(".js-cart-drawer-wrapper")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.isProcessingCartUpdate = !1),
            this.addEventListener(
                "change",
                SHTHelper.debounce((e) => {
                    this.onChange(e);
                }, 300)
            ),
            document.addEventListener("cart:update", this.handleCartUpdate.bind(this));
    }
    onChange(e) {
        this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.dataset.name);
    }
    getWrapper() {
        return this.drawerCartElement.querySelector(".js-cart-drawer-wrapper");
    }
    renderContents(i) {
        const wrapper = this.getWrapper();
            wrapper.classList.remove("is-empty");

            this.getSectionsToRender().forEach((s) => {
                s.selectors?.forEach((selector) => {
                    const container = SHTHelper.qid(s.id);

                    if (container && i.sections[s.section]) {
                        (container.querySelector(selector) || container).innerHTML =
                            this.getSectionInnerHTML(i.sections[s.section], selector);
                    }
                });
            });
    }
    handleCartUpdate(e) {
        if (!this.isProcessingCartUpdate) {
            this.isProcessingCartUpdate = !0;
            let i = this.getSectionsToRender();
            this.cartNotification && (i = [...i, ...this.cartNotification.getSectionsToRender()]),
                fetch("" + window.routes.cart_url, {
                    ...SHTHelper.fetchConfig,
                    headers: { Accept: "application/json" },
                })
                    .then((e) => e.json())
                    .then((e) => {
                        var t, s;
                        0 === e.item_count
                            ? ((e = SHTHelper.qs(".js-drawer-empty")),
                              (t = SHTHelper.qs(".js-cart-drawer-wrapper")),
                              (s = SHTHelper.qs(".js-cart-count-number")),
                              (t.innerHTML = e.innerHTML),
                              (s.innerHTML = 0))
                            : fetch("?sections=" + i.map((e) => e.section).join(","))
                                  .then((e) => e.text())
                                  .then((e) => {
                                      e = JSON.parse(e);
                                      this.renderContentsDiscount({ sections: e });
                                  })
                                  .catch((e) => {
                                      console.error("Error fetching cart sections:", e);
                                  });
                    })
                    .catch((e) => {
                        console.error("Error fetching cart:", e);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.isProcessingCartUpdate = !1;
                        }, 500);
                    });
        }
    }
    renderContentsDiscount(i) {
        this.wrapperElement.classList.contains("is-empty") && this.wrapperElement.classList.remove("is-empty"),
            this.getSectionsToRenderDiscount().forEach((s) => {
                s.selectors?.forEach((e) => {
                    var t = SHTHelper.qid(s.id);
                    t &&
                        i.sections[s.section] &&
                        (t.querySelector(e).innerHTML = this.getSectionInnerHTML(i.sections[s.section], e));
                });
            });
    }
    getSectionsToRenderDiscount() {
        return [
            {
                id: "cartDrawer",
                section: "cart-drawer",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
            {
                id: "mainCart",
                section: "main-cart",
                selectors: [
                    ".js-cart-items",
                    ".js-discount-pills",
                    ".js-cart-total",
                    ".js-free-shipping-notification-message",
                    ".js-cart-level-discount-applications",
                ],
            },
        ];
    }
    getSectionsToRender() {
        return [
            { id: "cartDrawer", section: "cart-drawer", selectors: [".js-cart-drawer-wrapper"] },
            { id: "mainCart", section: "main-cart", selectors: ["#mainCartContainer"] },
        ];
    }
    updateQuantity(t, e, s) {
        let i = this.getSectionsToRender(),
            n;
        this.cartNotification && (i = [...i, ...this.cartNotification.getSectionsToRender()]);
        e = JSON.stringify({
            line: t,
            quantity: e,
            sections: i.map((e) => e.section),
            sections_url: window.location.pathname,
        });
        this.updateButtonState(!0),
            fetch("" + window.routes.cart_change_url, { ...SHTHelper.fetchConfigJSON, body: e })
                .then((e) => e.text())
                .then((e) => {
                    (n = JSON.parse(e)),
                        console.log(n),
                        n.errors
                            ? setTimeout(() => {
                                  this.updateErrorRegions(t, n.errors);
                              }, 100)
                            : (this.closest(".js-cart-drawer-wrapper").classList.toggle("is-empty", 0 === n.item_count),
                              this.getSectionsToRender().forEach((s) => {
                                  s.selectors.forEach((e) => {
                                      var t = SHTHelper.qid(s.id);
                                      t &&
                                          ((t.querySelector(e) || t).innerHTML = this.getSectionInnerHTML(
                                              n.sections[s.section],
                                              e
                                          ));
                                  });
                              }),
                              (e = SHTHelper.qid("cartDrawerItem-" + t)) &&
                                  (e = e.querySelector(".js-cart-drawer-quantity-btn-" + s)) &&
                                  e.focus(),
                              this.cartNotification &&
                                  this.cartNotification.getSectionsToRender().forEach((e) => {
                                      "header-cart-status" == e.id &&
                                          (SHTHelper.qs(e.space_selector).innerHTML =
                                              this.cartNotification.getSectionInnerHTML(n.sections[e.id], e.selector));
                                  }));
                })
                .catch((e) => {
                    (this.$(".js-cart-drawer-errors").textContent = SHTLanguage.cart.ERROR),
                        console.log(e.message, e.stack);
                })
                .finally(() => {
                    this.updateButtonState(!1);
                });
    }
    updateErrorRegions(e, t) {
        e = SHTHelper.qs("#cart-drawer-line-item-error-" + e);
        (e.querySelector(".js-cart-drawer-form-item-error-message").innerHTML = t),
            e.classList.remove("d-none-important");
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    updateButtonState(e) {
        var s = this.$$(".js-cart-drawer-btn"),
            t = this.drawerCartElement.querySelector(".js-cart-drawer-submit-btn");
        if (e) {
            for (let e = 0, t = s.length; e < t; e++) s[e].setAttribute("disabled", "disabled");
            t && t.setAttribute("disabled", "disabled");
        } else {
            for (let e = 0, t = s.length; e < t; e++) s[e].removeAttribute("disabled", "disabled");
            t && t.removeAttribute("disabled");
        }
    }
}
customElements.define("sht-cart-drwr-frm", SHTCartDrawerForm);
class SHTMenuDrawer extends SHTCoreDrawer {}
customElements.define("sht-menu-drwer", SHTMenuDrawer);
class SHTMenuDrawerOpener extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.triggerBtnElement = this.$(".js-menu-drawer-trigger")),
            (this.menuDrawerElement = SHTHelper.qs("sht-menu-drwer")),
            this.triggerBtnElement.addEventListener("click", (e) => {
                this.menuDrawerElement?.openDrawer(e.target);
            });
    }
}
customElements.define("sht-menu-drwer-opner", SHTMenuDrawerOpener);
class SHTMegaMenuDrawer extends SHTCoreDrawer {
    constructor() {
        super();
    }
}
customElements.define("sht-mega-menu-drawer", SHTMegaMenuDrawer);
class SHTColorSwatch extends SHTCustomComponent {
    constructor() {
        super(),
            (this.json = null),
            (this.jsonDataElement = SHTHelper.qs('#colorSwatchData[type="application/json"]') || null),
            (this.variantSwatchItems = this.$$(".js-variant-swatch-item") || []),
            this.jsonDataElement && 0 != this.variantSwatchItems.length && this.bindEventHandlers();
    }
    onObserverHandler() {
        new IntersectionObserver((e, t) => {
            e.forEach((e) => {
                e.isIntersecting && (this.init(), t.unobserve(this));
            });
        }).observe(this);
    }
    init() {
        (this.json = JSON.parse(this.jsonDataElement.textContent)), this.processJsonData();
        for (let e = 0, t = this.variantSwatchItems.length; e < t; e++) {
            let i = this.variantSwatchItems[e];
            var s = this.json["" + i.dataset.optionValue];
            let n = "";
            var r,
                o = i.dataset.optionValue,
                a = i.dataset.swatchOptionValue,
                l = (e, t = "", s = "") => {
                    (n = e),
                        (i.style.backgroundColor = t),
                        (i.style.backgroundImage = s ? `url("${s}")` : ""),
                        (i.style.backgroundSize = s ? "cover" : ""),
                        (i.style.backgroundRepeat = s ? "no-repeat" : "");
                };
            void 0 !== s
                ? ((r = SHTHelper.isHexColor(s)), SHTHelper.isImage(s) ? l("image", "", s) : r && l("color", s))
                : SHTHelper.isColor(o) && l("color", o),
                a && ((r = SHTHelper.isHexColor(a)), SHTHelper.isImage(a) ? l("image", "", a) : r && l("color", a)),
                i.style.backgroundImage || i.style.backgroundColor
                    ? (n && i.classList.add("clr-swh__type--" + n), i.classList.add("clr-swh__has-value"))
                    : i.querySelector(".js-variant-option-label")?.classList.remove("opacity-0");
        }
    }
    processJsonData() {
        this.json &&
            (this.json = Object.assign.apply(
                {},
                this.json.color_swatch_name.map((e, t) => ({ [e]: this.json.color_swatch_value[t] }))
            ));
    }
    bindEventHandlers() {
        this.onObserverHandler();
    }
}
class SHTMainProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-variant-swtch", SHTMainProductVariantSwatch);
class SHTMainProductVariantSwatchWSelect extends SHTColorSwatch {}
customElements.define("sht-prd-variant-swtch-w-select", SHTMainProductVariantSwatchWSelect);
class SHTProductQuickViewVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-prd-qck-vw-variant-swtch", SHTProductQuickViewVariantSwatch);
class SHTMainCollectionProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-coll-prd-variant-swtch", SHTMainCollectionProductVariantSwatch);
class SHTFeaturedProductVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-featured-prd-variant-swtch", SHTFeaturedProductVariantSwatch);
class SHTMainSearchVariantSwatch extends SHTColorSwatch {}
customElements.define("sht-srch-variant-swtch", SHTMainSearchVariantSwatch);
class SHTVariantSwatch extends SHTColorSwatch {
    bindEventHandlers() {
        this.onObserverHandler(),
            this.variantSwatchItems.forEach((e) => {
                e.addEventListener("click", (e) => {
                    this.changeVariantImage(e.currentTarget);
                });
            });
    }
    changeVariantImage(e) {
        var s = SHTHelper.qs("#" + e.dataset.productImageId),
            i = SHTHelper.qsa("." + e.dataset.productLinkClass),
            n = e.querySelector("template");
        if (s && n) {
            this.setButtonVisibility(!1);
            let t = n.content.firstElementChild.cloneNode(!0);
            s.src && (s.src = t.src),
                s.srcset && (n.srcset ? (s.srcset = t.srcset) : (s.srcset = t.src)),
                i &&
                    i.forEach((e) => {
                        e.href = t.getAttribute("data_url");
                    }),
                e.setAttribute("aria-current", "true"),
                e.classList.add("btn-active"),
                e.focus();
        }
    }
    setButtonVisibility(t) {
        this.variantSwatchItems &&
            this.variantSwatchItems.forEach((e) => {
                t
                    ? (e.setAttribute("aria-current", "true"), e.classList.add("btn-active"))
                    : (e.removeAttribute("aria-current"), e.classList.remove("btn-active"));
            });
    }
}
customElements.define("sht-variant-swtch", SHTVariantSwatch);
class SHTDialogCore extends SHTCustomComponent {
    constructor() {
        super(),
            (this.dialog = this.$(".dialog")),
            (this.closeBtn = this.$$(".js-dialog-close-btn")),
            (this.body = this.$(".js-dialog-body")),
            (this.closeModalOnOverlayClick = this.dataset.closeModalOnOverlay || "true"),
            (this.opener = null),
            (this.bodyElement = document.body),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.closeBtn.forEach((e) => {
            e.addEventListener("click", (e) => {
                this.closeModal();
            });
        }),
            this.addEventListener("click", (e) => {
                e.target.nodeName === this.tagName && "true" === this.closeModalOnOverlayClick && this.closeModal();
            }),
            this.addEventListener("keyup", (e) => "ESCAPE" === e.code.toUpperCase() && this.closeModal()),
            this.dialogAttrObserve();
    }
    dialogAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "hidden" == e.attributeName &&
                    (!this.hasAttribute("hidden")
                        ? (this.dispatchEvent(
                              new CustomEvent("opening", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("opened", { detail: { opener: this.opener, dialog: this } })
                          ),
                          SHTHelper.trapFocus(this),
                          this.bodyElement.classList.add("o-hidden"))
                        : (SHTHelper.removeTrapFocus(this.opener),
                          this.dispatchEvent(
                              new CustomEvent("closing", { detail: { opener: this.opener, dialog: this } })
                          ),
                          await this.animationsComplete(),
                          this.dispatchEvent(
                              new CustomEvent("closed", { detail: { opener: this.opener, dialog: this } })
                          ),
                          this.bodyElement.classList.remove("o-hidden")));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.dialog.getAnimations({ subtree: !0 }).map((e) => e.finished));
    }
    processBodyContent() {
        var e;
        (this.template = this.$("template")), this.template && ((e = this.template.content), this.body.appendChild(e));
    }
    showModal(e, t = !1) {
        SHTHelper.preventStickyHeaderReveal(),
            t && this.processBodyContent(),
            (this.opener = e),
            this.toggleAttribute("hidden", !1);
    }
    closeModal() {
        this.setAttribute("hidden", !0);
    }
}
class SHTDialog extends SHTDialogCore {
    constructor() {
        super();
    }
}
customElements.define("sht-dialog", SHTDialog);
class SHTDialogQuickShop extends SHTDialogCore {
    constructor() {
        super();
    }
    showModal(e) {
        SHTHelper.preventStickyHeaderReveal(),
            (this.opener = e),
            this.opener?.setAttribute("disabled", "disabled"),
            this.processData(e);
    }
    processData(e) {
        (this.productElement = null),
            fetch(e.getAttribute("data-product-url"))
                .then((e) => e.text())
                .then((e) => {
                    e = new DOMParser().parseFromString(e, "text/html");
                    (this.productElement = e.querySelector(".section-product-quick-view")),
                        (this.body.innerHTML = this.productElement.innerHTML),
                        this.executeScriptElements(this.body),
                        SHTCustomComponent.waitForPaymentButtons(this.body),
                        window.Shopify?.PaymentButton && Shopify.PaymentButton.init(),
                        this.setupPaymentButtonObserver();
                })
                .finally(() => {
                    this.toggleAttribute("hidden", !1),
                        this.opener?.removeAttribute("disabled"),
                        this.bodyElement.classList.add("o-hidden");
                });
    }
    setupPaymentButtonObserver() {
        requestAnimationFrame(() => {
            var e = this.body.querySelectorAll(".shopify-payment-button");
            if (0 === e.length) {
                const t = new MutationObserver(() => {
                    var e = this.body.querySelectorAll('.shopify-payment-button:not([data-observed="true"])');
                    0 < e.length && this.observePaymentContainers(e);
                });
                t.observe(this.body, { childList: !0, subtree: !0 }), setTimeout(() => t.disconnect(), 3e3);
            } else this.observePaymentContainers(e);
        });
    }
    observePaymentContainers(e) {
        e.forEach((e) => {
            "true" !== e.dataset.observed &&
                (SHTCustomComponent.enhancePaymentButtons(e),
                new MutationObserver(() => SHTCustomComponent.enhancePaymentButtons(e)).observe(e, {
                    childList: !0,
                    subtree: !0,
                }),
                (e.dataset.observed = "true"));
        });
    }
    closeModal() {
        this.setAttribute("hidden", !0),
            this.bodyElement.classList.remove("o-hidden"),
            setTimeout(() => {
                this.body.innerHTML = "";
            }, 300);
    }
    executeScriptElements(e) {
        e = e.querySelectorAll("script");
        Array.from(e).forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
                t.setAttribute(e.name, e.value);
            }),
                t.appendChild(document.createTextNode(e.innerHTML)),
                e.parentNode.replaceChild(t, e);
        });
    }
}
customElements.define("sht-dialog-quickshop", SHTDialogQuickShop),
    document.addEventListener("DOMContentLoaded", function () {
        window.dialogQuickShop = document.getElementById("dialogQuickShop");
    });
class SHTDetailsExposal extends SHTCustomComponent {
    constructor() {
        super(),
            (this.detailsElm = this.$("details")),
            (this.content = this.detailsElm.querySelector("summary").nextElementSibling),
            this.detailsElm.addEventListener("focusout", this.onFocusOutHandler.bind(this)),
            this.detailsElm.addEventListener("toggle", this.onToggleHandler.bind(this));
    }
    onFocusOutHandler() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    onToggleHandler() {
        this.detailsElm.hasAttribute("open")
            ? this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !0)
            : this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !1);
    }
    close() {
        this.detailsElm.removeAttribute("open"),
            this.detailsElm.querySelector("summary").setAttribute("aria-expanded", !1);
    }
}
customElements.define("sht-dtl-exposal", SHTDetailsExposal);
class SHTShareProductButton extends SHTCustomComponent {
    constructor() {
        super(),
            (this.webShareApiContainer = this.$(".js-web-share-api-container")),
            (this.webShareApiButton = this.$(".js-web-share-api-btn")),
            (this.noneWebShareApiContainer = this.$(".js-none-web-share-api-container")),
            (this.noneWebShareApiButton = this.$(".js-none-web-share-api-btn")),
            (this.copyLinkButton = this.$(".js-social-share-copy-link")),
            this.init();
    }
    init() {
        navigator.share
            ? (this.webShareApiContainer.removeAttribute("hidden"),
              this.noneWebShareApiContainer.setAttribute("hidden", !0),
              this.webShareApiButton.addEventListener("click", () => {
                  navigator
                      .share({ url: this.dataset.productUrl, title: document.title })
                      .then(() => {
                          console.log("Thanks for sharing!");
                      })
                      .catch(console.error);
              }))
            : (this.noneWebShareApiContainer.removeAttribute("hidden"),
              this.webShareApiContainer.setAttribute("hidden", !0),
              this.copyLinkButton.addEventListener("click", (e) => {
                  this.copyToClipboard(e.currentTarget);
              }));
    }
    copyToClipboard(e) {
        navigator.clipboard.writeText(this.dataset.productUrl).then(() => {
            e.querySelector(".js-social-share-copy-link-label").textContent = e.dataset.linkCopiedToClipboard;
        });
    }
}
customElements.define("sht-share-prd-btn", SHTShareProductButton);
class SHTCollapsibleRegion extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.triggers = this.$$(".js-collapsible-region-trigger")),
            (this.contents = this.$$(".js-collapsible-region-content")),
            (this.bodyWidth = document.body.clientWidth),
            (this.isCollapsibleOnDesktop = this.properties.isCollapsibleOnDesktop),
            (this.isCollapsibleOnMobile = this.properties.isCollapsibleOnMobile),
            this.init(),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.isCollapsibleOnDesktop && this.isCollapsibleOnMobile) ||
            window.addEventListener("resize", (e) => {
                (this.bodyWidth = Math.floor(document.body.clientWidth)), this.init();
            }),
            this.triggers.forEach((e) => {
                e.addEventListener("click", (e) => {
                    this.onTriggerClick(e.currentTarget);
                });
            });
    }
    init() {
        ((!this.isCollapsibleOnDesktop && 769 < this.bodyWidth) ||
            (!this.isCollapsibleOnMobile && this.bodyWidth <= 769)) &&
            this.removeAriaProps(),
            ((this.isCollapsibleOnDesktop && 769 < this.bodyWidth) ||
                (this.isCollapsibleOnMobile && this.bodyWidth <= 769)) &&
                this.restoreAriaProps();
    }
    removeAriaProps() {
        this.triggers.forEach((e) => {
            (e.style.pointerEvents = "none"),
                e.setAttribute("tabindex", -1),
                e.removeAttribute("aria-controls"),
                e.removeAttribute("aria-expanded");
        }),
            this.contents.forEach((e) => {
                e.removeAttribute("aria-describedby"), e.removeAttribute("role"), e.removeAttribute("hidden");
            });
    }
    restoreAriaProps() {
        this.triggers.forEach((e) => {
            (e.style.pointerEvents = "auto"),
                e.setAttribute("aria-controls", this.properties.ariaControls),
                e.setAttribute("aria-expanded", "false"),
                e.removeAttribute("tabindex");
        }),
            this.contents.forEach((e) => {
                e.setAttribute("aria-describedby", this.properties.ariaDescribedby),
                    e.setAttribute("role", "region"),
                    e.setAttribute("hidden", "");
            });
    }
    onTriggerClick(e) {
        var t = "true" === e.getAttribute("aria-expanded");
        this.toggle(!t, e);
    }
    toggle(e, t) {
        t.setAttribute("aria-expanded", "" + e);
        var s = this.$("#" + t.getAttribute("aria-controls"));
        e
            ? (t.classList.add("open"), s.removeAttribute("hidden"))
            : (t.classList.remove("open"), s.setAttribute("hidden", ""));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
}
customElements.define("sht-clps-rgn", SHTCollapsibleRegion);
class SHTQuantityInput extends SHTCustomComponent {
    constructor() {
        super(),
            (this.input = this.$(".js-quantity-input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.$$(".js-quantity-btn").forEach((e) =>
                e.addEventListener("click", this.onButtonClickHandler.bind(this))
            );
    }
    onButtonClickHandler(e) {
        e.preventDefault();
        var t = this.input.value;
        "plus" === e.currentTarget.dataset.name ? this.input.stepUp() : this.input.stepDown(),
            t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define("sht-qty-inp", SHTQuantityInput);
class SHTAccordion extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = this.dataset.properties ? JSON.parse(this.dataset.properties) : {}),
            (this.accordionItems = this.$$(".js-accordion-item")),
            (this.accordionTriggers = this.$$(".js-accordion-trigger")),
            (this.accordionTrigger = this.$(".js-accordion-trigger")),
            (this.accordionContents = this.$$(".js-accordion-content")),
            this.bindEventHandlers();
    }
    connectedCallback() {
        this.properties &&
            this.properties.default_open &&
            (!this.properties.multiple && this.accordionTrigger
                ? this.toggle(!0, this.accordionTrigger)
                : this.accordionTriggers &&
                  this.accordionTriggers.length &&
                  this.accordionTriggers.forEach((e) => this.toggle(!0, e)));
    }
    bindEventHandlers() {
        this.accordionTriggers.forEach((e) => {
            e.addEventListener("click", (e) => {
                e.preventDefault(), this.onTriggerClick(e.currentTarget);
            });
        });
    }
    onTriggerClick(e) {
        var t = "true" === e.getAttribute("aria-expanded");
        this.properties.multiple || this.toggleAll(), this.toggle(!t, e);
    }
    toggle(e, t) {
        t.setAttribute("aria-expanded", "" + e), e ? t.classList.add("open") : t.classList.remove("open");
        t = this.$("#" + t.getAttribute("aria-controls"));
        e
            ? (t.classList.add("open"), (t.style.maxHeight = this.calculateMaxHeightContent(t) + "px"))
            : (t.classList.remove("open"), (t.style.maxHeight = "0px"));
    }
    open() {
        this.toggle(!0);
    }
    close() {
        this.toggle(!1);
    }
    toggleAll() {
        this.accordionTriggers.forEach((e) => {
            e.setAttribute("aria-expanded", "false"), e.classList.remove("open");
        }),
            this.accordionContents.forEach((e) => {
                e.classList.remove("open"), (e.style.maxHeight = "0px");
            });
    }
    calculateMaxHeightContent(e) {
        return e.scrollHeight;
    }
}
customElements.define("sht-accordion", SHTAccordion);
class SHTLazyLoadingVideo extends SHTCustomComponent {
    constructor() {
        super(), (this.video = this.$("iframe")), (this.isLoaded = !1), (this.isPlaying = !1), this.addObserver();
    }
    loadVideo() {
        var e;
        this.video &&
            !this.isLoaded &&
            (this.video.setAttribute("src", this.video.getAttribute("data-src")),
            (this.isLoaded = !0),
            this.video.addEventListener("load", () => {
                this.dispatchEvent(new CustomEvent("loadingEnd", { detail: { ele: this.video, parent: this } }));
            })),
            "local_video" != this.dataVideoType ||
                this.isLoaded ||
                ((this.local_video = this.$("video")),
                this.local_video &&
                    ((e = this.local_video.querySelector("source").getAttribute("data-src")),
                    (this.local_video.src = e)),
                (this.isLoaded = !0));
    }
    playVideo() {
        !this.isPlaying &&
            this.isLoaded &&
            ("youtube" == this.dataVideoType
                ? this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
                : "vimeo" == this.dataVideoType
                  ? this.video.contentWindow.postMessage('{"method":"play"}', "*")
                  : "local_video" == this.dataVideoType && this.local_video?.play(),
            (this.isPlaying = !0));
    }
    execute() {
        this.addObserver();
    }
    addObserver() {
        new IntersectionObserver(
            (e) => {
                e.forEach((e) => {
                    e.isIntersecting
                        ? (this.loadVideo(), this.playVideo())
                        : (this.pauseVideo(), (this.isPlaying = !1));
                });
            },
            { rootMargin: "0px 0px 200px 0px" }
        ).observe(this);
    }
    pauseVideo() {
        this.isPlaying &&
            (this.$(".js-media-item-youtube")?.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                "*"
            ),
            this.$(".js-media-item-vimeo")?.contentWindow.postMessage('{"method":"pause"}', "*"),
            this.$(".js-media-item-video")?.pause(),
            (this.isPlaying = !1));
    }
    static get observedAttributes() {
        return ["data-video-type", "data-video-id"];
    }
    set dataVideoType(e) {
        this.setAttribute("data-video-type", e);
    }
    get dataVideoType() {
        return this.getAttribute("data-video-type");
    }
    set dataVideoId(e) {
        this.setAttribute("data-video-id", e);
    }
    get dataVideoId() {
        return this.getAttribute("data-video-id");
    }
    attributeChangedCallback(e, t, s) {
        t !== s && this.execute();
    }
    connectedCallback() {
        this.execute();
    }
    disconnectedCallback() {}
}
customElements.define("sht-load-video", SHTLazyLoadingVideo);
class SHTTabs extends SHTCustomComponent {
    constructor() {
        super(),
            (this.tabLinks = this.$$(".js-tab-link")),
            (this.tabPanels = this.$$(".js-tab-panel")),
            (this.tabHeader = this.$(".js-mega-menu-drawer-tabs-header")),
            (this.tabHeaderWrap = this.$(".js-drawer-tabs-header")),
            (this.isRTL = SHTHelper.isRTL),
            this.bindEventHandlers(),
            this.initializeDragToSlide(),
            this.initializeOnLoad();
    }
    initializeOnLoad() {
        var e, t;
        this.tabLinks &&
            0 < this.tabLinks.length &&
            (e = this.$(".js-tab-link.tab__link--active") || this.tabLinks[0]) &&
            ((t = e.getAttribute("href")) && t.includes("#") && this.tabLinkEventHandler(e),
            this.tabPanelMegaMenuPromotionEventHandler(e)),
            this.updateHeaderMasks();
    }
    bindEventHandlers() {
        this.tabLinks?.forEach((s) => {
            s.addEventListener("click", (e) => {
                var t;
                this.dragBlockUntil && Date.now() < this.dragBlockUntil
                    ? e.preventDefault()
                    : ((t = s.getAttribute("href")),
                      this.classList.contains("js-mega-menu-drawer-tabs") && this.tabHeader && this.revealInHeader(s),
                      t && t.includes("#")
                          ? (e.preventDefault(),
                            this.tabLinkEventHandler(s),
                            this.tabPanelMegaMenuPromotionEventHandler(s))
                          : this.classList.contains("js-mega-menu-drawer-tabs") &&
                            this.tabHeader &&
                            (this.isElementFullyVisibleInContainer(s, this.tabHeader) ||
                                (e.preventDefault(),
                                this.scrollTabHeaderTo(s).then(() => {
                                    try {
                                        s.focus({ preventScroll: !0 });
                                    } catch (e) {}
                                    var e = s.getAttribute("href"),
                                        t = s.getAttribute("target");
                                    e &&
                                        !e.includes("#") &&
                                        ("_blank" === t ? window.open(e, "_blank") : (window.location.href = e));
                                }))));
            });
        }),
            this.tabHeader &&
                (this.tabHeader.addEventListener("scroll", () => this.updateHeaderMasks(), { passive: !0 }),
                window.addEventListener("resize", () => this.updateHeaderMasks()),
                setTimeout(() => this.updateHeaderMasks(), 0));
    }
    initializeDragToSlide() {
        this.tabHeader &&
            ((this.isPointerDown = !1),
            (this.isDragging = !1),
            (this.hasMoved = !1),
            (this.dragPointerType = "mouse"),
            (this.dragBlockUntil = 0),
            (this.dragStartX = 0),
            (this.dragStartScrollLeft = 0),
            (this.dragThreshold = 10),
            (this.onDragStart = (e) => {
                ("mouse" === e.pointerType && 0 !== e.button) ||
                    ((this.isPointerDown = !0),
                    (this.isDragging = !1),
                    (this.hasMoved = !1),
                    (this.dragPointerType = e.pointerType || "mouse"),
                    (this.dragStartX = e.clientX),
                    (this.dragStartScrollLeft = this.tabHeader.scrollLeft),
                    "mouse" === this.dragPointerType &&
                        ((this.tabHeader.style.cursor = "grabbing"), (this.tabHeader.style.userSelect = "none")));
            }),
            (this.onDragMove = (e) => {
                if (this.isPointerDown) {
                    var t = e.clientX - this.dragStartX;
                    if (
                        Math.abs(t) > this.dragThreshold &&
                        ((this.hasMoved = !0), "mouse" === this.dragPointerType) &&
                        !this.isDragging
                    ) {
                        this.isDragging = !0;
                        try {
                            this.tabHeader.setPointerCapture(e.pointerId);
                        } catch (e) {}
                        this.tabHeader.classList.add("is-dragging");
                    }
                    if ("mouse" === this.dragPointerType && this.isDragging) {
                        try {
                            e.preventDefault();
                        } catch (e) {}
                        this.tabHeader.scrollLeft = this.dragStartScrollLeft + -t;
                    }
                }
            }),
            (this.onDragEnd = (e) => {
                if (this.isPointerDown) {
                    if ("mouse" === this.dragPointerType && this.isDragging) {
                        try {
                            this.tabHeader.releasePointerCapture(e.pointerId);
                        } catch (e) {}
                        this.tabHeader.classList.remove("is-dragging"),
                            (this.tabHeader.style.cursor = ""),
                            (this.tabHeader.style.userSelect = "");
                    }
                    this.hasMoved && (this.dragBlockUntil = Date.now() + 200),
                        (this.isPointerDown = !1),
                        (this.isDragging = !1),
                        this.updateHeaderMasks();
                }
            }),
            this.tabHeader.addEventListener("pointerdown", this.onDragStart),
            this.tabHeader.addEventListener("pointermove", this.onDragMove),
            this.tabHeader.addEventListener("pointerup", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("pointercancel", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("pointerleave", this.onDragEnd, { passive: !0 }),
            this.tabHeader.addEventListener("dragstart", (e) => {
                try {
                    e.preventDefault();
                } catch (e) {}
            }));
    }
    isElementFullyVisibleInContainer(e, t) {
        return (
            !e ||
            !t ||
            ((e = e.getBoundingClientRect()), (t = t.getBoundingClientRect()), e.left >= t.left && e.right <= t.right)
        );
    }
    scrollTabHeaderTo(e) {
        if (!this.tabHeader || !e) return Promise.resolve();
        const r = this.tabHeader;
        let o;
        var t, s, i, n;
        return (
            (o = this.isRTL
                ? ((t = r.scrollWidth),
                  (s = r.clientWidth),
                  (i = e.getBoundingClientRect()),
                  (n = r.getBoundingClientRect()),
                  (i = i.left - n.left + e.clientWidth / 2),
                  (n = r.clientWidth / 2),
                  (o = r.scrollLeft + (i - n)),
                  (i = "scrollLeftMax" in r ? -r.scrollLeftMax : -(t - s)),
                  Math.max(i, Math.min(0, o)))
                : ((o = Math.max(0, e.offsetLeft - (r.clientWidth - e.clientWidth) / 2)),
                  (n = r.scrollWidth - r.clientWidth),
                  Math.min(o, n))),
            new Promise((s) => {
                const i = Date.now(),
                    n = () => {
                        var e = Math.abs(r.scrollLeft - o) < 2,
                            t = 700 < Date.now() - i;
                        e || t ? s() : requestAnimationFrame(n);
                    };
                requestAnimationFrame(n), r.scrollTo({ left: o, behavior: "smooth" });
            })
        );
    }
    revealInHeader(e) {
        this.tabHeader &&
            e &&
            (this.isElementFullyVisibleInContainer(e, this.tabHeader) || this.scrollTabHeaderTo(e),
            this.updateHeaderMasks());
    }
    updateHeaderMasks() {
        if (this.tabHeader && this.tabHeaderWrap) {
            let e, t;
            var s = this.tabHeader.scrollLeft,
                i = this.tabHeader.scrollWidth,
                n = this.tabHeader.clientWidth,
                r = i - n;
            (t = this.isRTL
                ? ((e =
                      "scrollLeftMax" in this.tabHeader
                          ? Math.abs(s) >= Math.abs(this.tabHeader.scrollLeftMax) - 1
                          : Math.abs(s) >= r - 1),
                  -1 <= s)
                : ((e = Math.floor(s) <= 0), Math.ceil(s + n) >= i - 1)),
                this.tabHeaderWrap.classList.toggle("is-at-start", e),
                this.tabHeaderWrap.classList.toggle("is-at-end", t);
        }
    }
    tabPanelMegaMenuPromotionEventHandler(e) {
        if (this.classList.contains("js-mega-menu-drawer-tabs")) {
            var t = e.getAttribute("href")?.replace("#", ""),
                t = this.$(`[data-tab-content-id="${t}"]`),
                s = this.closest(".js-drawer-wrapper");
            if (t && s) {
                "true" === t.getAttribute("data-mega-menu-promotion")
                    ? s.classList.add("have-promo")
                    : s.classList.remove("have-promo");
                const i = () => {
                    this.tabHeader && this.revealInHeader(e);
                };
                try {
                    requestAnimationFrame(() => requestAnimationFrame(i));
                } catch (e) {
                    setTimeout(i, 0);
                }
                try {
                    s.addEventListener(
                        "transitionend",
                        (e) => {
                            ("width" !== e.propertyName &&
                                "flex-basis" !== e.propertyName &&
                                "max-width" !== e.propertyName) ||
                                i();
                        },
                        { once: !0 }
                    );
                } catch (e) {}
            }
        }
    }
    tabLinkEventHandler(e) {
        var t = e.getAttribute("href"),
            t = t && t.startsWith("#") ? t.slice(1) : t,
            t =
                (this.tabPanels?.forEach((e) => {
                    e.classList.remove("d-block", "tab__panel--active"), e.classList.add("d-none");
                }),
                this.tabLinks.forEach((e) => {
                    e.classList.remove("tab__link--active");
                }),
                this.$(`[data-tab-content-id="${t}"]`));
        t && (t.classList.remove("d-none"), t.classList.add("d-block", "tab__panel--active")),
            e.classList.add("tab__link--active");
    }
}
customElements.define("sht-tabs", SHTTabs);
class SHTLoadMedia extends SHTCustomComponent {
    constructor() {
        super(),
            (this.trigger = this.$(".js-load-media-trigger")),
            this.trigger.addEventListener("click", (e) => this.loadMedia());
    }
    loadMedia(e = !0, t = !0) {
        if ((this.pauseAllVideo(), !this.getAttribute("loaded"))) {
            const i = document.createElement("div");
            (i.className = "p-absolute center-middle"),
                (i.innerHTML =
                    '<span class="btn btn-secondary btn-large btn-icon"><svg class="icon-spinner" style="animation: spin 1s linear infinite;" width="20" height="20" viewBox="0 0 20 20"><path d="M10 3.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm0 11a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" fill="currentColor"/></svg></span>'),
                document.getElementById("sht-video-loader-styles") ||
                    (((s = document.createElement("style")).id = "sht-video-loader-styles"),
                    (s.textContent =
                        "@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }"),
                    document.head.appendChild(s));
            var s = this.trigger.querySelector(".js-btn-play"),
                s = (s && (s.classList.add("opacity-0"), this.trigger.appendChild(i)), document.createElement("div"));
            s.appendChild(this.$("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            const n = s.querySelector("video, iframe");
            (this.trigger.style.transition = "opacity 0.3s ease-out"),
                n.classList.add("p-absolute", "inset", "opacity-0"),
                (n.style.transition = "opacity 0.3s ease-in"),
                this.appendChild(n),
                "VIDEO" === n.tagName
                    ? (n.addEventListener("loadeddata", () => {
                          this.onMediaReady(n, e, t, i);
                      }),
                      n.load())
                    : "IFRAME" === n.tagName &&
                      n.addEventListener("load", () => {
                          setTimeout(() => {
                              this.onMediaReady(n, e, t, i);
                          }, 500);
                      });
        }
    }
    onMediaReady(e, t, s, i) {
        i && i.parentNode && i.remove(),
            (e.style.opacity = "1"),
            s &&
                ((this.trigger.style.opacity = "0"),
                setTimeout(() => {
                    this.trigger.classList.replace("d-block", "d-none"), (e.style.position = "relative");
                }, 300)),
            t && e.focus();
    }
    pauseAllVideo() {
        SHTHelper.qsa(".js-media-item-youtube").forEach((e) => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }),
            SHTHelper.qsa(".js-media-item-vimeo").forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            }),
            SHTHelper.qsa(".js-media-item-video").forEach((e) => e.pause());
    }
}
customElements.define("sht-load-media", SHTLoadMedia);
class SHTAnnouncementBar extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.items = this.$$(".js-anmb-item")),
            (this.container = this.$(".js-anmb-items")),
            (this.linkItems = this.$$(".js-anmb-link-items")),
            (this.totalItems = this.items.length),
            (this.previousButton = this.$(".js-anmb-control-prev")),
            (this.nextButton = this.$(".js-anmb-control-next")),
            (this.props = JSON.parse(this.dataset.props)),
            (this.delayTime = this.props.duration),
            (this.interval = null),
            (this.currentItemIndex = 1),
            (this.lastScrollTimeout = null),
            (this.messages = this.container.children),
            (this.isScrolling = !1),
            (this.isRTL = SHTHelper.isRTL),
            this.bindEventHandlers(),
            this.updateSort(),
            this.autoPlay();
    }
    connectedCallback() {
        this.init();
    }
    updateSort() {
        var e, t, s, i;
        this.totalItems <= 1 ||
            ((this.isScrolling = !0),
            (e = this.container.scrollLeft),
            (t = Math.round(e)),
            (s = this.container.offsetWidth),
            (i = this.container.scrollWidth),
            this.isRTL
                ? (Math.abs(t) < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = t - s)),
                  Math.floor(i + e) <= s &&
                      (this.container.append(this.messages[0]), (this.container.scrollLeft = t + s)))
                : (t < s &&
                      (this.container.prepend(this.messages[this.totalItems - 1]), (this.container.scrollLeft = t + s)),
                  Math.floor(i - e) <= s &&
                      (this.container.append(this.messages[0]), (this.container.scrollLeft = t - s))),
            (this.isScrolling = !1));
    }
    onScrollEventHandle(e) {
        this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            ));
    }
    bindEventHandlers() {
        this.previousButton.addEventListener(
            "click",
            SHTHelper.debounce(this.onPrevButtonClickHandler.bind(this), 300)
        ),
            this.nextButton.addEventListener(
                "click",
                SHTHelper.debounce(this.onNextButtonClickHandler.bind(this), 300)
            ),
            this.onObserverHandler(),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100)),
            this.container.addEventListener(
                "wheel",
                function (e) {
                    SHTHelper.debounce(this.resetAutoPlay.bind(this), 0);
                }.bind(this),
                { passive: !0 }
            );
    }
    onPrevButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let e;
            this.isRTL
                ? ((e = this.currentItemIndex + 1), this.currentItemIndex == this.totalItems && (e = 1))
                : ((e = this.currentItemIndex - 1), 1 == this.currentItemIndex && (e = this.totalItems));
            var t = this.$(`div[data-item-index="${e}"]`);
            this.container.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
        }
    }
    onNextButtonClickHandler() {
        if (!this.isScrolling) {
            (this.isScrolling = !0), this.resetAutoPlay();
            let e;
            this.isRTL
                ? ((e = this.currentItemIndex - 1), 1 == this.currentItemIndex && (e = this.totalItems))
                : ((e = this.currentItemIndex + 1), this.currentItemIndex == this.totalItems && (e = 1));
            var t = this.$(`div[data-item-index="${e}"]`);
            this.container.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
        }
    }
    onMouseOverHandle(e) {
        this.clearDismissInterval();
    }
    onMouseOutHandle(e) {
        this.setDismissInterval();
    }
    clearDismissInterval() {
        this.interval && clearInterval(this.interval);
    }
    setDismissInterval() {
        this.interval = setInterval(
            function () {
                this.isRTL ? this.onPrevButtonClickHandler() : this.onNextButtonClickHandler();
            }.bind(this),
            this.delayTime
        );
    }
    resetAutoPlay() {
        !this.props.autoPlay ||
            this.totalItems < 2 ||
            (this.clearDismissInterval(),
            setTimeout(() => {
                this.setDismissInterval();
            }));
    }
    autoPlay() {
        !this.props.autoPlay || this.totalItems < 2
            ? (this.clearDismissInterval(), this.container.setAttribute("aria-live", "polite"))
            : (this.container.addEventListener("mouseover", this.onMouseOverHandle.bind(this)),
              this.container.addEventListener("mouseout", this.onMouseOutHandle.bind(this)),
              this.container.setAttribute("aria-live", "off"),
              this.setDismissInterval());
    }
    onObserverHandler() {
        let t = new IntersectionObserver(
            (e, t) => {
                e.forEach((t) => {
                    if (t.isIntersecting) {
                        let e = t.target;
                        this.linkItems.forEach((e) => {
                            e.setAttribute("tabindex", "-1");
                        }),
                            window.requestAnimationFrame(() => {
                                var e = this.$(".anmb-item--active");
                                e && (e.classList.remove("anmb-item--active"), e.setAttribute("aria-hidden", "true"));
                            }),
                            (this.currentItemIndex = parseInt(e.dataset.itemIndex)),
                            e.setAttribute("aria-hidden", "false"),
                            window.requestAnimationFrame(() => e.classList.add("anmb-item--active"));
                        t = e.querySelector(".js-anmb-link-items");
                        t && t.removeAttribute("tabindex");
                    }
                });
            },
            { root: this.container, rootMargin: "0px", threshold: 0.5 }
        );
        this.items.forEach((e) => {
            t.observe(e);
        });
    }
}
customElements.define("sht-ann-bar", SHTAnnouncementBar);
class SHTPopup extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = JSON.parse(this.dataset.props)),
            (this.myStorage = window.sessionStorage),
            (this.sessionStorageName = Shopify.theme.name.toLowerCase() + "-popup-display"),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.isOpen = !1),
            (this.buffer = 100),
            (this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0),
            (this.myWindowHeight = window.innerHeight || SHTHelper.qde.clientHeight || 0),
            (this.elms = { close_btn: this.$(".js-popup-close-btn"), body: SHTHelper.qs("body") }),
            (this.triggerOn = this.properties.triggerOn),
            (this.scrollEventHandle = this.onScrollEventHandle.bind(this)),
            (this.onLoadUserAction = this.onUserAction.bind(this)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.elms.close_btn.addEventListener("click", this.onCloseBtnClickHandle.bind(this)),
            window.addEventListener("scroll", this.scrollEventHandle),
            this.cartNotification &&
                "after-closing-cart-notification" === this.triggerOn &&
                this.cartNotification.addEventListener("closed", (e) => {
                    this.getPopupStatus() || this.togglePopup(!0);
                }),
            ["mouseover"].forEach(
                function (e) {
                    SHTHelper.qs("body").addEventListener(e, this.onLoadUserAction);
                }.bind(this)
            ),
            this.popupAttrObserve();
    }
    onUserAction(e) {
        this.classList.contains("d-none") && this.classList.remove("d-none"),
            e.currentTarget.removeEventListener(e.type, this.onLoadUserAction);
    }
    onScrollEventHandle(e) {
        var t, s;
        "reaching-to-footer" !== this.triggerOn
            ? window.removeEventListener("scroll", this.scrollEventHandle)
            : ((this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0),
              (t =
                  (window.pageYOffset || SHTHelper.qde.scrollTop || document.body.scrollTop || 0) +
                      this.buffer +
                      this.myWindowHeight >=
                  this.myScrollHeight),
              (s = this.getPopupStatus()),
              "reaching-to-footer" !== this.triggerOn ||
                  !t ||
                  (null !== this.getAttribute("open") && "" !== this.getAttribute("open")) ||
                  s ||
                  this.togglePopup(!0));
    }
    togglePopup(e) {
        var t = this.$(".js-success");
        e && !t ? this.toggleOpen(!0) : (this.toggleOpen(!1), this.setPopupStatus());
    }
    toggleOpen(e) {
        e
            ? (this.elms.body.classList.add("is-popup-show"), this.setAttribute("open", !0))
            : (this.elms.body.classList.remove("is-popup-show"),
              this.removeAttribute("open"),
              SHTHelper.removeTrapFocus());
    }
    onCloseBtnClickHandle(e) {
        e.preventDefault(), this.togglePopup(!1);
    }
    setPopupStatus() {
        this.myStorage.setItem(this.sessionStorageName, !1);
    }
    getPopupStatus() {
        return Shopify.designMode ? "" : this.myStorage.getItem(this.sessionStorageName);
    }
    popupAttrObserve() {
        new MutationObserver((e, t) => {
            e.forEach(async (e) => {
                "open" == e.attributeName &&
                    (this.hasAttribute("open")
                        ? (await this.animationsComplete(),
                          this.dispatchEvent(new Event("opened")),
                          SHTHelper.trapFocus(this))
                        : (SHTHelper.removeTrapFocus(),
                          await this.animationsComplete(),
                          this.dispatchEvent(new Event("closed"))));
            });
        }).observe(this, { attributes: !0 });
    }
    animationsComplete() {
        return Promise.allSettled(this.getAnimations().map((e) => e.finished));
    }
}
customElements.define("sht-popup", SHTPopup);
class SHTSlideShow extends SHTCustomComponent {
    constructor() {
        super(),
            (this.slideshow = this.$(".js-slideshow")),
            (this.slideshowItems = this.$(".js-slideshow-items")),
            (this.totalElm = this.$(".js-slideshow-total")),
            (this.currentElm = this.$(".js-slideshow-current")),
            (this.separatorElm = this.$(".js-slideshow-separator")),
            (this.prevBtn = this.$(".js-slideshow-prev-btn")),
            (this.nextBtn = this.$(".js-slideshow-next-btn")),
            (this.startNStopBtn = this.$(".js-slideshow-start-n-stop-btn")),
            (this.imageItems = this.$$(".js-slideshow-image")),
            (this.pauseIcon = this.startNStopBtn.querySelector(".js-slideshow-pause-icon")),
            (this.playIcon = this.startNStopBtn.querySelector(".js-slideshow-play-icon")),
            (this.properties = JSON.parse(this.dataset.slideshowProperties)),
            (this.autoplay = this.properties.autoplay || !1),
            (this.image = null),
            (this.template = null),
            (this.current = 1),
            (this.anchors = []),
            (this.lastScrollTimeout = null),
            (this.autoplayInterval = null),
            (this.images = this.slideshowItems.children),
            (this.total = this.images.length),
            (this.slideshowItems.scrollLeft = 0),
            (this.observer = null),
            (this.isPaused = !1),
            (this.isRTL = SHTHelper.isRTL),
            (this.isDragging = !1),
            (this.dragStartX = 0),
            (this.dragCurrentX = 0),
            (this.dragStartScrollLeft = 0),
            (this.dragThreshold = 10),
            (this.totalDragDistance = 0),
            (this.dragStartTime = 0),
            (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            (this.draggedLinks = new Set());
    }
    cloneSlideItem() {
        var e, t;
        2 == this.total &&
            ((e = this.slideshowItems.querySelector(".js-slideshow-item:first-of-type")),
            (t = this.slideshowItems.querySelector(".js-slideshow-item:last-of-type")) &&
                ((t = t.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(t)),
            e) &&
            ((t = e.cloneNode(!0)).classList.add("slider-slide--clone"), this.slideshowItems.append(t));
    }
    execute() {
        this.total <= 1 ||
            (this.cloneSlideItem(), this.prepare(), this.bindEventHandlers(), this.initDragToSlide(), this.init());
    }
    connectedCallback() {
        this.execute();
    }
    init() {
        this.autoplay && (this.resumeAutoPlay(), (this.isPaused = !0)), this.updateSort();
    }
    updateSort() {
        var e, t, s, i;
        this.total <= 1 ||
            ((e = this.slideshowItems.scrollLeft),
            (t = Math.round(e)),
            (s = this.slideshowItems.offsetWidth),
            (i = this.slideshowItems.scrollWidth),
            this.isRTL
                ? (Math.abs(t) < s &&
                      (this.slideshowItems.prepend(this.images[this.total - 1]),
                      (this.slideshowItems.scrollLeft = t - s)),
                  Math.floor(i + e) <= s &&
                      (this.slideshowItems.append(this.images[0]), (this.slideshowItems.scrollLeft = t + s)))
                : (t < s &&
                      (this.slideshowItems.prepend(this.images[this.total - 1]),
                      (this.slideshowItems.scrollLeft = t + s)),
                  Math.floor(i - e) <= s &&
                      (this.slideshowItems.append(this.images[0]), (this.slideshowItems.scrollLeft = t - s))));
    }
    initDragToSlide() {
        this.total <= 1 ||
            (this.updateDesktopDetection(),
            window.addEventListener("resize", () => {
                this.updateDesktopDetection();
            }),
            this.isDesktop && this.bindDragEventHandlers());
    }
    updateDesktopDetection() {
        var e = this.isDesktop;
        (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
            e && !this.isDesktop
                ? (this.cleanupLinkPrevention(), this.slideshowItems.classList.remove("slideshow--dragging"))
                : !e && this.isDesktop && this.bindDragEventHandlers();
    }
    bindDragEventHandlers() {
        this.slideshowItems.addEventListener("mousedown", this.onDragStart.bind(this)),
            document.addEventListener("mousemove", this.onDragMove.bind(this)),
            document.addEventListener("mouseup", this.onDragEnd.bind(this)),
            this.slideshowItems.addEventListener("mouseleave", this.onDragCancel.bind(this)),
            this.slideshowItems.addEventListener("dragstart", (e) => e.preventDefault());
    }
    onDragStart(e) {
        this.isDesktop &&
            0 === e.button &&
            ((this.isDragging = !0),
            (this.dragStartX = e.clientX),
            (this.dragCurrentX = e.clientX),
            (this.dragStartScrollLeft = this.slideshowItems.scrollLeft),
            (this.totalDragDistance = 0),
            (this.dragStartTime = Date.now()),
            this.autoplay && this.stopAutoPlay(),
            this.slideshowItems.classList.add("slideshow--dragging"),
            (document.body.style.userSelect = "none"),
            e.preventDefault());
    }
    onDragMove(t) {
        if (this.isDragging) {
            this.dragCurrentX = t.clientX;
            let e;
            (e = this.isRTL ? this.dragCurrentX - this.dragStartX : this.dragStartX - this.dragCurrentX),
                (this.totalDragDistance = Math.abs(e)),
                this.totalDragDistance > this.dragThreshold && this.preventLinksInCurrentSlide();
        }
    }
    onDragEnd(e) {
        if (this.isDragging) {
            this.isDragging = !1;
            let e;
            e = this.isRTL ? this.dragCurrentX - this.dragStartX : this.dragStartX - this.dragCurrentX;
            var t = this.slideshowItems.offsetWidth,
                t = Math.abs(e) / t,
                s = Date.now() - this.dragStartTime,
                s = this.totalDragDistance / s,
                t =
                    (this.slideshowItems.classList.remove("slideshow--dragging"),
                    (document.body.style.userSelect = ""),
                    0.1 < t || (0.3 < s && 30 < this.totalDragDistance));
            t && this.totalDragDistance > this.dragThreshold && this.performSlideTransition(0 < e ? "next" : "prev"),
                setTimeout(() => {
                    this.cleanupLinkPrevention();
                }, 500);
        }
    }
    performSlideTransition(t) {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft =
                      "next" === t
                          ? this.slideshowItems.scrollLeft - this.slideshow.scrollWidth
                          : this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft =
                      "next" === t
                          ? this.slideshowItems.scrollLeft + this.slideshow.scrollWidth
                          : this.slideshowItems.scrollLeft - this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e &&
                (e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft =
                              "next" === t
                                  ? this.slideshowItems.scrollLeft - this.slideshow.scrollWidth
                                  : this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              "next" === t
                                  ? this.slideshowItems.scrollLeft + this.slideshow.scrollWidth
                                  : this.slideshowItems.scrollLeft - this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400));
        }
    }
    onDragCancel() {
        this.isDragging &&
            ((this.isDragging = !1),
            this.slideshowItems.classList.remove("slideshow--dragging"),
            (document.body.style.userSelect = ""),
            setTimeout(() => {
                this.cleanupLinkPrevention();
            }, 100));
    }
    preventLinksInCurrentSlide() {
        var e = this.getCurrentSlide();
        e &&
            e.querySelectorAll(".js-slideshow-link").forEach((e) => {
                this.draggedLinks.has(e) ||
                    (e.addEventListener("click", this.preventLinkClick, !0), this.draggedLinks.add(e));
            });
    }
    preventLinkClick(e) {
        e.preventDefault(), e.stopPropagation();
    }
    cleanupLinkPrevention() {
        this.draggedLinks.forEach((e) => {
            e.removeEventListener("click", this.preventLinkClick, !0);
        }),
            this.draggedLinks.clear();
    }
    getCurrentSlide() {
        return this.querySelector(".js-slideshow-image--current")?.closest(".js-slideshow-item");
    }
    startAutoPlay() {
        this.autoplay &&
            (this.autoplayInterval = setInterval(
                function () {
                    this.nextSlide();
                }.bind(this),
                this.properties.duration
            ));
    }
    bindEventHandlers() {
        this.slideshowItems.addEventListener(
            "wheel",
            function (e) {
                5 == Math.abs(e.deltaX) && this.stopAutoPlay();
            }.bind(this),
            { passive: !0 }
        ),
            this.slideshowItems.addEventListener(
                "scroll",
                SHTHelper.debounce(this.onScrollEventHandle.bind(this), 100)
            ),
            this.nextBtn.addEventListener(
                "click",
                function () {
                    this.nextSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.prevBtn.addEventListener(
                "click",
                function () {
                    this.prevSlide(), this.stopAutoPlay();
                }.bind(this)
            ),
            this.startNStopBtn.addEventListener("click", this.onStartNStopEventHandle.bind(this));
    }
    onStartNStopEventHandle(e) {
        e.preventDefault(), this.autoplay ? this.stopAutoPlay() : this.resumeAutoPlay();
    }
    stopAutoPlay() {
        clearInterval(this.autoplayInterval),
            this.pauseIcon.classList.add("d-none"),
            this.playIcon.classList.remove("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
            this.slideshowItems.setAttribute("aria-live", "polite"),
            (this.autoplay = !1);
    }
    resumeAutoPlay() {
        (this.autoplay = !0),
            this.pauseIcon.classList.remove("d-none"),
            this.playIcon.classList.add("d-none"),
            this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[1]),
            this.slideshowItems.setAttribute("aria-live", "off"),
            this.startAutoPlay();
    }
    onScrollEventHandle(e) {
        e.preventDefault(),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout),
            (this.lastScrollTimeout = setTimeout(
                function () {
                    this.updateSort();
                }.bind(this),
                100
            )),
            this.updateCurrent();
    }
    prepare() {
        (this.totalElm.textContent = this.total),
            (this.currentElm.textContent = this.current),
            (this.separatorElm.textContent = this.properties.separatorText),
            this.autoplay &&
                (this.startNStopBtn.toggleAttribute("hidden", !1),
                this.startNStopBtn.querySelector(".js-slideshow-pause-icon").classList.remove("d-none"),
                this.startNStopBtn.setAttribute("aria-label", this.properties.autoplayAccessibilityText[0]),
                this.slideshowItems.setAttribute("aria-live", "off"));
    }
    updateCurrent() {
        var e = this.$(".js-slideshow-image--current");
        e && (this.current = e.dataset.slideshowIndex), (this.currentElm.textContent = this.current);
    }
    prevSlide() {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e && e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              this.slideshowItems.scrollLeft - this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400);
        }
    }
    nextSlide() {
        if (Shopify.designMode)
            this.isRTL
                ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth)
                : (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft + this.slideshow.scrollWidth);
        else {
            let e = this.$(".js-slideshow-image--current").closest(".slider-slide--active");
            e && e.classList.add("slider-slide--active-blur"),
                setTimeout(() => {
                    this.isRTL
                        ? (this.slideshowItems.scrollLeft = this.slideshowItems.scrollLeft - this.slideshow.scrollWidth)
                        : (this.slideshowItems.scrollLeft =
                              this.slideshowItems.scrollLeft + this.slideshow.scrollWidth),
                        e.classList.remove("slider-slide--active-blur");
                }, 400);
        }
    }
    observerSlideShow() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting && (this.dataset.viewport = 1), this.observer.unobserve(this);
                });
            },
            { threshold: 0.15 }
        )),
            this.observer.observe(this);
    }
    disconnectedCallback() {
        this.isDesktop &&
            (document.removeEventListener("mousemove", this.onDragMove.bind(this)),
            document.removeEventListener("mouseup", this.onDragEnd.bind(this))),
            this.cleanupLinkPrevention(),
            this.autoplayInterval && clearInterval(this.autoplayInterval),
            this.lastScrollTimeout && clearTimeout(this.lastScrollTimeout);
    }
}
customElements.define("sht-slideshow", SHTSlideShow);
class SHTSlideshowLazyLoadingImage extends SHTCustomComponent {
    constructor() {
        super(),
            (this.picture = this.$(".js-slideshow-picture")),
            (this.image = this.picture ? this.picture.querySelector("img") : null),
            (this.spinner = this.$(".js-image-lazy-spinner")),
            (this.container = this.closest(".js-slideshow-items")),
            (this.currentItemClass = "js-slideshow-image--current"),
            (this.slideItem = this.closest(".js-slideshow-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.section = SHTHelper.qs("#shopify-section-" + this.sectionId)),
            (this.videoComponents = this.$$("sht-load-video")),
            (this.videoComponentDesktop = this.$(
                "sht-load-video.d-block-md, sht-load-video:not(.d-block):not(.d-none-md)"
            )),
            (this.videoComponentMobile = this.$("sht-load-video.d-block.d-none-md")),
            (this.isVideoSlide = 0 < this.videoComponents.length),
            (this.isImageSlide = !(!this.image && !this.picture)),
            (this.mediaQuery = window.matchMedia("(max-width: 767px)")),
            this.bindEventHandlers();
    }
    setSlideItemVisibility(e) {
        e
            ? (this.slideItem.setAttribute("aria-hidden", "false"),
              this.slideItem.removeAttribute("tabindex"),
              this.slideItem.classList.add("slider-slide--active"))
            : (this.slideItem.setAttribute("aria-hidden", "true"),
              this.slideItem.setAttribute("tabindex", "-1"),
              this.slideItem.classList.remove("slider-slide--active"));
    }
    observeContent(e) {
        var t = new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.target;
                    var t = this.parentNode;
                    e.isIntersecting && !this.getAttribute("loaded")
                        ? (this.isImageSlide && this.image && this.image.removeAttribute("loading"),
                          this.isVideoSlide && this.loadResponsiveVideo(),
                          this.setAttribute("loaded", !0),
                          t.classList.add(this.currentItemClass),
                          this.setSlideItemVisibility(!0))
                        : 0 == e.intersectionRatio
                          ? (t.classList.remove(this.currentItemClass), this.setSlideItemVisibility(!1))
                          : this.getAttribute("loaded") &&
                            (t.classList.add(this.currentItemClass), this.setSlideItemVisibility(!0));
                });
            },
            { root: this.container, rootMargin: "100px -2px 100px -2px", threshold: 0 }
        );
        this.isImageSlide && e ? t.observe(e) : this.isVideoSlide && t.observe(this);
    }
    loadResponsiveVideo() {
        var e = this.mediaQuery.matches;
        let t = null;
        e && this.videoComponentMobile
            ? (t = this.videoComponentMobile)
            : !e && this.videoComponentDesktop
              ? (t = this.videoComponentDesktop)
              : 0 < this.videoComponents.length && (t = this.videoComponents[0]),
            t && "function" == typeof t.loadVideo && t.loadVideo();
    }
    loadContent() {
        SHTSlideshowLazyLoadingImage.sharedResizeObserver ||
            ((SHTSlideshowLazyLoadingImage.sharedResizeObserver = new ResizeObserver(
                SHTHelper.debounce(() => {
                    SHTSlideshowLazyLoadingImage.instances.forEach((e) => {
                        e.handleResize();
                    });
                }, 100)
            )),
            (SHTSlideshowLazyLoadingImage.instances = new Set())),
            SHTSlideshowLazyLoadingImage.instances.add(this),
            1 === SHTSlideshowLazyLoadingImage.instances.size &&
                SHTSlideshowLazyLoadingImage.sharedResizeObserver.observe(document.body),
            this.handleResize();
    }
    handleResize() {
        var e;
        this.isImageSlide
            ? (e = this.image || this.picture) && this.observeContent(e)
            : this.isVideoSlide && (this.observeContent(), this.getAttribute("loaded")) && this.loadResponsiveVideo();
    }
    bindEventHandlers() {}
    execute() {
        this.loadContent();
    }
    connectedCallback() {
        this.execute();
    }
    disconnectedCallback() {
        SHTSlideshowLazyLoadingImage.instances &&
            (SHTSlideshowLazyLoadingImage.instances.delete(this), 0 === SHTSlideshowLazyLoadingImage.instances.size) &&
            (SHTSlideshowLazyLoadingImage.sharedResizeObserver?.disconnect(),
            (SHTSlideshowLazyLoadingImage.sharedResizeObserver = null));
    }
}
customElements.define("sht-slideshow-load-img", SHTSlideshowLazyLoadingImage);
class SHTSlideshowCTA extends SHTCustomComponent {
    constructor() {
        super(),
            (this.ctaButton = this.$$(".js-slideshow-cta")),
            (this.container = this.closest(".js-slideshow-items")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.observeItem();
    }
    observeItem() {
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting ? this.setCTAVisibility(!0) : this.setCTAVisibility(!1);
                });
            },
            { threshold: 0.25 }
        ).observe(this);
    }
    setCTAVisibility(s) {
        this.ctaButton.forEach((e, t) => {
            s
                ? (e.removeAttribute("tabindex"), e.setAttribute("aria-hidden", "false"))
                : (e.setAttribute("tabindex", "-1"), e.setAttribute("aria-hidden", "true"));
        });
    }
}
customElements.define("sht-slideshow-cta", SHTSlideshowCTA);
class SHTHotSpotTooltip extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        (this.tooltip_content = this.$(".js-tooltip-content")),
            (this.tooltip_contents = this.$$(".js-tooltip-content")),
            (this.tooltip_placeholders = this.$$(".js-tooltip-placeholder")),
            (this.tooltip_container = SHTHelper.qs("#" + this.dataset.containerId)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        for (let e = 0, t = this.tooltip_placeholders.length; e < t; e++) {
            var s = this.tooltip_placeholders[e];
            s.addEventListener("mouseover", (e) => {
                this.handleToolTipContentPosition(e);
            }),
                s.addEventListener("mouseout", (e) => {
                    for (let e = 0, t = this.tooltip_contents.length; e < t; e++)
                        this.tooltip_contents[e].classList.remove(
                            "hotspot-content--right",
                            "hotspot-content--left",
                            "hotspot-content--top",
                            "hotspot-content--bottom",
                            "hotspot-content--show"
                        );
                });
        }
    }
    handleToolTipContentPosition(e) {
        var e = e.currentTarget,
            t = e.querySelector(".js-tooltip-content"),
            s = Math.round(e.offsetLeft + t.offsetWidth + e.offsetWidth),
            i = Math.round(e.offsetTop + t.offsetHeight + e.offsetHeight);
        0 <= e.offsetLeft && e.offsetLeft < this.tooltip_container.offsetWidth && s < this.tooltip_container.offsetWidth
            ? t.classList.add("hotspot-content--right", "hotspot-content--show")
            : 0 <= e.offsetLeft &&
              e.offsetLeft < this.tooltip_container.offsetWidth &&
              s >= this.tooltip_container.offsetWidth &&
              t.classList.add("hotspot-content--left", "hotspot-content--show"),
            0 <= e.offsetTop &&
            e.offsetTop < this.tooltip_container.offsetHeight &&
            i < this.tooltip_container.offsetHeight
                ? t.classList.add("hotspot-content--bottom")
                : 0 <= e.offsetTop &&
                  e.offsetTop < this.tooltip_container.offsetHeight &&
                  i >= this.tooltip_container.offsetHeight &&
                  t.classList.add("hotspot-content--top");
    }
    connectedCallback() {
        Shopify.designMode
            ? setTimeout(() => {
                  this.init();
              }, 1e3)
            : this.init();
    }
}
customElements.define("sht-hotspot", SHTHotSpotTooltip);
class SHTMarquee extends SHTCustomComponent {
    constructor() {
        super(),
            (this.playNPauseBtn = this.$(".js-marquee-pause-n-play-btn")),
            (this.pauseIcon = this.$(".js-marqueen-pause-btn")),
            (this.playIcon = this.$(".js-marqueen-play-btn")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.playNPauseBtn.addEventListener("click", (e) => {
            var t = "false" === e.currentTarget.getAttribute("aria-pressed");
            this.classList.toggle("marquee--animation-pause", t),
                this.playIcon.classList.toggle("d-none", !t),
                this.pauseIcon.classList.toggle("d-none", t),
                e.currentTarget.setAttribute("aria-pressed", t.toString());
        });
    }
}
customElements.define("sht-marquee", SHTMarquee);
class SHTMap extends SHTCustomComponent {
    constructor() {
        super(), (this.iframe = this.$(".js-map-iframe")), this.bindEventHandlers();
    }
    loadIframeContent() {
        new IntersectionObserver(
            (e, t) => {
                e.forEach((e) => {
                    e.isIntersecting &&
                        (this.dispatchEvent(
                            new CustomEvent("loadingStart", { detail: { ele: this.iframe, parent: this } })
                        ),
                        this.execute(),
                        t.unobserve(e.target));
                });
            },
            { rootMargin: "0px 0px -100px 0px" }
        ).observe(this);
    }
    bindEventHandlers() {
        this.iframe.addEventListener(
            "load",
            function () {
                this.dispatchEvent(new CustomEvent("loadingEnd", { detail: { ele: this.iframe, parent: this } })),
                    this.setAttribute("loaded", !0);
            }.bind(this)
        );
    }
    execute() {
        this.setIframeSrc();
    }
    setIframeSrc() {
        var e = `https://maps.google.com/maps?z=${this.dataZoom}&t=${this.dataType}&q=${this.dataLocation.replace(/"/g, "")}&ie=UTF8&&output=embed`;
        (this.iframe.src = e), this.iframe.removeAttribute("srcdoc");
    }
    static get observedAttributes() {
        return ["data-zoom", "data-type", "data-location"];
    }
    attributeChangedCallback(e, t, s) {
        t !== s && (Shopify.designMode ? this.execute() : this.loadIframeContent());
    }
    connectedCallback() {}
    disconnectedCallback() {}
    get dataZoom() {
        return this.getAttribute("data-zoom");
    }
    get dataType() {
        return this.getAttribute("data-type");
    }
    get dataLocation() {
        return this.getAttribute("data-location");
    }
    set dataZoom(e) {
        this.setAttribute("data-zoom", e);
    }
    set dataType(e) {
        this.setAttribute("data-type", e);
    }
    set dataLocation(e) {
        this.setAttribute("data-location", e);
    }
}
customElements.define("sht-map", SHTMap);
class SHTLoadDynamicCheckoutButtonDynamicCheckoutButton extends SHTCustomComponent {
    constructor() {
        super(),
            (this.template = this.$("template")),
            (this.onLoadDynamicCheckoutButton = this.onHandleLoadDynamicCheckoutButton.bind(this)),
            this.bindEventHandlers(),
            (this.isMouseenter = !1),
            (this.json = JSON.parse(SHTHelper.qs('#shopify-features[type="application/json"]').textContent)),
            Shopify.designMode
                ? this.loadDynamicCheckoutButton()
                : (window.addEventListener("scroll", this.onLoadDynamicCheckoutButton, !1),
                  window.addEventListener(
                      "load",
                      function (e) {
                          let t = setTimeout(
                              function () {
                                  this.isMouseenter || (this.loadDynamicCheckoutButton(), clearTimeout(t)),
                                      (this.isMouseenter = !0);
                              }.bind(this),
                              3e3
                          );
                      }.bind(this)
                  ),
                  ["mouseover"].forEach(
                      function (e) {
                          SHTHelper.qs("body").addEventListener(e, this.onLoadDynamicCheckoutButton);
                      }.bind(this)
                  ));
    }
    onHandleLoadDynamicCheckoutButton(e) {
        this.isMouseenter || this.loadDynamicCheckoutButton(),
            e.currentTarget.removeEventListener(e.type, this.onLoadDynamicCheckoutButton),
            (this.isMouseenter = !0);
    }
    loadDynamicCheckoutButton() {
        new IntersectionObserver(
            (e, s) => {
                e.forEach((e) => {
                    var t;
                    1 !== e.intersectionRatio ||
                        this.getAttribute("loaded") ||
                        ((e = this.template.content.firstElementChild.cloneNode(!0)),
                        ((t = document.createElement("script")).src = this.json.smart_payment_buttons_url),
                        t.setAttribute("data-source-attribute", "shopify.dynamic_checkout.product.init"),
                        this.parentNode.insertBefore(e, this.nextSibling),
                        this.parentNode.insertBefore(t, this.nextSibling),
                        this.setAttribute("loaded", !0),
                        s.unobserve(this));
                });
            },
            { root: null, rootMargin: "50px 0px", threshold: 0 }
        ).observe(this);
    }
    bindEventHandlers() {}
}
customElements.define("sht-load-dyn-co-btn", SHTLoadDynamicCheckoutButtonDynamicCheckoutButton);
class SHTVerticalCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.togglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-top")) +
                      parseFloat(
                          window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-bottom")
                      )),
                  (this.itemOffset = this.itemsToShow[1].offsetTop - this.itemsToShow[0].offsetTop),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientHeight - this.itemsToShow[0].offsetTop) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.updateCarousel());
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollTop / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollTop
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled"),
            1 < this.totalPages && this.togglePagination(!0),
            this.totalPages <= 1 && this.togglePagination(!1);
    }
    togglePagination(e) {
        e
            ? (this.paginationElement?.classList.remove("d-none"), this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"), this.paginationElement?.classList.add("d-none"));
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientHeight + this.container.scrollTop - t;
        return e.offsetTop + e.clientHeight - 1 <= Math.ceil(t) && e.offsetTop >= this.container.scrollTop;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 769px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollTop && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollTop - s + t * this.itemOffset
                    : this.container.scrollTop + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ top: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        new ResizeObserver((e) => this.init()).observe(this.container);
        new IntersectionObserver(
            ((e, t) => {
                e[0].isIntersecting && (this.init(), t.unobserve(this));
            }).bind(this)
        ).observe(this),
            this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
    }
}
customElements.define("sht-vert-carousel", SHTVerticalCarousel);
class SHTHorizontalCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            this.init(),
            this.bindEventHandlers();
    }
    init() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2 ||
                ((this.gutter =
                    parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                    parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                (this.itemsPerPage = Math.floor(
                    (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                )),
                (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                this.updateCarousel());
    }
    updateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.isItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled");
    }
    isItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft;
    }
    onButtonClick(e) {
        e.preventDefault();
        let t = 1,
            s = 0;
        window.matchMedia("(min-width: 769px)").matches && (t = e.currentTarget.dataset.step),
            (0 != this.container.scrollLeft && !this.isItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
                (s = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - s + t * this.itemOffset
                    : this.container.scrollLeft + s - t * this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    bindEventHandlers() {
        new ResizeObserver((e) => this.init()).observe(this.container);
        new IntersectionObserver(
            ((e, t) => {
                e[0].isIntersecting && (this.init(), t.unobserve(this));
            }).bind(this)
        ).observe(this),
            this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextBtnElement && this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this)),
            this.container.addEventListener("scroll", SHTHelper.debounce(this.updateCarousel.bind(this), 100));
    }
}
customElements.define("sht-horiz-carousel", SHTHorizontalCarousel);
class SHTProductSlideShowItem extends SHTCustomComponent {
    constructor() {
        super(),
            (this.openGalleryButton = this.$(".js-product-media-open-gallery-btn")),
            this.openGalleryButton &&
                this.openGalleryButton.addEventListener("click", (e) => {
                    this.openDialogGallery(e);
                }),
            (this.slideshow = this.closest("sht-prd-slideshow")),
            (this.parent = this.closest("sht-carousel-itm")),
            this.prepare();
    }
    openDialogGallery(e) {
        var t = SHTHelper.qs("#" + e.currentTarget.dataset.galleryDialogId);
        t && (t.showModal(e.currentTarget, !0), this.slideshow.pauseAllVideo());
    }
    prepare() {
        this.closest(".product__quickview") ||
            (window.matchMedia("(max-width: 459px)").matches
                ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
                : this.parent.classList.contains("d-block") ||
                  ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none")),
            new ResizeObserver((e) => {
                window.matchMedia("(max-width: 459px)").matches
                    ? "true" == this.slideshow.hide_variant && this.parent.classList.remove("d-none")
                    : this.parent.classList.contains("d-block") ||
                      ("true" == this.slideshow.hide_variant && this.parent.classList.add("d-none"));
            }).observe(document.body));
    }
}
customElements.define("sht-prd-slideshow-itm", SHTProductSlideShowItem);
class SHTProductSlideShow extends SHTCustomComponent {
    constructor() {
        super(),
            (this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.thumb_carousel = SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`)),
            this.bindEventHandlers(),
            (this.hide_variant = this.dataset.hideVariantImage);
    }
    bindEventHandlers() {
        this.closest(".product__quickview") ||
            this.$$(".js-slideshow-btn-thumb").forEach((e, t) => {
                0 === t && e.closest(".js-product-slideshow-thumb").classList.add("is-active-item"),
                    e.addEventListener("click", this.setActiveMedia.bind(this, e));
            });
    }
    setActiveMedia(e) {
        var t,
            s = this.$(`[data-media-id="${e.dataset.target}"]`),
            e = e.closest("sht-vert-carousel-itm");
        s &&
            e &&
            (window.matchMedia("(max-width: 768px)").matches
                ? (this.pauseAllVideo(),
                  this.$$(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  e.classList.add("is-active-item"),
                  (t = this.carousel?.querySelector(".js-carousel-items")) &&
                      s &&
                      t.scrollTo({ left: s.offsetLeft, behavior: "smooth" }))
                : (this.$$(".js-product-slideshow-item").forEach((e) => {
                      e.classList.remove("d-block"), "true" == this.hide_variant && e.classList.add("d-none");
                  }),
                  this.$$(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  s.classList.add("d-block"),
                  "true" == this.hide_variant && s.classList.remove("d-none"),
                  e.classList.add("is-active-item"),
                  this.playActiveVideo(s),
                  this.playActiveModel(s)));
    }
    pauseAllModel() {
        SHTHelper.qsa("sht-prd-media-itm-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
    }
    pauseAllVideo() {
        this.$$(".js-media-item-youtube").forEach((e) => {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }),
            this.$$(".js-media-item-vimeo").forEach((e) => {
                e.contentWindow.postMessage('{"method":"pause"}', "*");
            }),
            this.$$(".js-media-item-video").forEach((e) => e.pause());
    }
    playActiveVideo(e) {
        this.pauseAllVideo();
        e = e.querySelector(".js-product-media-deferred-video");
        e && e.loadContent();
    }
    playActiveModel(e) {
        e = e.querySelector(".js-product-media-deferred-model");
        e && e.loadContent();
    }
}
customElements.define("sht-prd-slideshow", SHTProductSlideShow);
class SHTProductMediaItemDeferredVideo extends SHTCustomComponent {
    constructor() {
        super(),
            (this.itemDeferredVideoImageElem = this.$(".js-product-media-item-deferred-video-image")),
            this.itemDeferredVideoImageElem &&
                this.itemDeferredVideoImageElem.addEventListener("click", (e) => {
                    this.loadContent();
                });
    }
    loadContent() {
        var e;
        if (!this.getAttribute("loaded"))
            return (
                (e = this.$("template").content.firstElementChild.cloneNode(!0)),
                this.appendChild(e),
                this.isLoaded(!0),
                this.itemDeferredVideoImageElem && this.itemDeferredVideoImageElem.remove(),
                !0
            );
    }
    isLoaded(e) {
        e ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
    }
}
customElements.define("sht-prd-media-itm-deferred-video", SHTProductMediaItemDeferredVideo);
class SHTProductMediaItemModel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.itemModelImageElem = this.$(".js-product-media-item-model-image")),
            this.itemModelImageElem &&
                this.itemModelImageElem.addEventListener("click", (e) => {
                    this.loadContent();
                });
    }
    loadModelViewerUICss() {
        var e;
        SHTHelper.qs("#model-viewer-ui") ||
            ((e = document.createElement("link")).setAttribute(
                "href",
                "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"
            ),
            e.setAttribute("rel", "stylesheet"),
            e.setAttribute("media", "all"),
            e.setAttribute("id", "model-viewer-ui"),
            document.getElementsByTagName("head")[0].appendChild(e));
    }
    loadContent() {
        var e;
        this.getAttribute("loaded") ||
            ((e = document.createElement("div")).appendChild(
                this.$("template").content.firstElementChild.cloneNode(!0)
            ),
            this.setAttribute("loaded", !0),
            this.itemModelImageElem && this.itemModelImageElem.remove(),
            this.appendChild(e.querySelector("model-viewer")).focus(),
            this.loadModelViewerUICss(),
            Shopify.loadFeatures([
                { name: "model-viewer-ui", version: "1.0", onLoad: this.setupModelViewerUI.bind(this) },
            ]));
    }
    setupModelViewerUI(e) {
        e || (this.modelViewerUI = new Shopify.ModelViewerUI(this.$("model-viewer")));
    }
}
customElements.define("sht-prd-media-itm-model", SHTProductMediaItemModel),
    (window.SHTProductMediaItemModel = {
        isMouseenter: !1,
        loadShopifyXR() {
            Shopify.loadFeatures([{ name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this) }]);
        },
        setupShopifyXR(e) {
            e ||
                (window.ShopifyXR
                    ? (SHTHelper.qsa('[id^="ProductJSON-"]').forEach((e) => {
                          window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove();
                      }),
                      window.ShopifyXR.setupXRElements())
                    : document.addEventListener("shopify_xr_initialized", () => this.setupShopifyXR()));
        },
    }),
    Shopify.designMode
        ? (SHTHelper.qsa("[data-shopify-xr-hidden]").forEach((e) => e.classList.add("hidden")),
          window.SHTProductMediaItemModel && window.SHTProductMediaItemModel.loadShopifyXR())
        : window.SHTProductMediaItemModel &&
          (window.addEventListener(
              "scroll",
              function (e) {
                  window.SHTProductMediaItemModel.isMouseenter || window.SHTProductMediaItemModel.loadShopifyXR(),
                      (window.SHTProductMediaItemModel.isMouseenter = !0);
              },
              !1
          ),
          ["mouseenter", "touchstart", "mouseover"].forEach(function (e) {
              SHTHelper.qs("body").addEventListener(e, function (e) {
                  window.SHTProductMediaItemModel.isMouseenter || window.SHTProductMediaItemModel.loadShopifyXR(),
                      (window.SHTProductMediaItemModel.isMouseenter = !0);
              });
          }));
class SHTFeaturedVariantSelector extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.$ = this.querySelector.bind(this)),
            (this.$$ = this.querySelectorAll.bind(this)),
            (this.elms = {
                radio_elms: this.$$(".js-featured-variant-radio-item"),
                form: SHTHelper.qs("#featuredProductForm-" + this.dataset.section),
                price: SHTHelper.qs("#featuredProductPrice-" + this.dataset.section),
                product_form: SHTHelper.qs(`sht-featured-prd-frm[data-section="${this.dataset.section}"]`),
                inventory_tracking: SHTHelper.qs("#featuredInventoryTracking-" + this.dataset.section),
                variant_picker: SHTHelper.qs("#featuredVariantPicker-" + this.dataset.section),
                quantity_input: SHTHelper.qs("#featuredProductQuantity-" + this.dataset.section),
                slideshow: SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`),
                thumb_carousel: SHTHelper.qs(`sht-vert-carousel[data-section="${this.dataset.section}"]`),
                carousel: SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`),
                variant_options: this.$$(".js-variant-option-value"),
                sku: SHTHelper.qs("#featuredSku-" + this.dataset.section),
            }),
            (this.price_selector = "#featuredProductPrice-" + this.dataset.section),
            (this.inventory_tracking_selector = "#featuredInventoryTracking-" + this.dataset.section),
            (this.variant_picker_selector = "#featuredVariantPicker-" + this.dataset.section),
            (this.quantity_input_selector = "#featuredProductQuantity-" + this.dataset.section),
            (this.slideshow_selector = `sht-prd-slideshow[data-section="${this.dataset.section}"]`),
            (this.sku_selector = "#featuredSku-" + this.dataset.section),
            (this.variantData = this.setSelectedVariants(this)),
            this.updateSelectedVariants(this.variantData),
            this.bindEventHandlers();
    }
    updateSelectedVariants(e) {
        e?.options &&
            e.options.forEach((e, t) => {
                var s,
                    i,
                    t = (e + "-" + t).replace(/"/g, '\\"'),
                    t = this.$(`.js-variant-item[data-variant-value="${t}"]`);
                t &&
                    ((s = t.getAttribute("data-variant-name") || t.getAttribute("name")),
                    (t = t.dataset.optionVariantValue),
                    s) &&
                    ((i = this.$(`.js-variant-radio-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`)) &&
                        (i.innerHTML = e),
                    (i = this.$(`.js-variant-select-option-name[data-option-name="${s.replace(/"/g, '\\"')}"]`))) &&
                    (i.innerHTML = t || e);
            });
    }
    setSelectedVariants(e) {
        return JSON.parse(e.querySelector('[data-selected-variant][type="application/json"]').textContent);
    }
    bindEventHandlers() {
        this.addEventListener("change", () => this.onVariantChangeHandle());
    }
    onVariantChangeHandle() {
        this.toggleAddButton(!0), this.removeErrorMessage(), this.renderProductInfo();
    }
    toggleAddButton(e = !0, t, s) {
        var i,
            n = this.elms.form;
        n &&
            ((i = (n = n.querySelector(".js-featured-product-form-submit-btn")).querySelector(
                ".js-featured-product-form-submit-btn-text"
            )),
            n) &&
            (e
                ? (n.setAttribute("disabled", "disabled"), t && (i.textContent = t))
                : (n.removeAttribute("disabled"), (i.textContent = SHTLanguage.product.PRODUCT_ADD_TO_CART)));
    }
    removeErrorMessage() {
        this.elms.product_form && this.elms.product_form.handleErrorMessage();
    }
    getSelectedVariantValue() {
        return Array.from(this.querySelectorAll(".js-variant-item:checked")).map((e) => e.dataset.optionValueId);
    }
    buildRequestUrlWithParams(e, t) {
        var s = new URLSearchParams({ section_id: this.dataset.section });
        return t.length && s.append("option_values", t.join(",")), e + "?" + s.toString();
    }
    async renderProductInfo() {
        var e = this.dataset.url,
            t = this.getSelectedVariantValue(),
            e = this.buildRequestUrlWithParams(e, t);
        try {
            var s = await fetch(e);
            if (!s.ok) throw new Error("Network response was not ok");
            var i = await s.text(),
                n = new DOMParser().parseFromString(i, "text/html"),
                r = this.setSelectedVariants(n);
            if (!r) return this.setUnavailable();
            this.updateUI(n, r);
        } catch (e) {
            console.error("Error fetching product info:", e), this.setUnavailable();
        }
    }
    checkInventory(e) {
        var t = this.elms.inventory_tracking,
            e = e.querySelector(this.inventory_tracking_selector);
        t && (t.innerHTML = e?.innerHTML ?? "");
    }
    updateOptionValues(e) {
        var e = e.querySelector(".js-variant-picker"),
            t = this.elms.variant_picker;
        e && t && (t.innerHTML = e.innerHTML);
    }
    updateUI(e, t) {
        this.checkInventory(e),
            this.updateVariantInput(t),
            this.updateOptionValues(e),
            this.setActiveMedia(t),
            this.updatePrice(e),
            this.updateSku(e),
            this.updateQuantity(e),
            this.updateSelectOptions(e, t),
            this.updateSlideshow(e),
            this.updateAddToCartState(t);
    }
    updateSelectOptions(e, t) {
        e = e.querySelectorAll("sht-select .js-variant-select-item");
        const s = this.querySelectorAll("sht-select .js-variant-select-item");
        e.forEach((e, t) => {
            s[t] && (s[t].innerHTML = e.innerHTML);
        }),
            this.updateSelectedVariants(t);
    }
    updateSku(e) {
        e = e.querySelector(this.sku_selector);
        this.elms.sku && (this.elms.sku.innerHTML = e?.innerHTML ?? "");
    }
    updatePrice(e) {
        e = e.querySelector(this.price_selector);
        e &&
            this.elms.price &&
            ((this.elms.price.innerHTML = e.innerHTML), this.elms.price.classList.remove("d-none-important"));
    }
    updateQuantity(e) {
        var t = this.elms.quantity_input?.querySelector(".js-max-quantity-message"),
            s = e.querySelector(this.quantity_input_selector)?.querySelector(".js-max-quantity-message"),
            t =
                (t && (t.classList.add("d-none-important"), (t.innerHTML = s?.innerHTML ?? "")),
                e.querySelector(this.quantity_input_selector));
        this.elms.quantity_input && (this.elms.quantity_input.innerHTML = t?.innerHTML ?? "");
    }
    updateAddToCartState(e) {
        this.toggleAddButton(!e.available, SHTLanguage.product.PRODUCT_SOLD_OUT);
    }
    updateSlideshow(e) {
        "false" === this.elms.slideshow?.hide_variant &&
            (e = e.querySelector(this.slideshow_selector)) &&
            this.elms.slideshow &&
            ((this.elms.slideshow.innerHTML = e.innerHTML), this.elms.slideshow.bindEventHandlers());
    }
    updateVariantInput(t) {
        var e;
        t &&
            ((e = [this.elms.form, this.elms.installment_form]),
            SHTHelper.qs(".js-inventory-tracking")?.classList.remove("d-none"),
            e.forEach((e) => {
                e &&
                    (e = e.querySelector('input[name="id"]')) &&
                    ((e.value = t.id), e.dispatchEvent(new Event("change", { bubbles: !0 })));
            }));
    }
    setActiveMedia(e) {
        var t, s;
        e.featured_media &&
            ((e = e.featured_media.id),
            (t = this.elms.slideshow?.querySelector(`sht-carousel-itm[data-media-id="${this.dataset.section}-${e}"]`)),
            (e = this.elms.slideshow?.querySelector(
                `sht-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${e}"]`
            )),
            t) &&
            (window.matchMedia("(max-width: 768px)").matches
                ? (s = this.elms.carousel?.querySelector(".js-carousel-items")) &&
                  s.scrollTo({ left: t.offsetLeft, behavior: "smooth" })
                : (this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach((e) => {
                      e.classList.remove("d-block"),
                          "true" == this.elms.slideshow.hide_variant && e.classList.add("d-none");
                  }),
                  this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach((e) => {
                      e.classList.remove("is-active-item");
                  }),
                  t.classList.add("d-block"),
                  "true" == this.elms.slideshow.hide_variant && t.classList.remove("d-none")),
            e &&
                (e.classList.add("is-active-item"),
                (s = this.elms.thumb_carousel?.querySelector(".js-carousel-items"))) &&
                s.scrollTo({ top: e.offsetTop, behavior: "auto" }),
            this.elms.slideshow.pauseAllVideo());
    }
    setUnavailable() {
        var e,
            t = this.elms.form,
            s = this.elms.inventory_tracking;
        t &&
            ((e = (t = t.querySelector(".js-featured-product-form-submit-btn")).querySelector(
                ".js-featured-product-form-submit-btn-text"
            )),
            t) &&
            (s.setAttribute("hidden", "true"),
            (e.textContent = SHTLanguage.product.PRODUCT_UNAVAILABLE),
            this.elms.price) &&
            this.elms.price.classList.add("visibility-hidden");
    }
}
class SHTFeaturedVariantRadios extends SHTFeaturedVariantSelector {
    constructor() {
        super(), (this.select_type = "button");
    }
}
customElements.define("sht-featured-variant-radios", SHTFeaturedVariantRadios);
class SHTFeaturedVariantSelects extends SHTFeaturedVariantSelector {
    constructor() {
        super(),
            (this.$ = this.querySelector.bind(this)),
            (this.$$ = this.querySelectorAll.bind(this)),
            (this.select_type = "dropdown");
    }
}
customElements.define("sht-featured-variant-selects", SHTFeaturedVariantSelects);
class SHTFeaturedVariantSwatchSelect extends HTMLElement {
    constructor() {
        super(), (this.$ = this.querySelector.bind(this)), (this.$$ = this.querySelectorAll.bind(this));
    }
    init() {
        (this.radios = this.$$(".js-variant-radio-item")),
            (this.select_id = this.dataset.selectId),
            (this.select_element = document.querySelector("#" + this.select_id)),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.radios.forEach((e) => {
            e.addEventListener("click", (e) => {
                e.preventDefault(),
                    Array.from(this.radios, (e) => {
                        e.checked = !1;
                    }),
                    setTimeout(() => {
                        e.target.checked = !0;
                    }),
                    this.select_element &&
                        ((this.select_element.querySelector(
                            `option[value="${e.target.value.replace(/"/g, '\\"')}"]`
                        ).selected = !0),
                        this.select_element.dispatchEvent(new Event("change", { bubbles: !0 })));
            });
        });
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("sht-featured-variant-swatch-select", SHTFeaturedVariantSwatchSelect);
class SHTFeaturedProductForm extends SHTCustomComponent {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.elms = {
            form: this.$("form"),
            submit_btn: this.$('[type="submit"]'),
            error_wrapper: this.$(".js-featured-product-form-error-wrapper"),
            error_message: this.$(".js-featured-product-form-error-message"),
            spinner: this.$(".js-featured-product-form-spinner"),
            quantity_input_container: SHTHelper.qs("#featuredProductQuantity-" + this.dataset.section),
            sticky_header: SHTHelper.qs("sht-sticky-header"),
            header: SHTHelper.qs("sht-header"),
            announcement_bar: SHTHelper.qs("sht-ann-bar"),
            header_cart_status: SHTHelper.qs("#headerCartStatus"),
        }),
            (this.cartNotiType = document.body.getAttribute("data-cart-show-type")),
            (this.cartType = document.body.getAttribute("data-cart-type")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.cartDrawerForm = SHTHelper.qs("sht-cart-drwr-frm")),
            this.elms.form && ((this.elms.form.querySelector("[name=id]").disabled = !1), this.bindEventHandlers());
    }
    bindEventHandlers() {
        this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    }
    onSubmitHandler(s) {
        if ((s.preventDefault(), !this.elms.submit_btn.classList.contains("loading"))) {
            this.handleErrorMessage(),
                this.elms.submit_btn.setAttribute("aria-disabled", !0),
                this.elms.submit_btn.setAttribute("disabled", !0),
                this.elms.submit_btn.classList.add("loading"),
                this.elms.spinner.classList.remove("hidden"),
                this.elms.header_cart_status &&
                    this.elms.header_cart_status.classList.remove("header-cart-status--animate");
            let e = [];
            this.cartNotification && (e = this.cartNotification.getSectionsToRender()),
                this.cartDrawer && (e = [...e, ...this.cartDrawer.getSectionsToRender()]);
            var i = new FormData(this.elms.form);
            e.length &&
                i.append(
                    "sections",
                    e.map((e) => e.id)
                );
            let t = void 0 !== s.submitter ? this.elms.submit_btn : null;
            i.append("sections_url", window.location.pathname),
                (SHTHelper.fetchConfigHTTP.body = i),
                fetch("" + routes.cart_add_url, SHTHelper.fetchConfigHTTP)
                    .then((e) => e.json())
                    .then((e) => {
                        if (e.status) this.handleErrorMessage(e.description);
                        else {
                            switch (
                                (this.elms.sticky_header &&
                                    this.elms.sticky_header.dataset.isEnabled &&
                                    this.elms.sticky_header.reveal(),
                                this.cartNotiType)
                            ) {
                                case "show_popup_noti":
                                    this.handleShowNotification(e, t);
                                    break;
                                case "show_drawer":
                                    this.handleShowDrawer(e, t);
                            }
                            this.elms.quantity_input_container &&
                                "add-to-cart" == this.elms.quantity_input_container.dataset.show &&
                                (this.elms.quantity_input_container.classList.remove("d-none"),
                                (this.elms.quantity_input_container.querySelector("input").value = 1)),
                                this.elms.header || window.location.assign(window.routes.cart_url);
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.elms.submit_btn.classList.remove("loading"),
                            this.elms.submit_btn.removeAttribute("aria-disabled"),
                            this.elms.submit_btn.removeAttribute("disabled"),
                            this.elms.spinner.classList.add("hidden");
                    });
        }
    }
    handleShowNotification(e, t) {
        this.cartNotification && this.cartNotification.renderContents(e, !0, t),
            this.cartDrawerForm && this.cartDrawerForm.renderContents(e);
    }
    handleShowDrawer(e, t) {
        "drawer" === this.cartType
            ? (this.cartNotification?.renderContents(e, !1),
              this.cartDrawerForm?.renderContents(e),
              this.cartDrawer?.querySelector(".js-drawer-message")?.setActiveMessage(),
              this.cartDrawer?.openDrawer(t))
            : "page" === this.cartType &&
              (this.cartNotification?.renderContents(e, !1), window.location.assign(window.routes.cart_url));
    }
    handleErrorMessage(e = !1) {
        this.elms.error_wrapper.toggleAttribute("hidden", !e), e && (this.elms.error_message.textContent = e);
    }
}
customElements.define("sht-featured-prd-frm", SHTFeaturedProductForm),
    window.addEventListener("load", function () {
        if (!customElements.get("sht-shape-parallax")) {
            class e extends SHTCustomComponent {
                constructor() {
                    super(),
                        (this.speed = -8),
                        (this.shape = this.$(".js-shape-parallax-shape")),
                        (this.shape_rotation = this.$(".js-shape-parallax-rotation")),
                        (this.content = this.$(".js-shape-parallax-content")),
                        (this.bound = {}),
                        (this.dataTransformContent = this.dataset.contentTransform),
                        (this.dataEnableParallaxScrolling = "true" == this.dataset.enableParallaxScrolling),
                        (this.inViewport = !1);
                }
                recalculate() {
                    var e = SHTHelper.qde.scrollTop;
                    (this.top = this.bound.top + e + this.offsetHeight / 2),
                        (this.windowH = window.innerHeight),
                        (this.maxY = this.windowH / 2),
                        (this.cA = this.top - this.windowH);
                }
                recalculateForEditor() {
                    var e = SHTHelper.qde.scrollTop,
                        t = this.getBoundingClientRect();
                    (this.top = t.top + e + this.offsetHeight / 2),
                        (this.windowH = window.innerHeight),
                        (this.maxY = this.windowH / 2),
                        (this.cA = this.top - this.windowH);
                }
                bindEventHandlers() {
                    document.addEventListener(
                        "scroll",
                        () => {
                            requestAnimationFrame(this.setAnimation.bind(this));
                        },
                        !0
                    ),
                        Shopify.designMode &&
                            (document.addEventListener(
                                "shopify:inspector:activate",
                                function (e) {
                                    setTimeout(() => {
                                        this.recalculateForEditor(),
                                            requestAnimationFrame(this.setAnimation.bind(this));
                                    });
                                }.bind(this)
                            ),
                            document.addEventListener(
                                "shopify:section:load",
                                function (e) {
                                    setTimeout(() => {
                                        this.recalculateForEditor(),
                                            requestAnimationFrame(this.setAnimation.bind(this));
                                    });
                                }.bind(this)
                            ));
                }
                calculatePercentage() {
                    var e = SHTHelper.qde.scrollTop,
                        t = e - this.cA;
                    let s = 0;
                    return (s = this.inViewport ? -e / this.top : 1 - t / this.maxY);
                }
                setAnimation() {
                    var e = SHTHelper.qde.scrollTop,
                        t = this.calculatePercentage(),
                        t = (this.windowH / 12) * t;
                    this.dataEnableParallaxScrolling && (this.shape.style.transform = `translate3d(0px, ${t}px, 0px)`),
                        (this.shape_rotation.style.transform = `rotate(${e / 4}deg)`),
                        (this.content.style.transform = this.dataTransformContent + ` rotate(-${e / 4}deg)`);
                }
                onObserverHandler() {
                    new IntersectionObserver((e, t) => {
                        e.forEach((e) => {
                            e.isIntersecting && SHTHelper.qde.scrollTop <= 0 && (this.inViewport = !0),
                                t.unobserve(this.shape);
                        });
                    }).observe(this.shape),
                        Shopify.designMode ||
                            new IntersectionObserver((e, t) => {
                                (this.bound = e[0].boundingClientRect),
                                    this.recalculate(),
                                    requestAnimationFrame(this.setAnimation.bind(this)),
                                    t.disconnect();
                            }).observe(this);
                }
                connectedCallback() {
                    this.bindEventHandlers(), this.onObserverHandler();
                }
                disconnectedCallback() {}
            }
            customElements.define("sht-shape-parallax", e);
        }
    });
var VAR_LOCALIZATION_CACHE = new Map();
class SHTLocalization extends SHTCustomComponent {
    constructor() {
        super();
    }
    async init() {
        Shopify.designMode
            ? await this.getSearchResults()
            : new IntersectionObserver(
                  (async (e, t) => {
                      e[0].isIntersecting && (await this.getSearchResults(), t.unobserve(this));
                  }).bind(this),
                  { threshold: 0.25 }
              ).observe(this);
    }
    async getSearchResults() {
        SHTHelper.loadScript(
            this.dataset.jsFileId,
            this.dataset.jsFile,
            async function () {
                var e = this.dataset.url.replace(/\s/g, "-").toLowerCase(),
                    t = VAR_LOCALIZATION_CACHE.get(e);
                t
                    ? (this.innerHTML = t)
                    : ((t = await this.fetchResults()), VAR_LOCALIZATION_CACHE.set(e, t), (this.innerHTML = t));
            }.bind(this)
        );
    }
    async fetchResults() {
        return fetch(this.dataset.url)
            .then((e) => e.text())
            .then((e) => {
                var t = document.createElement("div"),
                    e = ((t.innerHTML = e), t.querySelector("#" + this.dataset.sectionId));
                return e && e.innerHTML.trim().length ? e.innerHTML : "";
            })
            .catch((e) => (console.error(e), ""));
    }
    connectedCallback() {
        this.init();
    }
}
customElements.define("sht-localization", SHTLocalization);
class SHTFreeShippingBar extends SHTCustomComponent {
    constructor() {
        super(),
            (this.total_price = this.dataset.totalPrice),
            (this.threshold = 0),
            (this.original_free_shipping_price = this.dataset.freeShippingOriginalPrice),
            (this.free_shipping_price = this.dataset.freeShippingPrice),
            (this.free_shipping_progress = this.$(".js-free-shipping-progress")),
            (this.free_shipping_progress_content = this.$(".js-free-shipping-progress-content")),
            (this.free_shipping_progress_message = this.$(".js-free-shipping-message")),
            this.init();
    }
    calculateCurrencyRate() {
        this.threshold = Math.round(this.free_shipping_price * (Shopify.currency.rate || 1));
    }
    init() {
        this.calculateCurrencyRate(),
            (this.free_shipping_progress.max = this.threshold),
            (this.free_shipping_progress.value = this.total_price),
            (this.free_shipping_progress_content.innerHTML = SHTHelper.formatMoney(
                this.threshold,
                window.theme_variables.settings.money_with_currency_format
            ));
        var e = this.threshold - this.total_price;
        this.free_shipping_progress_message.innerHTML =
            e <= 0
                ? SHTLanguage.free_shipping_bar.FULFILLED
                : SHTLanguage.free_shipping_bar.UNFULFILLED.replace(
                      "[remaining_amount]",
                      SHTHelper.formatMoney(e, window.theme_variables.settings.money_with_currency_format)
                  );
    }
}
customElements.define("sht-free-shipping-bar", SHTFreeShippingBar);
class SHTCountDown extends SHTCustomComponent {
    constructor() {
        super();
    }
    init() {
        if (((this.isExpired = JSON.parse(this.dataset.isExpired)), this.isExpired)) return !0;
        (this.timeZoneName = this.dataset.timeZoneName),
            (this.timeZoneOffset = this.dataset.timeZoneOffset),
            (this.endTime = this.dataset.endTime),
            (this.endDate = this.dataset.endDate),
            (this.hideOnEnd = JSON.parse(this.dataset.hideOnEnd)),
            this.validateDateValue(this.endDate) || (this.endDate = this.getCurrentDateTime(!0)),
            this.validateTimeValue(this.endTime) || (this.endTime = "23:59:59"),
            (this.expiredAt = new Date(this.convertDateStringToISOString(this.endDate + ":" + this.endTime)).getTime()),
            (this.currentTime = this.convertDateTimeToSpecificTimeZone(this.getCurrentDateTime())),
            (this.daysElement = this.$(".js-counter-days")),
            (this.hoursElement = this.$(".js-counter-hours")),
            (this.minutesElement = this.$(".js-counter-minutes")),
            (this.secondsElement = this.$(".js-counter-seconds")),
            (this.messageElement = this.$(".js-counter-message")),
            (this.counterElement = this.$(".js-counter"));
        const n = setInterval(() => {
            var e,
                t,
                s,
                i = this.expiredAt - this.currentTime;
            i <= 0
                ? (clearInterval(n),
                  this.setCounter({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                  "" != this.messageElement.innerHTML && this.messageElement.classList.remove("d-none"),
                  this.hideOnEnd && this.counterElement.classList.add("d-none-important"))
                : ((e = Math.floor(i / 864e5)),
                  (t = Math.floor((i % 864e5) / 36e5)),
                  (s = Math.floor((i % 36e5) / 6e4)),
                  (i = Math.floor((i % 6e4) / 1e3)),
                  this.setCounter({ days: e, hours: t, minutes: s, seconds: i }),
                  (this.currentTime = this.currentTime + 1e3));
        }, 1e3);
    }
    connectedCallback() {
        this.init();
    }
    getCurrentDateTime(e = !1) {
        var t = new Date(),
            s = t.getFullYear(),
            i = String(t.getMonth() + 1).padStart(2, "0"),
            n = String(t.getDate()).padStart(2, "0"),
            r = String(t.getHours()).padStart(2, "0"),
            o = String(t.getMinutes()).padStart(2, "0"),
            t = String(t.getSeconds()).padStart(2, "0");
        return e ? s + `-${i}-` + n : s + `-${i}-${n} ${r}:${o}:` + t;
    }
    convertDateTimeToSpecificTimeZone(e, t = !0) {
        var e = new Date(e),
            s = "-" === this.timeZoneOffset[0];
        let i =
            60 *
            (60 * parseInt(this.timeZoneOffset.substring(1, 3)) + parseInt(this.timeZoneOffset.substring(3, 5))) *
            1e3;
        s && (i = -i);
        s = new Date(e.getTime() + i);
        return t ? s.getTime() : s.toISOString();
    }
    setCounter({ days: e, hours: t, minutes: s, seconds: i }) {
        (this.daysElement.textContent = e < 10 ? "0" + e : e),
            (this.hoursElement.textContent = t < 10 ? "0" + t : t),
            (this.minutesElement.textContent = s < 10 ? "0" + s : s),
            (this.secondsElement.textContent = i < 10 ? "0" + i : i);
    }
    convertDateStringToISOString(e) {
        return e.replace(/:/, "T") + ".000Z";
    }
    validateDateValue(e) {
        return !!/^\d{4}-\d{2}-\d{2}$/.test(e);
    }
    validateTimeValue(e) {
        return !!/^([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(e);
    }
}
customElements.define("sht-countdown", SHTCountDown);
class SHTHorizoltalCarousel extends SHTCustomComponent {
    constructor() {
        super(),
            (this.sectionID = this.dataset.sectionId),
            (this.carousels = this.$$(".js-carousel-item")),
            (this.container = this.$(".js-carousel-items")),
            (this.totalItems = this.carousels.length),
            (this.prevBtnElement = this.$(".js-carousel-prev-btn")),
            (this.nextBtnElement = this.$(".js-carousel-next-btn")),
            (this.currentElement = this.$(".js-carousel-counter-current")),
            (this.totalElement = this.$(".js-carousel-counter-total")),
            (this.paginationElement = this.$(".js-carousel-pagination")),
            (this.slideshow = SHTHelper.qs(`sht-prd-slideshow[data-section="${this.dataset.section}"]`)),
            (this.carousel = SHTHelper.qs(`sht-carousel[data-section-id="${this.dataset.section}"]`)),
            (this.carouselLayout = this.getAttribute("data-layout")),
            (this.window_width =
                window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth),
            this.transform(),
            this.bindEventHandlers(),
            window.addEventListener("resize", (e) => {
                var t = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                this.window_width != t && (this.transform(e), (this.window_width = t));
            });
    }
    bindEventHandlers() {
        this.closest(".product__quickview") ||
            this.$$(".js-slideshow-btn-thumb").forEach((e, t) => {
                0 === t && e.closest(".js-product-slideshow-thumb").classList.add("is-active-item"),
                    e.addEventListener("click", this.setActiveMedia.bind(this, e));
            });
    }
    setActiveMedia(e) {
        var t;
        this.slideshow &&
            ((t = this.slideshow.querySelector(`[data-media-id="${e.dataset.target}"]`)),
            (e = e.closest("sht-vert-carousel-itm")),
            t) &&
            e &&
            window.matchMedia("(max-width: 768px)").matches &&
            (this.slideshow.pauseAllVideo(),
            this.$$(".js-product-slideshow-thumb").forEach((e) => {
                e.classList.remove("is-active-item");
            }),
            e.classList.add("is-active-item"),
            (e = this.carousel?.querySelector(".js-carousel-items"))) &&
            t &&
            e.scrollTo({ left: t.offsetLeft, behavior: "smooth" });
    }
    transform(e) {
        setTimeout(() => {
            this.horizontalInit(), this.horizontalBindEventHandlers(), void 0 !== e && this.horizontalSetActiveMedia();
        }, 200);
    }
    horizontalInit() {
        (this.itemsToShow = Array.from(this.carousels).filter((e) => 0 < e.clientWidth)),
            this.itemsToShow.length < 2
                ? this.horizontalTogglePagination(!1)
                : ((this.gutter =
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-left")) +
                      parseFloat(window.getComputedStyle(this.itemsToShow[1], null).getPropertyValue("padding-right"))),
                  (this.itemOffset = this.itemsToShow[1].offsetLeft - this.itemsToShow[0].offsetLeft),
                  (this.itemsPerPage = Math.floor(
                      (this.container.clientWidth - this.itemsToShow[0].offsetLeft) / this.itemOffset
                  )),
                  (this.totalPages = this.itemsToShow.length - this.itemsPerPage + 1),
                  this.horizontalUpdateCarousel());
    }
    horizontalUpdateCarousel() {
        var e = this.currentPage;
        (this.currentPage = Math.round(this.container.scrollLeft / this.itemOffset) + 1),
            0 < this.currentPage &&
                0 < this.totalPages &&
                (this.totalElement && (this.totalElement.textContent = this.totalPages), this.currentElement) &&
                (this.currentElement.innerHTML =
                    this.currentPage +
                    `<span class="visually-hidden">${this.currentElement.dataset.accessibilityMessage}</span>`),
            this.currentPage != e &&
                this.dispatchEvent(
                    new CustomEvent("itemChanged", {
                        detail: {
                            currentPage: this.currentPage,
                            currentElement: this.itemsToShow[this.currentPage - 1],
                            container: this,
                        },
                    })
                ),
            this.horizontalIsItemVisible(this.itemsToShow[0]) && 0 === this.container.scrollLeft
                ? this.prevBtnElement.setAttribute("disabled", "disabled")
                : this.prevBtnElement.removeAttribute("disabled"),
            this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])
                ? this.nextBtnElement.setAttribute("disabled", "disabled")
                : this.nextBtnElement.removeAttribute("disabled"),
            1 < this.totalPages && this.horizontalTogglePagination(!0),
            this.totalPages <= 1 && this.horizontalTogglePagination(!1);
    }
    horizontalIsItemVisible(e, t = 0) {
        t = this.container.clientWidth + this.container.scrollLeft - t;
        return e.offsetLeft + e.clientWidth <= t && e.offsetLeft >= this.container.scrollLeft;
    }
    horizontalOnButtonClick(e) {
        e.preventDefault();
        let t = 0;
        (0 != this.container.scrollLeft &&
            !this.horizontalIsItemVisible(this.itemsToShow[this.itemsToShow.length - 1])) ||
            (t = this.gutter),
            (this.itemScrollPosition =
                "next" === e.currentTarget.name
                    ? this.container.scrollLeft - t + +this.itemOffset
                    : this.container.scrollLeft + t - +this.itemOffset),
            window.requestAnimationFrame(() =>
                this.container.scrollTo({ left: this.itemScrollPosition, behavior: "smooth" })
            );
    }
    horizontalBindEventHandlers() {
        this.prevBtnElement && this.prevBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.nextBtnElement &&
                this.nextBtnElement.addEventListener("click", this.horizontalOnButtonClick.bind(this)),
            this.container.addEventListener(
                "scroll",
                SHTHelper.debounce(this.horizontalUpdateCarousel.bind(this), 100)
            );
    }
    horizontalTogglePagination(e) {
        e
            ? (this.paginationElement?.classList.remove("d-none-important"),
              this.paginationElement?.classList.add("d-flex"))
            : (this.paginationElement?.classList.remove("d-flex"),
              this.paginationElement?.classList.add("d-none-important"));
    }
    horizontalSetActiveMedia() {
        var e = this.$("sht-vert-carousel-itm.is-active-item");
        e &&
            (this.container.scrollTo({ left: e.offsetLeft, behavior: "auto" }),
            (e = this.slideshow.$(`sht-carousel-itm[data-media-id="${e.dataset.mediaTargetId}"]`)),
            this.carousel.querySelector(".js-carousel-items").scrollTo({ left: e.offsetLeft, behavior: "auto" }));
    }
}
customElements.define("sht-horizoltal-carousel", SHTHorizoltalCarousel);
class SHTCartDiscount extends SHTCustomComponent {
    static ENTER_KEY = "Enter";
    static CART_UPDATE_DELAY = 500;
    static BIND_BUTTONS_DELAY = 600;
    static ENDPOINTS = { DISCOUNT: "/cart/update.js" };
    constructor() {
        super(), this.initializeProperties(), this.cacheElements(), this.initializeState();
    }
    initializeProperties() {
        (this.sectionId = this.dataset.sectionId),
            (this.isUpdating = !1),
            (this.eventListeners = new Map()),
            (this.debounceTimers = new Map());
    }
    cacheElements() {
        (this.elements = {
            formDiv: this.querySelector("[data-discount-form]"),
            input: null,
            errorContainer: this.querySelector("#cartDiscountError"),
            successContainer: this.querySelector("#cartDiscountSuccess"),
            errorShipping: null,
            errorDiscount: null,
            submitBtn: null,
            pillsContainer: this.querySelector(".js-discount-pills"),
        }),
            this.elements.formDiv &&
                ((this.elements.input = this.elements.formDiv.querySelector(".js-discount-input")),
                (this.elements.submitBtn = this.elements.formDiv.querySelector(".js-discount-submit"))),
            this.elements.errorContainer &&
                ((this.elements.errorShipping = this.elements.errorContainer.querySelector(".js-error-shipping")),
                (this.elements.errorDiscount = this.elements.errorContainer.querySelector(".js-error-discount")));
    }
    initializeState() {
        this.boundHandlers = {
            handleDiscountSubmit: this.handleDiscountSubmit.bind(this),
            handleKeydown: this.handleKeydown.bind(this),
            handleFormSubmit: this.handleFormSubmit.bind(this),
            handleCartUpdate: this.handleCartUpdate.bind(this),
            handleDOMReady: this.handleDOMReady.bind(this),
            handleRemoveClick: this.handleRemoveClick.bind(this),
        };
    }
    connectedCallback() {
        this.setupEventListeners(), this.bindRemoveButtons();
    }
    disconnectedCallback() {
        this.cleanup();
    }
    setupEventListeners() {
        this.setupFormEvents(), this.setupCartUpdateListener(), this.setupRemoveButtonsDelegation();
    }
    setupFormEvents() {
        var e;
        this.elements.formDiv &&
            !this.elements.formDiv.dataset.eventBound &&
            ((this.elements.formDiv.dataset.eventBound = "true"),
            this.elements.submitBtn &&
                this.addEventListener(this.elements.submitBtn, "click", this.boundHandlers.handleDiscountSubmit),
            this.elements.input &&
                this.addEventListener(this.elements.input, "keydown", this.boundHandlers.handleKeydown),
            (e = document.getElementById("cartForm"))) &&
            this.addEventListener(e, "submit", this.boundHandlers.handleFormSubmit);
    }
    setupCartUpdateListener() {
        this.addEventListener(document, "cart:update", this.boundHandlers.handleCartUpdate),
            "loading" === document.readyState
                ? this.addEventListener(document, "DOMContentLoaded", this.boundHandlers.handleDOMReady)
                : this.boundHandlers.handleDOMReady();
    }
    setupRemoveButtonsDelegation() {
        this.elements.pillsContainer &&
            !this.elements.pillsContainer.dataset.delegationBound &&
            ((this.elements.pillsContainer.dataset.delegationBound = "true"),
            this.addEventListener(this.elements.pillsContainer, "click", this.boundHandlers.handleRemoveClick));
    }
    addEventListener(e, t, s) {
        e.addEventListener(t, s);
        var i = e.tagName + "-" + t;
        this.eventListeners.has(i) || this.eventListeners.set(i, []),
            this.eventListeners.get(i).push({ element: e, event: t, handler: s });
    }
    removeEventListener(t, e, s) {
        t.removeEventListener(e, s);
        var i,
            e = t.tagName + "-" + e,
            e = this.eventListeners.get(e);
        e && -1 < (i = e.findIndex((e) => e.element === t && e.handler === s)) && e.splice(i, 1);
    }
    handleKeydown(e) {
        e.key === SHTCartDiscount.ENTER_KEY && (e.preventDefault(), this.handleDiscountSubmit(e));
    }
    handleFormSubmit(e) {
        var t = document.activeElement;
        if (this.isDiscountInputActive(t)) return e.preventDefault(), this.handleDiscountSubmit(e), !1;
    }
    handleCartUpdate(e) {
        "discount" === e.detail?.source && this.debounceBindRemoveButtons();
    }
    handleDOMReady() {
        this.debounce("dom-ready", () => this.bindRemoveButtons(), 100);
    }
    handleRemoveClick(e) {
        var t = e.target.closest(".js-remove-discount");
        t &&
            (e.preventDefault(), e.stopPropagation(), this.hideMessages(), (e = t.dataset.removeDiscount)) &&
            this.processDiscountRemoval(e);
    }
    debounce(e, t, s) {
        this.debounceTimers.has(e) && clearTimeout(this.debounceTimers.get(e));
        s = setTimeout(() => {
            t(), this.debounceTimers.delete(e);
        }, s);
        this.debounceTimers.set(e, s);
    }
    debounceBindRemoveButtons() {
        this.debounce("bind-buttons", () => this.bindRemoveButtons(), SHTCartDiscount.BIND_BUTTONS_DELAY);
    }
    isDiscountInputActive(e) {
        return "discount" === e?.name && e.closest("[data-discount-form]");
    }
    bindRemoveButtons() {
        var e = document.querySelectorAll(".js-remove-discount:not([data-event-bound-remove])");
        0 !== e.length &&
            e.forEach((e) => {
                this.addEventListener(e, "click", (e) => this.handleDiscountRemove(e)),
                    (e.dataset.eventBoundRemove = "true");
            });
    }
    async handleDiscountSubmit(e) {
        e.preventDefault(), e.stopPropagation();
        e = this.getDiscountCodeFromInput();
        e && (await this.processDiscountApplication(e));
    }
    async handleDiscountRemove(e) {
        e.preventDefault(), e.stopPropagation(), this.hideMessages();
        e = e.currentTarget.dataset.removeDiscount;
        e && (await this.processDiscountRemoval(e));
    }
    getDiscountCodeFromInput() {
        return this.elements.input?.value.trim() || "";
    }
    async processDiscountApplication(e) {
        this.setLoading(!0), this.hideMessages();
        try {
            var t,
                s,
                i,
                n = this.getExistingDiscountCodes(),
                r = await this.applyDiscount(e);
            r.ok
                ? ((s = await r.json()),
                  (i = this.validateDiscountResponse(s, n, e)).isValid
                      ? this.handleSuccessfulDiscount()
                      : (this.clearInput(), this.showError(i.errorType)))
                : ((t = await r.json()), this.showError(t.description || "discount_code"));
        } catch (e) {
            console.error("Error applying discount:", e), this.showError("general");
        } finally {
            this.setLoading(!1);
        }
    }
    async processDiscountRemoval(t) {
        this.setLoading(!0), this.hideMessages();
        try {
            var e = this.getExistingDiscountCodes().filter((e) => e !== t);
            (await this.sendDiscountUpdateRequest(e)).ok && this.updateCartDrawer();
        } catch (e) {
            console.error("Error removing discount:", e);
        } finally {
            this.setLoading(!1);
        }
    }
    validateDiscountResponse(e, t, s) {
        return this.isDiscountNotApplicable(e, s)
            ? { isValid: !1, errorType: "discount_code" }
            : this.isShippingOnlyDiscount(e, t, s)
              ? { isValid: !1, errorType: "shipping" }
              : { isValid: !0 };
    }
    isDiscountNotApplicable(e, t) {
        return e.discount_codes?.some((e) => e.code === t && !1 === e.applicable);
    }
    isShippingOnlyDiscount(e, t, s) {
        var i;
        return (
            !!e.sections?.[this.sectionId] &&
            ((i = this.extractDiscountCodesFromHTML(e.sections[this.sectionId])),
            this.isDiscountAlreadyAppliedButNotVisible(i, t, e.discount_codes, s))
        );
    }
    extractDiscountCodesFromHTML(e) {
        e = new DOMParser().parseFromString(e, "text/html").getElementById("shopify-section-" + this.sectionId);
        return e
            ? Array.from(e.querySelectorAll("[data-discount-code]"))
                  .map((e) => e.dataset.discountCode)
                  .filter(Boolean)
            : [];
    }
    isDiscountAlreadyAppliedButNotVisible(e, t, s, i) {
        (e = e.length === t.length && e.every((e) => t.includes(e))),
            (s = s?.some((e) => e.code === i && !0 === e.applicable));
        return e && s;
    }
    async applyDiscount(e) {
        e = [...this.getExistingDiscountCodes(), e];
        return this.sendDiscountUpdateRequest(e);
    }
    async sendDiscountUpdateRequest(e) {
        return fetch(SHTCartDiscount.ENDPOINTS.DISCOUNT, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: e.join(","), sections: this.sectionId }),
        });
    }
    getExistingDiscountCodes() {
        return Array.from(this.querySelectorAll("[data-discount-code]"))
            .map((e) => e.dataset.discountCode)
            .filter(Boolean);
    }
    handleSuccessfulDiscount() {
        this.clearInput(), this.showSuccess(), this.updateCartDrawer();
    }
    clearInput() {
        this.elements.input && (this.elements.input.value = "");
    }
    updateCartDrawer() {
        this.isUpdating ||
            ((this.isUpdating = !0),
            this.dispatchCartUpdateEvent(),
            this.debounce(
                "cart-update",
                () => {
                    this.bindRemoveButtons(), (this.isUpdating = !1);
                },
                SHTCartDiscount.CART_UPDATE_DELAY
            ));
    }
    dispatchCartUpdateEvent() {
        document.dispatchEvent(
            new CustomEvent("cart:update", { detail: { source: "discount", timestamp: Date.now() } })
        );
    }
    hideMessages() {
        this.hideError(), this.hideSuccess();
    }
    showSuccess() {
        this.elements.successContainer &&
            (this.hideError(), this.elements.successContainer.classList.remove("d-none-important"));
    }
    hideSuccess() {
        this.elements.successContainer?.classList.add("d-none-important");
    }
    showError(e) {
        this.elements.errorContainer &&
            (this.hideSuccess(),
            this.elements.errorContainer.classList.remove("d-none-important"),
            this.toggleErrorTypes(e));
    }
    toggleErrorTypes(e) {
        e = "shipping" === e;
        this.elements.errorShipping?.classList.toggle("d-none-important", !e),
            this.elements.errorDiscount?.classList.toggle("d-none-important", e);
    }
    hideError() {
        this.elements.errorContainer?.classList.add("d-none-important");
    }
    setLoading(e) {
        this.toggleAttribute("loading", e),
            this.elements.formDiv?.classList.toggle("loading", e),
            this.elements.submitBtn?.toggleAttribute("disabled", e);
    }
    cleanup() {
        this.debounceTimers.forEach((e) => clearTimeout(e)),
            this.debounceTimers.clear(),
            this.eventListeners.forEach((e) => {
                e.forEach(({ element: e, event: t, handler: s }) => {
                    e.removeEventListener(t, s);
                });
            }),
            this.eventListeners.clear();
    }
}
customElements.define("sht-cart-discount", SHTCartDiscount);
class SHTVariation extends SHTCustomComponent {
    constructor() {
        super(),
            (this.productVariations = this.$$(".js-variation-item")),
            (this.sectionId = this.dataset.sectionId),
            (this.isQuickView = this.classList.contains("js-variation-quick-view")),
            (this.cachedData = {}),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        this.addEventListener("click", this.handleClick.bind(this));
    }
    handleClick(e) {
        e = e.target.closest(".js-variation-item");
        e && this.handleVariationClick(e.dataset.variationUrl);
    }
    handleVariationClick(e) {
        this.isQuickView || window.history.replaceState(null, "", e), this.fetchData(e);
    }
    async fetchData(e) {
        try {
            if (this.cachedData[e]) this.updateDOM(this.cachedData[e], e);
            else {
                var t = e + "?section_id=" + this.sectionId,
                    s = await fetch(t);
                if (!s.ok) throw new Error(`Failed to fetch product: ${s.status} ` + s.statusText);
                var i = await s.text(),
                    n = document.createElement("div");
                (n.innerHTML = i), (this.cachedData[e] = n), await this.preloadImages(n), this.updateDOM(n, e);
            }
        } catch (e) {
            console.error("Error fetching product variation:", e);
        }
    }
    preloadImages(e) {
        var e = e.querySelectorAll('img[src]:not([loading="lazy"])');
        return 0 === e.length
            ? Promise.resolve()
            : ((e = Array.from(e).map(
                  (t) =>
                      new Promise((e) => {
                          t.complete ? e() : ((t.onload = () => e()), (t.onerror = () => e()));
                      })
              )),
              Promise.all(e));
    }
    updateDOM(e, t) {
        var s = this.isQuickView ? "dialogBodyQuickView" : this.sectionId,
            i = document.querySelector("#" + s);
        if (e && i) {
            var n = e.querySelector(".js-main-product");
            if (
                (n && n.removeAttribute("data-animate"),
                this.isQuickView
                    ? (n = e.querySelector(".js-quick-view-container")) &&
                      ((i.innerHTML = n.innerHTML),
                      (n =
                          document.querySelector("#dialogQuickShop .js-view-full-btn a") ||
                          document.querySelector(".js-quick-view-drawer .js-view-full-btn a"))) &&
                      t &&
                      (n.href = t)
                    : (i.parentElement.innerHTML = e.children[0].innerHTML),
                window.Shopify?.PaymentButton)
            ) {
                const r = document.querySelector("#" + s);
                requestAnimationFrame(() => {
                    Shopify.PaymentButton.init(),
                        setTimeout(() => {
                            r.querySelectorAll(".shopify-payment-button").forEach((e) => {
                                e.removeAttribute("data-observed"),
                                    SHTCustomComponent.enhancePaymentButtons(e),
                                    e.dataset.observed ||
                                        (new MutationObserver(() => {
                                            SHTCustomComponent.enhancePaymentButtons(e);
                                        }).observe(e, { childList: !0, subtree: !0 }),
                                        (e.dataset.observed = "true"));
                            });
                        }, 250);
                });
            }
        } else console.warn("Product elements not found in current or new product");
    }
}
customElements.define("sht-variation", SHTVariation);
class SHTMarqueeSection extends SHTCustomComponent {
    constructor() {
        super(),
            (this.marqueeWrapper = this.$(".js-marquee-container")),
            (this.marqueeList = this.$(".js-marquee-list")),
            (this.marqueeListAll = this.$$(".js-marquee-list")),
            (this.normalSpeed = parseFloat(this.getAttribute("normal-speed")) / 2 || 1),
            (this.stopSpeed = 0),
            (this.direction = this.getAttribute("direction")),
            (this.loop = parseInt(this.marqueeWrapper.getAttribute("loop-marquee"))),
            (this.speed = this.normalSpeed),
            (this.isRTL = SHTHelper.isRTL),
            this.init();
    }
    onResize() {
        (this.resizeObserver = new ResizeObserver((e) => {
            (this.marqueeListWidth = this.marqueeList.offsetWidth),
                (this.currentPosition = 0),
                (this.currentPositionReverse = this.isRTL ? this.marqueeListWidth : -this.marqueeListWidth),
                (this.minWidthValue = window.innerWidth / (this.loop - 1)),
                this.checkWidth(),
                (this.currentPositionReverse = this.isRTL ? this.newWidth : -this.newWidth);
        })),
            this.resizeObserver.observe(this);
    }
    init() {
        this.onResize(), this.startAnimation(), this.bindHoverEvents();
    }
    checkWidth() {
        this.loop * this.marqueeListWidth < window.innerWidth
            ? (this.marqueeListAll.forEach((e) => {
                  e.style.minWidth = this.minWidthValue + "px";
              }),
              (this.newWidth = this.minWidthValue))
            : (this.marqueeListAll.forEach((e) => {
                  e.style.minWidth = "";
              }),
              (this.newWidth = this.marqueeListWidth));
    }
    bindHoverEvents() {
        this.marqueeWrapper.addEventListener("mouseover", () => {
            this.speed = this.stopSpeed;
        }),
            this.marqueeWrapper.addEventListener("mouseout", () => {
                this.speed = this.normalSpeed;
            });
    }
    startAnimation() {
        this.animate();
    }
    animate() {
        "animation-reverse" == this.direction
            ? (this.isRTL
                  ? ((this.currentPositionReverse -= this.speed),
                    this.currentPositionReverse <= 0 && (this.currentPositionReverse = this.newWidth))
                  : ((this.currentPositionReverse += this.speed),
                    0 <= this.currentPositionReverse && (this.currentPositionReverse = -this.newWidth)),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPositionReverse}px)`))
            : (this.isRTL
                  ? ((this.currentPosition += this.speed),
                    this.currentPosition >= this.newWidth && (this.currentPosition = 0))
                  : ((this.currentPosition -= this.speed),
                    this.currentPosition <= -this.newWidth && (this.currentPosition = 0)),
              (this.marqueeWrapper.style.transform = `translateX(${this.currentPosition}px)`)),
            requestAnimationFrame(this.animate.bind(this));
    }
}
customElements.define("sht-marquee-section", SHTMarqueeSection);
class SHTInfinityScroll extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        (this.renderContainer = SHTHelper.qid("loadMoreContainer")),
            (this.loadingIndicator = this.querySelector(".js-loading-infinity-scroll")),
            this.bindEventHandlers();
    }
    bindEventHandlers() {
        (this.observer = this.registerObserver(this.loadNextPage.bind(this))), this.observer.observe(this);
    }
    registerObserver(t) {
        let s = !1;
        return new IntersectionObserver(function (e) {
            e[0].isIntersecting &&
                !s &&
                ((s = !0),
                t()
                    .then(() => (s = !1))
                    .catch(() => (s = !1)));
        });
    }
    loadNextPage() {
        var { nextUrl: e, totalPages: t } = this.dataset,
            s = parseInt(this.dataset.currentPage) + 1;
        return t < s
            ? (this.observer.disconnect(), Promise.resolve())
            : (this.loadingIndicator.classList.remove("hidden"),
              fetch(e.replace(/page=[0-9]+/, "page=" + s))
                  .then((e) => (this.loadingIndicator.classList.add("hidden"), e.text()))
                  .then((e) => {
                      var t = document.createElement("div"),
                          e = ((t.innerHTML = e), t.querySelector("#loadMoreContainer").innerHTML);
                      this.renderContainer.insertAdjacentHTML("beforeend", e);
                  })
                  .catch((e) => {
                      console.error(e);
                  })
                  .finally(() => {
                      this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
                  }));
    }
}
customElements.define("sht-infinity-scroll", SHTInfinityScroll);
class SHTNewsletterPopup extends SHTCustomComponent {
    constructor() {
        super(),
            (this.properties = JSON.parse(this.dataset.props || "{}")),
            (this.myStorage = window.localStorage),
            (this.sessionStorageName = Shopify.theme.name.toLowerCase() + "-newsletter-popup-display"),
            (this.cartNotificationSessionKey = Shopify.theme.name.toLowerCase() + "-cart-notification-popup-shown"),
            (this.bodyElement = SHTHelper.qs("body")),
            (this.cartNotification = SHTHelper.qs("sht-cart-noti")),
            (this.cartDrawer = SHTHelper.qs("sht-cart-drwr")),
            (this.cartShowType = this.bodyElement ? this.bodyElement.dataset.cartShowType : "show_popup_noti"),
            (this.isOpen = !1),
            (this.buffer = 100),
            (this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0),
            (this.myWindowHeight = window.innerHeight || SHTHelper.qde.clientHeight || 0),
            (this.contentLoaded = !1),
            (this.contentContainer = this.$("[data-deferred-content]")),
            (this.contentTemplate = this.$(".js-newsletter-content-template")),
            (this.elms = {
                close_btn: this.$(".js-popup-close-btn"),
                body: this.bodyElement,
                trigger_btn: SHTHelper.qs(".js-newsletter-popup-trigger"),
                overlay: this.$(".js-newsletter-popup-overlay"),
            }),
            (this.trigger = this.dataset.trigger || "reaching-to-footer"),
            (this.delayTime = this.dataset.delayTime || "session"),
            (this.delayDays = parseInt(this.dataset.delayDays || 30)),
            (this.delayUntil = parseInt(this.dataset.delayUntil || 0)),
            (this.showOnlyOnIndex = this.hasAttribute("data-show-only-on-index")),
            (this.showOnlyForVisitors = this.hasAttribute("data-show-only-for-visitors")),
            (this.stickyPopupEnabled = !!this.elms.trigger_btn),
            (this.stickyStorageKey = Shopify.theme.name.toLowerCase() + "-sticky-popup-dismissed"),
            (this.manuallyClosedInSession = !1),
            (this.boundScrollEventHandle = this.onScrollEventHandle.bind(this)),
            (this.boundOnLoadUserAction = this.onUserAction.bind(this)),
            (this.boundCloseBtnClickHandle = this.onCloseBtnClickHandle.bind(this)),
            (this.boundTriggerBtnClickHandle = this.onTriggerBtnClickHandle.bind(this)),
            (this.boundStickyCloseBtnClickHandle = this.onStickyCloseBtnClickHandle.bind(this)),
            this.init();
    }
    loadDeferredContent() {
        if (!this.contentLoaded && this.contentTemplate && this.contentContainer)
            try {
                var e = this.contentTemplate.content.cloneNode(!0);
                (this.contentContainer.innerHTML = ""), this.contentContainer.appendChild(e), (this.contentLoaded = !0);
            } catch (e) {
                console.error("Error loading deferred newsletter popup content:", e),
                    (this.contentContainer.innerHTML =
                        '<div class="newsletter-popup-error">Content could not be loaded</div>');
            }
    }
    initializeLoadedComponents() {
        this.contentContainer.querySelectorAll("[is], [data-ui-component]").forEach((e) => {
            e.tagName.toLowerCase().startsWith("sht-") && "function" == typeof e.init && e.init();
        });
    }
    init() {
        (this.showOnlyOnIndex && !window.location.pathname.match(/^\/$|^\/\?/)) ||
            (this.bindEventHandlers(),
            this.getPopupStatus()
                ? this.initStickyPopup()
                : (this.initTrigger(),
                  this.initStickyPopup(),
                  Shopify.designMode &&
                      this.dataset.sectionId &&
                      (this.editorHelper = new SHTPopupEditorHelper(this, this.dataset.sectionId))));
    }
    bindEventHandlers() {
        this.elms.close_btn && this.elms.close_btn.addEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.overlay && this.elms.overlay.addEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.trigger_btn &&
                (this.elms.trigger_btn.addEventListener("click", this.boundTriggerBtnClickHandle),
                (this.stickyCloseBtn = this.elms.trigger_btn.querySelector(".icon-close, svg")),
                this.stickyCloseBtn) &&
                this.stickyCloseBtn.addEventListener("click", this.boundStickyCloseBtnClickHandle),
            (this.userEventTypes = ["mouseenter", "touchstart", "mouseover"]),
            this.userEventTypes.forEach((e) => {
                this.bodyElement.addEventListener(e, this.boundOnLoadUserAction);
            }),
            this.popupAttrObserve();
    }
    disconnectedCallback() {
        this.elms.close_btn && this.elms.close_btn.removeEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.overlay && this.elms.overlay.removeEventListener("click", this.boundCloseBtnClickHandle),
            this.elms.trigger_btn &&
                (this.elms.trigger_btn.removeEventListener("click", this.boundTriggerBtnClickHandle),
                this.stickyCloseBtn) &&
                this.stickyCloseBtn.removeEventListener("click", this.boundStickyCloseBtnClickHandle),
            this.userEventTypes &&
                this.bodyElement &&
                this.userEventTypes.forEach((e) => {
                    this.bodyElement.removeEventListener(e, this.boundOnLoadUserAction);
                }),
            "reaching-to-footer" === this.trigger && window.removeEventListener("scroll", this.boundScrollEventHandle),
            this.cartNotification &&
                this.cartNotificationHandler &&
                this.cartNotification.removeEventListener("closed", this.cartNotificationHandler),
            this.cartDrawer &&
                this.cartDrawerHandler &&
                this.cartDrawer.removeEventListener("closed", this.cartDrawerHandler),
            this.delayTimeoutId && clearTimeout(this.delayTimeoutId),
            this.popupAttrObserver && (this.popupAttrObserver.disconnect(), (this.popupAttrObserver = null)),
            super.disconnectedCallback && super.disconnectedCallback();
    }
    initTrigger() {
        switch (this.trigger) {
            case "reaching-to-footer":
                window.addEventListener("scroll", this.boundScrollEventHandle);
                break;
            case "after-closing-cart-notification":
                "show_popup_noti" === this.cartShowType && this.cartNotification
                    ? ((this.cartNotificationHandler = (e) => {
                          try {
                              "true" === sessionStorage.getItem(this.cartNotificationSessionKey) ||
                                  (this.togglePopup(!0),
                                  sessionStorage.setItem(this.cartNotificationSessionKey, "true"));
                          } catch (e) {
                              console.warn("Error handling cart notification:", e);
                          }
                      }),
                      this.cartNotification.addEventListener("closed", this.cartNotificationHandler))
                    : "show_drawer" === this.cartShowType &&
                      this.cartDrawer &&
                      ((this.cartDrawerHandler = (e) => {
                          try {
                              "true" === sessionStorage.getItem(this.cartNotificationSessionKey) ||
                                  (this.togglePopup(!0),
                                  sessionStorage.setItem(this.cartNotificationSessionKey, "true"));
                          } catch (e) {
                              console.warn("Error handling cart drawer:", e);
                          }
                      }),
                      this.cartDrawer.addEventListener("closed", this.cartDrawerHandler));
                break;
            case "delay-after-page-load":
                this.delayTimeoutId = setTimeout(() => {
                    try {
                        this.getPopupStatus() || this.togglePopup(!0);
                    } catch (e) {
                        console.warn("Error in delay trigger:", e);
                    }
                }, 1e3 * this.delayUntil);
        }
    }
    initStickyPopup() {
        this.stickyPopupEnabled &&
            (this.toggleStickyPopup(!1),
            this.getStickyPopupDismissedStatus() || (this.getPopupStatus() && this.toggleStickyPopup(!0)));
    }
    onUserAction(e) {
        this.classList.contains("d-none") && this.classList.remove("d-none"),
            e.currentTarget.removeEventListener(e.type, this.onLoadUserAction);
    }
    onScrollEventHandle(e) {
        var t, s;
        "reaching-to-footer" !== this.trigger
            ? window.removeEventListener("scroll", this.boundScrollEventHandle)
            : ((this.myScrollHeight = document.body.scrollHeight || SHTHelper.qde.scrollHeight || 0),
              (t =
                  (window.pageYOffset || SHTHelper.qde.scrollTop || document.body.scrollTop || 0) +
                      this.buffer +
                      this.myWindowHeight >=
                  this.myScrollHeight),
              (s = this.getPopupStatus()),
              !t ||
                  (null !== this.getAttribute("open") && "" !== this.getAttribute("open")) ||
                  s ||
                  this.manuallyClosedInSession ||
                  this.togglePopup(!0));
    }
    onTriggerBtnClickHandle(e) {
        e.preventDefault(), this.togglePopup(!0);
    }
    onStickyCloseBtnClickHandle(e) {
        e.preventDefault(),
            e.stopPropagation(),
            this.toggleStickyPopup(!1),
            "after-closing-cart-notification" === this.trigger
                ? (sessionStorage.setItem(this.cartNotificationSessionKey, "true"),
                  sessionStorage.setItem(this.stickyStorageKey, "true"))
                : "days" === this.delayTime
                  ? ((e = new Date().getTime() + 24 * this.delayDays * 60 * 60 * 1e3),
                    this.myStorage.setItem(this.sessionStorageName, e.toString()),
                    this.myStorage.setItem(this.stickyStorageKey, e.toString()))
                  : (this.setStickyPopupDismissedStatus(!0), this.setPopupStatus());
    }
    onCloseBtnClickHandle(e) {
        e.preventDefault(),
            (this.manuallyClosedInSession = !0),
            "after-closing-cart-notification" === this.trigger &&
                sessionStorage.setItem(this.cartNotificationSessionKey, "true"),
            this.togglePopup(!1);
    }
    togglePopup(e) {
        var t = this.$(".js-success");
        e && !t
            ? (this.stickyPopupEnabled && this.toggleStickyPopup(!1), this.toggleOpen(!0))
            : (this.toggleOpen(!1),
              this.setPopupStatus(),
              this.stickyPopupEnabled &&
                  !this.getStickyPopupDismissedStatus() &&
                  setTimeout(() => {
                      this.toggleStickyPopup(!0);
                  }, 500));
    }
    toggleOpen(e) {
        e
            ? (this.loadDeferredContent(),
              this.elms.overlay &&
                  (this.elms.overlay.classList.add("animate-in"), this.elms.overlay.classList.remove("animate-out")),
              this.elms.body.classList.add("is-newsletter-popup-show"),
              this.setAttribute("open", !0),
              this.classList.remove("is-closing"))
            : (this.classList.add("is-closing"),
              this.elms.overlay &&
                  (this.elms.overlay.classList.add("animate-out"), this.elms.overlay.classList.remove("animate-in")),
              setTimeout(() => {
                  this.classList.remove("is-closing"),
                      this.removeAttribute("open"),
                      this.elms.body.classList.remove("is-newsletter-popup-show"),
                      SHTHelper.removeTrapFocus();
              }, 350));
    }
    setCookie(t, e) {
        try {
            document.cookie = t + `=${e}; path=/;`;
        } catch (e) {
            console.warn(`Failed to set cookie ${t}:`, e);
        }
    }
    getCookie(t) {
        try {
            var e = document.cookie.match(new RegExp("(^| )" + t + "=([^;]+)"));
            return e ? e[2] : null;
        } catch (e) {
            return console.warn(`Failed to get cookie ${t}:`, e), null;
        }
    }
    removeCookie(t) {
        try {
            document.cookie = t + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
        } catch (e) {
            console.warn(`Failed to remove cookie ${t}:`, e);
        }
    }
    setStorageValue(t, e, s = null) {
        try {
            var i = s || this.delayTime,
                n = new Date();
            switch (i) {
                case "session":
                    sessionStorage.setItem(t, String(e));
                    break;
                case "cookies":
                    this.setCookie(t, String(e));
                    break;
                case "days":
                    var r = n.getTime() + 24 * this.delayDays * 60 * 60 * 1e3;
                    this.myStorage.setItem(t, String(r));
                    break;
                default:
                    sessionStorage.setItem(t, String(e));
            }
        } catch (e) {
            console.warn(`Failed to set storage for ${t}:`, e);
        }
    }
    removeStorageValue(t, e = null) {
        try {
            switch (e || this.delayTime) {
                case "session":
                    sessionStorage.removeItem(t);
                    break;
                case "cookies":
                    this.removeCookie(t);
                    break;
                default:
                    this.myStorage.removeItem(t);
            }
        } catch (e) {
            console.warn(`Failed to remove storage for ${t}:`, e);
        }
    }
    getStorageValue(t, e = null) {
        if (Shopify.designMode) return null;
        try {
            switch (e || this.delayTime) {
                case "session":
                    return sessionStorage.getItem(t);
                case "cookies":
                    return this.getCookie(t);
                case "days":
                    var s,
                        i = this.myStorage.getItem(t);
                    return i
                        ? ((s = new Date().getTime()), parseInt(i) <= s ? (this.myStorage.removeItem(t), null) : i)
                        : null;
                default:
                    return sessionStorage.getItem(t);
            }
        } catch (e) {
            return console.warn(`Failed to get storage for ${t}:`, e), null;
        }
    }
    setPopupStatus() {
        this.setStorageValue(this.sessionStorageName, "true");
    }
    getPopupStatus() {
        var e;
        return (
            !Shopify.designMode &&
            ((e = this.getStorageValue(this.sessionStorageName)), "days" === this.delayTime ? null !== e : "true" === e)
        );
    }
    setStickyPopupDismissedStatus(e) {
        e ? this.setStorageValue(this.stickyStorageKey, "true") : this.removeStorageValue(this.stickyStorageKey);
    }
    getStickyPopupDismissedStatus() {
        var e;
        return (
            !Shopify.designMode &&
            ((e = this.getStorageValue(this.stickyStorageKey)), "days" === this.delayTime ? null !== e : "true" === e)
        );
    }
    toggleStickyPopup(e) {
        this.elms.trigger_btn &&
            (e
                ? this.elms.trigger_btn.classList.add("is-visible")
                : this.elms.trigger_btn.classList.remove("is-visible"));
    }
    popupAttrObserve() {
        try {
            (this.popupAttrObserver = new MutationObserver((e, t) => {
                e.forEach(async (e) => {
                    try {
                        var t;
                        "open" === e.attributeName &&
                            (this.hasAttribute("open")
                                ? (await this.animationsComplete(),
                                  this.dispatchEvent(new Event("opened")),
                                  SHTHelper.trapFocus(this),
                                  (t = this.querySelector('input[type="email"]')) && t.focus())
                                : this.dispatchEvent(new Event("closed")));
                    } catch (e) {
                        console.warn("Error handling popup attribute change:", e);
                    }
                });
            })),
                this.popupAttrObserver.observe(this, { attributes: !0 });
        } catch (e) {
            console.error("Failed to initialize popup attribute observer:", e);
        }
    }
    animationsComplete() {
        try {
            return Promise.allSettled(this.getAnimations().map((e) => e.finished));
        } catch (e) {
            return console.warn("Error waiting for animations to complete:", e), Promise.resolve();
        }
    }
}
customElements.define("sht-newsletter-popup", SHTNewsletterPopup);
class SHTImageATF extends HTMLElement {
    constructor() {
        super(),
            (this.imageElement = null),
            (this.pictureElement = null),
            (this.loadAttempted = !1),
            (this.intersectionObserver = null),
            (this.mutationObserver = null);
    }
    connectedCallback() {
        this.findImage() ? this.init() : this.waitForImage(), this.setupIntersectionObserver();
    }
    findImage() {
        return (
            (this.pictureElement = this.querySelector("picture")),
            (this.imageElement = this.pictureElement?.querySelector("img") || this.querySelector("img")),
            this.imageElement
        );
    }
    waitForImage() {
        this.mutationObserver?.disconnect(),
            (this.mutationObserver = new MutationObserver(() => {
                this.findImage() && (this.mutationObserver.disconnect(), (this.mutationObserver = null), this.init());
            })),
            this.mutationObserver.observe(this, { childList: !0, subtree: !0 });
    }
    init() {
        this.imageElement &&
            (this.imageElement.src && this.imageElement.complete && 0 !== this.imageElement.naturalHeight
                ? ((this.loadAttempted = !0), this.handleImageLoad())
                : this.imageElement.complete && 0 !== this.imageElement.naturalHeight
                  ? this.handleImageLoad()
                  : (this.imageElement.addEventListener("load", () => this.handleImageLoad(), { once: !0 }),
                    this.imageElement.addEventListener(
                        "error",
                        () => {
                            this.classList.add("image-loader--error"),
                                console.warn("Image failed to load:", this.imageElement?.src || "unknown source"),
                                this.cleanup();
                        },
                        { once: !0 }
                    )));
    }
    setupIntersectionObserver() {
        this.intersectionObserver?.disconnect(),
            (this.intersectionObserver = new IntersectionObserver(
                (e) => {
                    e[0].isIntersecting && !this.loadAttempted && ((this.loadAttempted = !0), this.loadImage());
                },
                { rootMargin: "50px 0px", threshold: 0.01 }
            )),
            this.intersectionObserver.observe(this);
    }
    loadImage() {
        var e;
        this.imageElement &&
            (this.imageElement.removeAttribute("loading"),
            this.pictureElement?.querySelectorAll("source[data-srcset]").forEach((e) => {
                (e.srcset = e.getAttribute("data-srcset")), e.removeAttribute("data-srcset");
            }),
            (e = this.imageElement.getAttribute("data-src")) &&
                !this.imageElement.src &&
                ((this.imageElement.src = e), this.imageElement.removeAttribute("data-src")),
            (e = this.imageElement.getAttribute("data-srcset"))) &&
            !this.imageElement.srcset &&
            ((this.imageElement.srcset = e), this.imageElement.removeAttribute("data-srcset"));
    }
    handleImageLoad() {
        this.classList.add("image-loader--loaded"), this.cleanup();
    }
    cleanup() {
        this.intersectionObserver?.disconnect(),
            this.mutationObserver?.disconnect(),
            (this.intersectionObserver = this.mutationObserver = null);
    }
    disconnectedCallback() {
        this.cleanup(), (this.loadAttempted = !1);
    }
}
if (
    (customElements.define("sht-image-atf", SHTImageATF),
    "loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", () => SHTCustomComponent.initGlobalFeatures())
        : SHTCustomComponent.initGlobalFeatures(),
    !customElements.get("sht-predictive-srch"))
) {
    class Kj extends SHTCustomComponent {
        constructor() {
            super(),
                (this.cachedRequests = new Map()),
                (this.resultsPanelMaxHeight = 0),
                (this.elms = {
                    predictive_search_form: this.$(".js-predictive-search-form"),
                    predictive_search_input: this.$(".js-predictive-search-input"),
                    predictive_search_results: this.$(".js-predictive-search-results"),
                    predictive_search_result_panel: this.$(".js-predictive-search-results-panel"),
                    predictive_search_message_placeholder: this.$(".js-predictive-search-message-placeholder"),
                    predictive_search_loading: this.$(".js-predictive-search-loading"),
                    predictive_close_button: this.$(".js-predictive-search-close-trigger"),
                    predictive_overlay: this.$(".js-predictive-search-results-panel-overlay"),
                    header: this.closest("sht-header"),
                    header_search_open_trigger: this.closest("sht-header")?.querySelector(".js-search-open-trigger"),
                    body: document.body,
                    enable_predictive: "true" === this.dataset.enablePredictive,
                }),
                (this.url = {
                    searchUrl: routes.predictive_search_url,
                    queryParameters: {
                        section_id: "sht-predictive-srch",
                        resources: { limit: 10, options: { unavailable_products: "last", fields: "" } },
                    },
                }),
                (this.shopifyFeaturesJson = JSON.parse(
                    SHTHelper.qs('#shopify-features[type="application/json"]').textContent
                )),
                (this.code = ""),
                this.elms.enable_predictive && this.bindEventHandlers();
        }
        bindEventHandlers() {
            this.elms.predictive_search_form.addEventListener("submit", this.onSubmitHandle.bind(this)),
                this.elms.predictive_search_input.addEventListener(
                    "input",
                    SHTHelper.debounce((e) => {
                        this.onInputHandle(e);
                    }, 300).bind(this)
                ),
                this.elms.predictive_search_input.addEventListener("focus", this.onInputFocusHandle.bind(this)),
                this.elms.predictive_close_button.addEventListener("click", this.closeSearchResults.bind(this)),
                this.elms.predictive_overlay &&
                    this.elms.predictive_overlay.addEventListener("click", this.closeSearchResults.bind(this)),
                this.addEventListener("keyup", (e) => {
                    (this.code = e.code.toUpperCase()), "ESCAPE" === e.code.toUpperCase() && this.closeSearchResults();
                }),
                Shopify.designMode &&
                    this.dataset.sectionId &&
                    (this.editorHelper = new SHTPredictiveSearchEditorHelper(this, this.dataset.sectionId));
        }
        onSubmitHandle(e) {
            this.getSearchTerm() || e.preventDefault();
        }
        onInputFocusHandle(e) {
            var t = this.getSearchTerm();
            this.openSearchResults(t);
        }
        getSearchTerm() {
            return this.elms.predictive_search_input.value.trim();
        }
        openSearchResults(e) {
            e.length
                ? this.togglePlaceHolderMessage(!1)
                : (this.resetSearchResultPanel(),
                  this.togglePlaceHolderMessage(!0),
                  this.toggleLoading(!1),
                  this.toggleLoadingContainer(!1),
                  this.toggleResults(!1)),
                this.toggleOpen(!0),
                this.toggleSearchResults(!0),
                this.elms.predictive_search_input.setAttribute("aria-expanded", !0);
        }
        resetSearchResultPanel() {
            this.elms.predictive_search_result_panel.innerHTML = "";
        }
        toggleResults(e) {
            e
                ? (this.setAttribute("results", !0),
                  setTimeout(
                      function () {
                          this.classList.add("is-result-show");
                      }.bind(this),
                      300
                  ))
                : (this.removeAttribute("results"), this.classList.remove("is-result-show"));
        }
        toggleOpen(e) {
            e
                ? (this.setAttribute("open", !0),
                  document.body.classList.add("header--predictive-search-open"),
                  this.elms.body.classList.add("o-hidden"),
                  this.elms.body.classList.add("no-scroll")
                )
                : (this.removeAttribute("open"),
                  document.body.classList.remove("header--predictive-search-open"),
                  this.elms.body.classList.remove("o-hidden"),
                  this.elms.body.classList.remove("no-scroll")
                );
        }
        async onInputHandle(e) {
            var t;
            this.shopifyFeaturesJson.predictiveSearch &&
                "ESCAPE" !== this.code &&
                ((t = this.getSearchTerm()), this.openSearchResults(t), this.resetSearchResultPanel(), t.length) &&
                ((t = await this.getSearchResults(t)), this.renderSearchResultPanel(t));
        }
        renderSearchResultPanel(e) {
            (this.elms.predictive_search_result_panel.innerHTML = e),
                this.toggleResults(!0),
                this.toggleLoading(!1),
                this.toggleLoadingContainer(!1),
                Shopify.designMode || SHTHelper.trapFocus(this);
        }
        async getSearchResults(e) {
            var t = e.replace(/\s/g, "-").toLowerCase(),
                s = this.cachedRequests.get(t);
            return s || ((s = await this.fetchResults(e)), this.cachedRequests.set(t, s), s);
        }
        onSubmitHandle(e) {
            this.getSearchTerm() || e.preventDefault();
        }
        async fetchResults(e) {
            (e = `${this.url.searchUrl}?q=${encodeURIComponent(e)}&resources[limit_scope]=each&section_id=predictive-search`),
                this.toggleLoading(!0),
                this.toggleLoadingContainer(!0),
                (e = await fetch(e)
                    .then((e) => {
                        if (e.ok) return e.text();
                        throw new Error(e.status);
                    })
                    .then((e) => {
                        return (
                            this.toggleLoading(!1),
                            this.toggleLoadingContainer(!1),
                            new DOMParser()
                                .parseFromString(e, "text/html")
                                .querySelector("#shopify-section-predictive-search").innerHTML
                        );
                    })
                    .catch((e) => (console.error(e), "")));
            return e;
        }
        toggleSearchResults(e) {
            (e = this.shopifyFeaturesJson.predictiveSearch ? e : !1)
                ? this.elms.predictive_search_results.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_results.setAttribute("hidden", !0);
        }
        toggleLoading(e) {
            e
                ? this.elms.predictive_search_loading.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_loading.setAttribute("hidden", !0);
        }
        togglePlaceHolderMessage(e) {
            e
                ? this.elms.predictive_search_message_placeholder.toggleAttribute("hidden", !1)
                : this.elms.predictive_search_message_placeholder.setAttribute("hidden", !0);
        }
        toggleLoadingContainer(e) {
            e ? this.setAttribute("loading", !0) : this.removeAttribute("loading");
        }
        closeSearchResults(e = !1) {
            this.toggleOpen(!1),
                this.toggleLoading(!1),
                this.toggleLoadingContainer(!1),
                this.togglePlaceHolderMessage(!1),
                this.toggleResults(!1),
                this.resetSearchResultPanel(),
                this.toggleSearchResults(!1),
                document.body.classList.remove("header--predictive-search-open", "o-hidden", "no-scroll"),
                this.classList.remove("is-active"),
                this.elms.header_search_open_trigger &&
                    !e &&
                    SHTHelper.removeTrapFocus(this.elms.header_search_open_trigger),
                (this.resultsPanelMaxHeight = 0),
                this.elms.predictive_search_result_panel.removeAttribute("style"),
                (this.elms.predictive_search_input.value = ""),
                this.elms.predictive_search_input.setAttribute("aria-expanded", !1);
        }
        calculateResultsPanelMaxHeight() {
            return (
                (this.resultsPanelMaxHeight =
                    window.innerHeight - SHTHelper.qid("shopify-section-header").getBoundingClientRect().bottom),
                this.resultsPanelMaxHeight
            );
        }
    }
    customElements.define("sht-predictive-srch", Kj);
}
class SHTMainSearch extends HTMLElement {
    constructor() {
        super(),
            (this.hasProduct = null !== this.querySelector(".js-main-search-result-product")),
            this.hasProduct || this.querySelector(".filter--vertical").classList.add("d-none-important");
    }
}
customElements.define("sht-srch", SHTMainSearch);

class CartGiftNote extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.checkbox = this.querySelector('#giftCheckbox11');
    this.textarea = this.querySelector('.note-field-cart-slider');

    if (!this.checkbox || !this.textarea) return;

    this.bindEvents();
    this.restoreState();
  }

  // Cookie helpers
  setCookie(name, value) {
    document.cookie = name + "=" + encodeURIComponent(value) + "; path=/";
  }

  getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
    return null;
  }

  restoreState() {
    const savedChecked = this.getCookie("cartDrawerGiftChecked");
    const savedNote = this.getCookie("cartDrawerGiftNote");

    // ✅ ALWAYS clean initial value (important)
    this.textarea.value = this.textarea.value.trim();

    if (savedChecked === "true") {
        this.checkbox.checked = true;
        this.textarea.classList.add('is-visible');
        document.body.classList.add('cart-swift-gift');
    } else {
        this.textarea.classList.remove('is-visible');
    }

    if (savedNote) {
        this.textarea.value = savedNote.trim();
    }
    }

  bindEvents() {
    this.checkbox.removeEventListener("change", this.onChange);
    this.textarea.removeEventListener("input", this.onInput);

    this.onChange = this.handleChange.bind(this);
    this.onInput = this.handleInput.bind(this);

    this.checkbox.addEventListener("change", this.onChange);
    this.textarea.addEventListener("input", this.onInput);
  }

  handleChange() {
    this.textarea.classList.toggle('is-visible', this.checkbox.checked);

    this.setCookie("cartDrawerGiftChecked", this.checkbox.checked);
    this.updateCartNote();
  }

  handleInput() {
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.setCookie("cartDrawerGiftNote", this.textarea.value);
      this.updateCartNote();
    }, 1000);
  }

  updateCartNote() {
    const cartNote = this.textarea.value.trim();
    const isGift = this.checkbox.checked;

    const formData = new FormData();

    if (isGift) {
      if (cartNote !== "") {
        formData.append('note', "Gift Message: " + cartNote);
      } else {
        formData.append('note', "");
      }
      document.body.classList.add('cart-swift-gift');
    } else {
      formData.append('note', "");
      document.body.classList.remove('cart-swift-gift');
    }

    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(() => {
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch(err => console.error(err));
  }
}

customElements.define('cart-gift-note', CartGiftNote);
window.addEventListener("load", () => {
  let btn = document.querySelector('.js-product-form-submit-btn[data-original-text]');
  if (!btn) return;

  let text = btn.getAttribute("data-original-text");
  if (!text) return;

  btn.setAttribute("data-original-text", text.trim());
});
//Custom Cart Drawer Open Event Start//
(function () {
  let isFetching = false;

  document.addEventListener('cart:refreshDrawer', () => {
    if (isFetching) return;

    isFetching = true;

    fetch('?sections=cart-drawer', { cache: 'no-store' })
      .then(res => {
        if (!res.ok) throw new Error('Fetch failed');
        return res.json();
      })
      .then(data => {
        const section = data['cart-drawer'];
        if (!section) return;

        const temp = document.createElement('div');
        temp.innerHTML = section;

        const newDrawer = temp.querySelector('sht-cart-drwr');
        const currentDrawer = document.querySelector('#shtCartDrawer');

        if (!newDrawer || !currentDrawer) return;

        currentDrawer.innerHTML = newDrawer.innerHTML;

        document.dispatchEvent(new CustomEvent('cart:openDrawer'));

        const count = temp
          .querySelector('.drawer__heading .item_count')
          ?.textContent?.trim();

        if (count) {
          const headerCount = document.querySelector('.header__cart-count');
          const numberEl = headerCount?.querySelector('.cart-count-number');

          if (numberEl) numberEl.textContent = count;

          if (headerCount) {
            headerCount.className = headerCount.className
              .replace(/header-cart-count-\d+/, `header-cart-count-${count}`);
          }
        }
      })
      .finally(() => {
        isFetching = false;
      });
  });

  document.addEventListener('cart:openDrawer', () => {
    const drawer = document.querySelector('#shtCartDrawer');
    if (!drawer) return;

    drawer.setAttribute('open', '');
    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');

    if (typeof drawer.openDrawer === 'function') {
      drawer.openDrawer(document.activeElement);
      document.body.classList.add('o-hidden');
    }

    const overlay = drawer.querySelector('.js-drawer-overlay');
    if (overlay) {
      overlay.onclick = () => {
        document.dispatchEvent(new CustomEvent('cart:closeDrawer'));
      };
    }
  });

  document.addEventListener('cart:closeDrawer', () => {
    const drawer = document.querySelector('#shtCartDrawer');
    if (!drawer) return;

    drawer.removeAttribute('open');
    drawer.classList.remove('active');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('o-hidden');
  });
})();
//Custom Cart Drawer Open Event End//
